webpackJsonp([4],[
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["capitalize"] = capitalize;
/* harmony export (immutable) */ __webpack_exports__["indefiniteArticle"] = indefiniteArticle;
/* harmony export (immutable) */ __webpack_exports__["template"] = template;
/* harmony export (immutable) */ __webpack_exports__["randomFilter"] = randomFilter;
// From my tests the original capitalizes the first two words;
// changed to capitalize all words.
function capitalize(input) {
  return input.replace(/(^|\s)\w/g, function (match) {
    return match.toUpperCase();
  });
}

// noop: articles are handled by the template function
function indefiniteArticle(s) {
  return s;
}

function template(source, context, filters) {
  return source.replace(/\{([^}]+)\}/g, function (match, values) {
    var calls = values.split(/\s*\|\s*/g);
    var firstKey = calls.shift();

    // Check if a function was called
    // Example: {random | 1 | 100}
    if (typeof filters[firstKey] === 'function') {
      return filters[firstKey](calls);
    }

    // Split keys by dot and find key in context
    var parts = firstKey.split('.');
    var currentValue = context;
    var part = void 0;
    while (parts.length > 0 && currentValue) {
      part = parts.shift();
      currentValue = currentValue[part];
    }

    // If the result is an array then pick one random value from it
    if (Array.isArray(currentValue)) {
      currentValue = filters.pickone(currentValue);
    }

    // Remove the article if not needed
    var articleFilterIndex = calls.indexOf('indefiniteArticle');
    if (context.keysWithArticles.includes(part) && articleFilterIndex === -1) {
      currentValue = currentValue.replace(/^\S+\s+/, '');
    } else if (articleFilterIndex !== -1) {
      calls.splice(articleFilterIndex, 1);
    }

    // Apply the filters
    // Example: capitalize
    var fn = calls.shift();
    while (fn && typeof filters[fn] === 'function') {
      currentValue = filters[fn](currentValue);
      fn = calls.shift();
    }

    // Return the final value
    return currentValue;
  });
}

function randomFilter(random) {
  return function (values) {
    return random.integer({
      min: Number(values[0]),
      max: Number(values[1])
    });
  };
}

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports) {

module.exports = {
	"en": "English",
	"pt": "Português"
};

/***/ }),
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MainView__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_MainView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_MainView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_chance__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_chance___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_chance__);





var chance = new __WEBPACK_IMPORTED_MODULE_3_chance___default.a();

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

function toRandomChart(to) {
  var language = to.params.language;
  if (language) {
    return '/' + language + '/' + chance.word({ syllables: 3 });
  }
  return '/' + chance.word({ syllables: 3 });
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [
  // Other routes may be added (like an about page)
  {
    name: 'Root',
    path: '/',
    redirect: '/random'
  }, {
    name: 'Random',
    path: '/random',
    redirect: toRandomChart
  }, {
    name: 'Chart',
    path: '/:seed',
    component: __WEBPACK_IMPORTED_MODULE_2__components_MainView___default.a
  }, {
    name: 'TranslatedRandom',
    path: '/:language/random/',
    redirect: toRandomChart
  }, {
    name: 'TranslatedChart',
    path: '/:language/:seed/',
    component: __WEBPACK_IMPORTED_MODULE_2__components_MainView___default.a
  }]
}));

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(62)
  __webpack_require__(63)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(71),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b21230e0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getLanguageData;
function getLanguageData(language) {
  return __webpack_require__(76)("./" + language.replace(/\W/g, '').toLowerCase() + '.yaml');
}

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(16);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = generateChart;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createSentence__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createTrope__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createSetting__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createMeta__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createMeta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__createMeta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTitle__ = __webpack_require__(24);






function generateChart(random, names) {
  var chart = {
    id: random.hash({ length: 15 }),
    random: random
  };
  var state = {
    structureTaken: 'x',
    protagonist: {},
    secondaryCharacter: {},
    tertiaryCharacter: {},
    setting: {},
    title: {},
    meta: {},
    random: random,
    names: names
  };

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__createTrope__["a" /* default */])(state, 'protagonist');
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__createTrope__["a" /* default */])(state, 'secondaryCharacter');
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__createTrope__["a" /* default */])(state, 'tertiaryCharacter');
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__createSetting__["a" /* default */])(state);
  __WEBPACK_IMPORTED_MODULE_3__createMeta___default()(state);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__createTitle__["a" /* default */])(state);

  chart.title = state.title.full;
  chart.titleBasic = state.title.primary;
  chart.subtitle = state.title.subtitle;
  chart.studio = state.meta.studio;
  chart.genre = state.meta.genre;

  // Chance of 1-3 second sentences
  var description = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__createSentence__["a" /* default */])(state, 'first') + '. ';
  var count = random.integer({ min: 1, max: 3 });
  for (var j = 0; j < count; j++) {
    description += __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__createSentence__["a" /* default */])(state, 'mid') + '. ';
  }
  description += ' ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__createSentence__["a" /* default */])(state, 'last');

  chart.description = description;
  chart.episodes = random.integer(random.weighted([{ min: 1, max: 5 }, { min: 10, max: 14 }, { min: 22, max: 26 }, { min: 50, max: 60 }, { min: 100, max: 200 }], [10, 30, 20, 5, 1]));
  chart.score = state.meta.malScore;

  return chart;
}

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var _require = __webpack_require__(0),
    capitalize = _require.capitalize;

module.exports = function createMeta(state) {
  var random = state.random,
      setting = state.setting,
      meta = state.meta,
      names = state.names;
  var genres = names.genres,
      studio = names.studio,
      source = names.source;

  var genresCopy = genres.slice();

  var genre = random.pickone(genresCopy);
  setting.genre = genre;
  meta.genre = capitalize(genre);
  setting.genreMain = genre;
  genresCopy.splice(genresCopy.indexOf(genre), 1);

  var genreCount = random.integer({ min: 1, max: 5 });
  for (var y = 0; y < genreCount; y++) {
    genre = random.pickone(genresCopy);
    meta.genre += ', ' + capitalize(genre);
    genresCopy.splice(genresCopy.indexOf(genre), 1);
  }

  meta.studio = random.pickone(studio);
  meta.source = random.pickone(source);

  meta.malScore = random.integer({ min: 1, max: 10 });

  if (meta.malScore < 7 && random.bool()) {
    meta.malScore += random.integer({ min: 1, max: 3 });
  }
  if (meta.malScore < 5 && random.bool()) {
    meta.malScore += random.integer({ min: 1, max: 3 });
  }
  if (meta.malScore < 3 && random.bool()) {
    meta.malScore += random.integer({ min: 1, max: 3 });
  }
  if (meta.malScore > 7 && random.bool()) {
    meta.malScore -= random.integer({ min: 1, max: 2 });
  }
  if (meta.malScore > 8 && random.bool()) {
    meta.malScore -= random.integer({ min: 1, max: 2 });
  }
  meta.malScore += random.integer({ min: 1, max: 100 }) / 100;
};

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSentence;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);


var _require = __webpack_require__(0),
    capitalize = _require.capitalize,
    indefiniteArticle = _require.indefiniteArticle,
    template = _require.template,
    randomFilter = _require.randomFilter;

function createSentence(state, type) {
  var random = state.random,
      protagonist = state.protagonist,
      meta = state.meta,
      setting = state.setting,
      names = state.names;


  var templateFilters = {
    random: randomFilter(random),
    pickone: function pickone(arr) {
      return random.pickone(arr);
    },
    indefiniteArticle: indefiniteArticle,
    capitalize: capitalize
  };

  var protagonistName = random.pickone([protagonist.firstName, protagonist.firstName + ' ' + protagonist.lastName]);

  var result = void 0;

  if (type === 'first') {
    // One character, two characters and setting
    var structuresOne = names.sentenceFirst.oneCharacter;
    var structuresTwo = names.sentenceFirst.twoCharacters;
    var structuresSetting = names.sentenceFirst.setting;

    var firstSentencePool = structuresOne.length + structuresTwo.length + structuresSetting.length;

    meta.firstSentenceRelation = random.integer({ min: 1, max: firstSentencePool });
    if (meta.firstSentenceRelation <= structuresOne.length) {
      result = random.pickone(structuresOne);
      meta.firstSentenceRelationLog = 1;
    } else if (meta.firstSentenceRelation > structuresOne.length && meta.firstSentenceRelation <= structuresTwo.length) {
      result = random.pickone(structuresTwo);
      meta.firstSentenceRelationLog = 2;
    } else {
      result = random.pickone(structuresSetting);
      meta.firstSentenceRelationLog = 3;
    }

    result = template(result, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ protagonistName: protagonistName }, names, state), templateFilters);

    meta.sentences = 1;
    return result;
  }

  if (type === 'mid') {
    var merge = meta.firstSentenceRelationLog === 1
    // One Character
    ? names.sentenceMid.oneCharacter : meta.firstSentenceRelationLog === 2
    // Group
    ? names.sentenceMid.twoCharacters
    // Setting
    : names.sentenceMid.setting;

    // Merge neutral 'structures' with merge
    var structures = names.sentenceMid.structures;
    structures = merge.concat(structures);

    result = random.pickone(structures.filter(function (element, index) {
      return index !== setting.structureTaken;
    }));

    setting.structureTaken = structures.indexOf(result);

    meta.sentence = meta.sentence + 1;

    result = template(result, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ protagonistName: protagonistName }, names, state), templateFilters);

    return result;
  }

  if (type === 'last') {
    result = template(random.pickone(names.sentenceMid.structures), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ protagonistName: protagonistName }, names, state), templateFilters);

    return result;
  }
}

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSetting;
function createSetting(state) {
  var random = state.random,
      setting = state.setting,
      names = state.names;
  var locations = names.locations,
      locationPlace = names.locationPlace,
      locationNature = names.locationNature,
      occupationLocation = names.occupationLocation,
      stateform = names.stateform,
      place = names.place,
      period = names.period,
      era = names.era,
      weather = names.weather,
      time = names.time,
      timespan = names.timespan,
      catastrophe = names.catastrophe,
      timeOfDay = names.timeOfDay,
      season = names.season;


  setting.location = random.pickone(locations);
  setting.locationPlace = random.pickone(locationPlace);
  setting.locationNature = random.pickone(locationNature);
  setting.occupationLocation = random.pickone(occupationLocation);
  setting.country = random.country({ full: true });
  setting.countrySek = random.country({ full: true });
  setting.countryStateform = random.pickone(stateform);
  setting.countrySekStateform = random.pickone(stateform);
  setting.place = random.pickone(place);
  setting.period = random.pickone(period);
  setting.era = random.pickone(era);
  setting.weather = random.pickone(weather);
  setting.time = random.pickone(time);
  setting.timespan = random.pickone(timespan);
  setting.catastrophe = random.pickone(catastrophe);
  setting.timeOfDay = random.pickone(timeOfDay);
  setting.season = random.pickone(season);

  setting.wildcard = random.pickone([].concat(random.countries().map(function (e) {
    return e.name;
  }), locationPlace, locationNature, place));

  setting.catastropheSpice = setting.wildcardSubject;
}

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTitle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);


var _require = __webpack_require__(0),
    capitalize = _require.capitalize,
    template = _require.template,
    randomFilter = _require.randomFilter;

function createTitle(state) {
  var title = state.title,
      random = state.random,
      names = state.names;

  var templateFilters = {
    random: randomFilter(random),
    pickone: function pickone(arr) {
      return random.pickone(arr);
    },
    capitalize: capitalize
  };

  var titlePool = names.titleTemplates;
  title.primary = template(random.pickone(titlePool), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state, names), templateFilters);

  var titleSubtitle = names.subtitleTemplates;
  title.subtitle = template(random.pickone(titleSubtitle), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state, names), templateFilters);

  if (random.bool({ likelihood: 80 })) {
    var characters = names.specialCharacters.map(function (e) {
      return e[0];
    });
    var weights = names.specialCharacters.map(function (e) {
      return e[1];
    });
    title.primary = title.primary + random.weighted(characters, weights);
  }

  if (random.bool({ likelihood: 90 })) {
    var version = random.integer({ min: 1, max: 3 });
    if (random.integer({ min: 1, max: 2 }) === 1) {
      if (version === 1) {
        version = 0;
      }
      title.primary = title.primary + ' ' + version;
    } else {
      var versionTemp = '';
      for (var i = 0; i < version; i++) {
        versionTemp = versionTemp + 'I';
      }
      title.primary = title.primary + ' ' + versionTemp;
    }
  }

  if (random.bool({ likelihood: 85 })) {
    title.full = title.primary + ': ' + title.subtitle;
  } else {
    title.full = title.primary;
    title.subtitle = null;
  }
}

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTrope;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);


var _require = __webpack_require__(0),
    capitalize = _require.capitalize,
    template = _require.template,
    randomFilter = _require.randomFilter;

function createTrope(state, type) {
  var protagonist = state.protagonist,
      secondaryCharacter = state.secondaryCharacter,
      tertiaryCharacter = state.tertiaryCharacter,
      setting = state.setting,
      meta = state.meta,
      names = state.names,
      random = state.random;
  var object = names.object,
      bodypart = names.bodypart,
      group = names.group,
      occupationPlural = names.occupationPlural,
      determiner = names.determiner,
      adjective = names.adjective,
      occupation = names.occupation,
      race = names.race,
      relation = names.relation,
      verbPresentParticiple = names.verbPresentParticiple,
      verbPastParticiple = names.verbPastParticiple,
      characterTrope = names.characterTrope,
      ownership = names.ownership,
      assessment = names.assessment,
      racePlural = names.racePlural,
      groupSize = names.groupSize,
      color = names.color,
      abstractConcept = names.abstractConcept,
      verbToInfinitive = names.verbToInfinitive,
      element = names.element;


  var wildcardSubject = [].concat(occupation, race, object, color);

  var templateFilters = {
    random: randomFilter(random),
    pickone: function pickone(arr) {
      return random.pickone(arr);
    },
    capitalize: capitalize
  };

  if (type === 'protagonist') {
    makeBasicCharacter(random, names, protagonist);

    protagonist.bodypart = random.pickone(bodypart);
    protagonist.group = random.pickone(group);

    var occupationNumber = random.integer({ min: 0, max: occupation.length - 1 });
    protagonist.occupation = occupation[occupationNumber];
    protagonist.occupationPlural = occupationPlural[occupationNumber];
    protagonist.occupationDeterminer = random.pickone(determiner);

    protagonist.nickname = template('{adjective | capitalize} {occupation | capitalize}', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, names, state), templateFilters);
    protagonist.object = random.pickone(object);
    protagonist.objectSecond = random.pickone(object);
    protagonist.verbPresentParticiple = random.pickone(verbPresentParticiple);
    protagonist.verbPastParticiple = random.pickone(verbPastParticiple);
    protagonist.characterTrope = random.pickone(characterTrope);
    protagonist.ability = template('{object | capitalize} {object | capitalize}', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, names, state), templateFilters);
    protagonist.objectAdj = random.pickone(adjective);
    protagonist.objectRelation = random.pickone(ownership);
    protagonist.assessment = random.pickone(assessment);
    protagonist.allies = template('{occupation | capitalize} {object | occupationPlural}', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, names, state), templateFilters);
    protagonist.threat = template('{occupation | capitalize} {object | occupationPlural}', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, names, state), templateFilters);
    protagonist.threatRace = random.pickone(racePlural);
    protagonist.alliesRace = random.pickone(racePlural);
    protagonist.threadRaceSingular = random.pickone(race);
    protagonist.threatGroup = random.pickone(group);
    protagonist.threatGroupSize = random.pickone(groupSize);
    protagonist.threatAdjective = random.pickone(adjective);
    protagonist.adjective = random.pickone(adjective);
    protagonist.abstractConcept = random.pickone(abstractConcept);
    protagonist.color = random.pickone(color);
    setting.wildcardSubject = random.pickone(wildcardSubject);

    protagonist.goal = template(random.pickone(names.goalTemplates), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, names, state), templateFilters);

    protagonist.verbToInfinitive = random.pickone(verbToInfinitive);
    protagonist.element = random.pickone(element);
    protagonist.relationSek = random.pickone(relation);
    protagonist.relationTert = random.pickone(relation);

    setting.adjective = random.pickone(adjective);
    meta.PresentParticiple = random.pickone(verbPresentParticiple);
    meta.adjective = random.pickone(adjective);
  }

  if (type === 'secondaryCharacter') {
    makeBasicCharacter(random, names, secondaryCharacter);
    secondaryCharacter.adjective = random.pickone(adjective);
    secondaryCharacter.adjectiveSek = random.pickone(adjective);
  }

  if (type === 'tertiaryCharacter') {
    makeBasicCharacter(random, names, tertiaryCharacter);
  }
}

function makeBasicCharacter(random, names, character) {
  var occupation = names.occupation,
      race = names.race,
      gender = names.gender,
      lastName = names.lastName,
      relation = names.relation;


  character.gender = random.pickone(gender);
  character.age = random.age({ type: 'teen' });

  var genderData = names.genderData[character.gender];

  character.firstName = random.pickone(names.firstNames[character.gender]);
  character.objectivePronoun = genderData.objectivePronoun;
  character.genderPerfectTense = genderData.perfectTense;
  character.pronoun = genderData.pronoun;

  if (character.age > 19) {
    character.genderName = genderData.adultGenderName;
  } else {
    character.genderName = genderData.youngGenderName;
  }

  character.lastName = random.pickone(lastName);
  character.relation = random.pickone(relation);
  character.race = random.pickone(race);
  character.occupation = random.pickone(occupation);
}

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lang_language_handler__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_json_loader_yaml_loader_lang_language_names_yaml__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_json_loader_yaml_loader_lang_language_names_yaml___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_json_loader_yaml_loader_lang_language_names_yaml__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      lang: null,
      languageNames: __WEBPACK_IMPORTED_MODULE_1_json_loader_yaml_loader_lang_language_names_yaml___default.a
    };
  },

  watch: {
    '$route': function $route(to, from) {
      if (to.params.language !== from.params.language) {
        this.getLanguageData();
      }
    }
  },
  mounted: function mounted() {
    this.getLanguageData();
  },

  methods: {
    getLanguageData: function getLanguageData() {
      var _this = this;

      var language = this.$route.params.language || 'en';

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lang_language_handler__["a" /* getLanguageData */])(language).then(function (lang) {
        fixTag(lang.interface, 'footer');
        _this.lang = lang;
      }, function () {
        _this.$router.replace('/' + _this.$route.params.seed);
      });
    }
  }
});

function fixTag(obj, tagName) {
  var original = obj[tagName];
  var tokens = original.match(/\{[^}]+\}/g);
  var result = original.split(/\{[^}]+\}/g);
  tokens.forEach(function (token, index) {
    var tokenName = token.replace(/^\{\s*|\s*\}$/g, '');
    var tagValues = obj[tokenName];
    result.splice(index * 2 + 1, 0, tagValues);
  });
  obj[tagName + 'Parts'] = result;
}

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AnimePoster__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AnimePoster___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__AnimePoster__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AnimeChart',
  props: ['data', 'lang'],
  components: {
    AnimePoster: __WEBPACK_IMPORTED_MODULE_0__AnimePoster___default.a
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__poster_network_json__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__poster_network_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__poster_network_json__);
//
//
//
//

/* global convnetjs */


// https://websitesetup.org/web-safe-fonts-html-css/
var websafeFonts = ['Arial', 'Helvetica', 'Verdana', 'Bookman', 'Trebuchet MS', 'Arial Black', 'Impact'];

var generateTitle = function generateTitle(ctx, random, data) {
  var font = random.pickone(websafeFonts);
  var lineWidth = random.integer({ min: 5, max: 9 });
  ctx.lineWidth = lineWidth;
  ctx.miterLimit = 2;

  var darkText = random.bool({ probality: 20 });
  ctx.fillStyle = darkText ? 'black' : 'white';
  ctx.strokeStyle = darkText ? 'white' : 'black';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';

  var posX = random.integer({ min: 110, max: 120 });
  var posY = random.bool({ probality: 80 }) ? random.integer({ min: 250, max: 285 }) // down
  : random.bool({ probality: 60 }) ? random.integer({ min: 50, max: 100 }) // above
  : 164; // middle

  var doRotation = random.bool({ probality: 30 });
  if (doRotation) {
    ctx.save();
    ctx.rotate(random.floating({ min: -0.02, max: 0.02 }));
  }

  if (data.subtitle) {
    var sizeFirst = random.integer({ min: 30, max: 40 });
    var sizeSecond = random.integer({ min: 20, max: 30 });
    var yDelta = sizeFirst / 2;

    ctx.font = sizeFirst + 'px ' + font;
    ctx.strokeText(data.titleBasic, posX, posY - yDelta, 200);
    ctx.fillText(data.titleBasic, posX, posY - yDelta, 200);

    ctx.font = sizeSecond + 'px ' + font;
    ctx.strokeText(data.subtitle, posX, posY + yDelta, 200);
    ctx.fillText(data.subtitle, posX, posY + yDelta, 200);
  } else {
    var size = random.integer({ min: 20, max: 50 });
    ctx.font = size + 'px ' + font;
    ctx.strokeText(data.title, posX, posY, 200);
    ctx.fillText(data.title, posX, posY, 200);
  }

  if (doRotation) ctx.restore();
};

function sharpen(ctx, w, h, mix, a) {
  // note: for some weird reason declaring "a" in the let below makes ESLint
  // throw a no-unused-vars error, in the other hand not declaring it makes
  // it throw a no-undef error, so to fix this weird bug this variable got
  // declared in the function arguments
  var x = void 0,
      sx = void 0,
      sy = void 0,
      r = void 0,
      g = void 0,
      b = void 0,
      dstOff = void 0,
      srcOff = void 0,
      wt = void 0,
      cx = void 0,
      cy = void 0,
      scy = void 0,
      scx = void 0;
  var weights = [0, -1, 0, -1, 5, -1, 0, -1, 0];
  var katet = Math.round(Math.sqrt(weights.length));
  var half = katet * 0.5 | 0;
  var dstData = ctx.createImageData(w, h);
  var dstBuff = dstData.data;
  var srcBuff = ctx.getImageData(0, 0, w, h).data;
  var y = h;

  while (y--) {
    x = w;
    while (x--) {
      sy = y;
      sx = x;
      dstOff = (y * w + x) * 4;
      r = 0;
      g = 0;
      b = 0;
      a = 0;

      for (cy = 0; cy < katet; cy++) {
        for (cx = 0; cx < katet; cx++) {
          scy = sy + cy - half;
          scx = sx + cx - half;

          if (scy >= 0 && scy < h && scx >= 0 && scx < w) {
            srcOff = (scy * w + scx) * 4;
            wt = weights[cy * katet + cx];

            r += srcBuff[srcOff] * wt;
            g += srcBuff[srcOff + 1] * wt;
            b += srcBuff[srcOff + 2] * wt;
            a += srcBuff[srcOff + 3] * wt;
          }
        }
      }

      dstBuff[dstOff] = r * mix + srcBuff[dstOff] * (1 - mix);
      dstBuff[dstOff + 1] = g * mix + srcBuff[dstOff + 1] * (1 - mix);
      dstBuff[dstOff + 2] = b * mix + srcBuff[dstOff + 2] * (1 - mix);
      dstBuff[dstOff + 3] = srcBuff[dstOff + 3];
    }
  }

  ctx.putImageData(dstData, 0, 0);
}

var scheduledPosters = [];
var currentKey = void 0;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AnimePoster',
  props: ['data'],
  mounted: function mounted() {
    this.generatePosterSchedule();
  },

  watch: {
    '$route': function $route(to, from) {
      var scheduleKey = to.params.seed + '_' + to.params.language;
      if (scheduleKey !== currentKey) {
        currentKey = scheduleKey;
        scheduledPosters = [];
      }
    },
    data: function data() {
      this.generatePosterSchedule();
    }
  },
  methods: {
    generatePosterSchedule: function generatePosterSchedule() {
      var _this = this;

      var canvas = this.$el;
      // Those are the AniList poster dimensions
      canvas.width = 230;
      canvas.height = 325;

      if (scheduledPosters.length === 0) {
        setTimeout(this.generatePosterTimeout, 100);
      }

      scheduledPosters.push(function () {
        _this.generatePoster();
      });
    },
    generatePosterTimeout: function generatePosterTimeout() {
      var posterFn = scheduledPosters.shift();
      if (posterFn) {
        posterFn();
        setTimeout(this.generatePosterTimeout, 1000);
      }
    },
    generatePoster: function generatePoster() {
      var canvas = this.$el;
      var data = this.data;
      var random = data.random;
      var ctx = canvas.getContext('2d');

      // Those are the MyAnimeList small poster dimensions
      var tempCanvas = document.createElement('canvas');
      var W = tempCanvas.width = 50;
      var H = tempCanvas.height = 70;
      var tempCtx = tempCanvas.getContext('2d');

      // Neural network related info
      var imageCount = 20;
      var bg = tempCtx.getImageData(0, 0, W, H);
      var v = new convnetjs.Vol(1, 1, 2 + imageCount);
      var net = new convnetjs.Net();
      net.fromJSON(__WEBPACK_IMPORTED_MODULE_0__poster_network_json___default.a);

      // Set image weights
      var mainImage = random.integer({ min: 0, max: imageCount - 1 });
      var secondImage = random.integer({ min: 0, max: imageCount - 1 });
      for (var i = 0; i < imageCount; i++) {
        v.w[2 + i] = mainImage === secondImage ? random.floating({ min: 0, max: 1 }) : i === mainImage ? random.floating({ min: 0.5, max: 1 }) : i === secondImage ? random.floating({ min: 0, max: 0.5 }) : 0;
      }

      // Normalize heights
      var heightSum = v.w.slice(2).reduce(function (sum, element) {
        return sum + element;
      }, 0);
      for (var _i = 0; _i < imageCount; _i++) {
        v.w[2 + _i] /= heightSum;
      }

      // Draw background from neural network
      for (var x = 0; x < W; x++) {
        v.w[0] = (x - W / 2) / W;
        for (var y = 0; y < H; y++) {
          v.w[1] = (y - H / 2) / H;

          var ix = (W * y + x) * 4;
          var r = net.forward(v);
          bg.data[ix + 0] = Math.floor(255 * r.w[0]);
          bg.data[ix + 1] = Math.floor(255 * r.w[1]);
          bg.data[ix + 2] = Math.floor(255 * r.w[2]);
          bg.data[ix + 3] = 255;
        }
      }

      // Update canvas
      tempCtx.putImageData(bg, 0, 0);
      sharpen(tempCtx, W, H, random.floating({ min: 0.1, max: 0.7 }));
      ctx.drawImage(tempCanvas, 0, 0, canvas.width, canvas.height);

      // Draw title
      generateTitle(ctx, random, data);
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AnimeChart__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AnimeChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__AnimeChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chance__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chance___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chance__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__procedural_createChart__ = __webpack_require__(20);
//
//
//
//
//
//
//





var CHART_COUNT = 12;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'main-view',
  props: ['lang'],
  components: {
    AnimeChart: __WEBPACK_IMPORTED_MODULE_0__AnimeChart___default.a
  },
  data: function data() {
    return {
      charts: []
    };
  },

  watch: {
    '$route': function $route(to, from) {
      this.generateCharts();
    }
  },
  mounted: function mounted() {
    this.generateCharts();
  },

  methods: {
    generateCharts: function generateCharts() {
      var chance = new __WEBPACK_IMPORTED_MODULE_1_chance___default.a(this.$route.params.seed);
      var newCharts = [];
      this.charts = [];

      for (var i = 0; i < CHART_COUNT; i++) {
        var chart = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__procedural_createChart__["a" /* default */])(chance, this.lang);
        newCharts.push(chart);
      }

      this.charts = newCharts;
    }
  }
});

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 61 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 62 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 63 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 64 */,
/* 65 */,
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(61)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(27),
  /* template */
  __webpack_require__(70),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-adbed55c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(28),
  /* template */
  __webpack_require__(72),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(60)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(29),
  /* template */
  __webpack_require__(69),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5aa63786",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart-area"
  }, [(!_vm.charts.length) ? _c('div', {
    staticClass: "loading-msg"
  }, [_vm._v(_vm._s(_vm.lang.interface.loading))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.charts), function(chart) {
    return _c('AnimeChart', {
      key: "chart.id",
      attrs: {
        "data": chart,
        "lang": _vm.lang
      }
    })
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 70 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart"
  }, [_c('div', {
    staticClass: "poster-area"
  }, [_c('AnimePoster', {
    staticClass: "poster",
    attrs: {
      "data": _vm.data
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "scroll-area"
  }, [_c('h2', [_vm._v(_vm._s(_vm.data.title))]), _vm._v(" "), _c('div', {
    staticClass: "meta"
  }, [_vm._v("\n      " + _vm._s(_vm.data.episodes) + " " + _vm._s(_vm.data.episodes === 1 ? _vm.lang.interface.episode : _vm.lang.interface.episodes)), _c('br'), _vm._v("\n      ★ " + _vm._s(_vm.data.score.toFixed(2)) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "studio"
  }, [_vm._v(_vm._s(_vm.data.studio))]), _vm._v(" "), _c('div', {
    staticClass: "genre"
  }, [_vm._v(_vm._s(_vm.data.genre))]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.data.description))])])])
},staticRenderFns: []}

/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.lang) ? _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header', [_c('h1', [_vm._v(_vm._s(_vm.lang.interface.name))]), _vm._v(" "), _c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": "random"
    }
  }, [_vm._v(_vm._s(_vm.lang.interface.reroll))])], 1), _vm._v(" "), _c('div', {
    staticClass: "floating-header-padding"
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "lang": _vm.lang
    }
  }), _vm._v(" "), _c('footer', [_c('p', _vm._l((_vm.lang.interface.footerParts), function(part) {
    return _c('span', [(part.url) ? _c('a', {
      attrs: {
        "href": part.url
      }
    }, [_vm._v(_vm._s(part.text))]) : _c('span', [_vm._v(_vm._s(part))])])
  })), _vm._v(" "), _c('p', {
    staticClass: "lang-select"
  }, _vm._l((_vm.languageNames), function(lang, code) {
    return _c('router-link', {
      key: code,
      attrs: {
        "to": '/' + (code === 'en' ? '' : code + '/') + _vm.$route.params.seed
      }
    }, [_vm._v("\n        " + _vm._s(lang) + "\n      ")])
  }))])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('canvas')
},staticRenderFns: []}

/***/ }),
/* 73 */,
/* 74 */,
/* 75 */
/***/ (function(module, exports) {

module.exports = {
	"layers": [
		{
			"out_depth": 22,
			"out_sx": 1,
			"out_sy": 1,
			"layer_type": "input"
		},
		{
			"out_depth": 30,
			"out_sx": 1,
			"out_sy": 1,
			"layer_type": "fc",
			"num_inputs": 22,
			"l1_decay_mul": 0,
			"l2_decay_mul": 1,
			"filters": [
				{
					"sx": 1,
					"sy": 1,
					"depth": 22,
					"w": [
						-0.03976998056746876,
						1.4078332749781222,
						-0.21959969200974336,
						-0.4561103464748795,
						-0.35430831569606014,
						0.916809908632498,
						-0.4738197580379236,
						1.7637797667665804,
						-0.2814988356583731,
						-0.3486979926144185,
						-0.2029335858067078,
						0.03229785187165493,
						0.17748892935284563,
						-0.4782025418400701,
						-0.480452737822537,
						-0.26710177514015065,
						-0.30705052052279225,
						-0.4101972323755758,
						-0.19015257857208984,
						0.6064959444266097,
						-0.21802744442942787,
						-0.2673424255623474
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 22,
					"w": [
						2.5626471208183013,
						2.3412250583541274,
						0.5308750274513274,
						0.9730140935726528,
						0.5471388044708799,
						1.4767697670407758,
						-1.30942191413566,
						0.5798852006303681,
						-0.7666068920646121,
						1.1046820502846597,
						-0.4670999650747406,
						0.9289886382097653,
						1.493015515354862,
						-0.5262868739676347,
						-0.9667529711616617,
						-0.19943305319467067,
						-0.5104475948874962,
						0.1814415559103852,
						-0.8083434021592466,
						-0.13903106812273605,
						-0.4224717585192707,
						0.6268416937671716
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 22,
					"w": [
						2.412313793020279,
						3.497883152498504,
						-0.7862498651821173,
						0.2240164194400245,
						1.3230687898556313,
						-1.1933015168700905,
						-0.9071936118576854,
						-1.1868073711176117,
						0.7508879537627885,
						0.14445597654015682,
						1.8060341849964001,
						0.7590965298730638,
						0.36482397289878493,
						-0.6228585257726402,
						1.4438562029687505,
						-1.7360028262397886,
						2.2219355475437115,
						-0.2226070927467554,
						-1.855508878194354,
						0.06466713363101485,
						-0.18169805949207718,
						0.5674805592978168
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 22,
					"w": [
						-3.4721981147731302,
						2.3799119206148576,
						-0.05595712067340952,
						0.26335230541065946,
						0.07366866905240432,
						0.5928481316481136,
						1.1731451312179206,
						0.22751204683556422,
						1.8384618031072628,
						-0.05345680076051578,
						0.10944465274975308,
						-1.1253763251074584,
						-0.7531852997742842,
						-1.4739177707526816,
						-0.4427315576320347,
						0.5216217026831952,
						-1.380218477100309,
						1.0169159682068678,
						-0.11706226247759373,
						-0.239978379204356,
						-1.089425253503473,
						0.6619902901037382
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 22,
					"w": [
						1.9283211118340258,
						0.12574028652998973,
						0.15560224068675108,
						-0.04891850053070966,
						0.22047470410801603,
						-1.1365374661352632,
						0.9240651717374926,
						0.2662753772614338,
						0.5669812198579489,
						-1.122059486896916,
						-0.747159694533945,
						-0.9870037551033469,
						1.7797819540108024,
						0.23688981909800658,
						-0.01650613176750337,
						0.14523609503134957,
						-0.05377522043039128,
						-0.16259559233604975,
						1.572429900924309,
						0.42165067023136904,
						-1.002287373703529,
						-0.9905880216903389
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 22,
					"w": [
						3.94975922599732,
						-1.0928561257892044,
						0.8896609966759155,
						-0.5000776100750556,
						-0.8535295262974628,
						-0.46811701649315335,
						-0.548106319172879,
						-0.2968320726058586,
						0.6282544074144225,
						-0.5304261349263236,
						-0.24784692931162644,
						-1.442175465534601,
						-0.09763378616943719,
						1.5772830184916842,
						0.7742876693050262,
						-0.7360673807443919,
						-1.0804692288356064,
						1.2430934880021083,
						-0.5999144935164618,
						1.1758084309763632,
						0.4488650067840054,
						-1.165645525292036
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 22,
					"w": [
						2.09637083599977,
						0.07200695091824472,
						-0.9371473184678393,
						-0.47167151076458624,
						-0.5157080929984992,
						-0.9213428526671881,
						-0.44909185007044927,
						0.2481597567326348,
						-0.3303630067248043,
						-0.5981442299870827,
						0.5578575057233277,
						-0.1735838691443306,
						0.22862660276566926,
						-0.2485712818204331,
						-0.7775056313979564,
						-0.562153212028934,
						0.5346772559904739,
						-0.829891181187663,
						1.2973185806944478,
						0.8017155207160493,
						-0.15009153461965855,
						2.2736903768237084
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 22,
					"w": [
						3.3369677481189197,
						3.447812796079258,
						1.1605803466886004,
						-0.0668787651006752,
						0.651386524350541,
						-2.419720143350272,
						-1.3788284955104035,
						-1.0161098928180412,
						0.14567072002731002,
						1.169725110230356,
						0.5982518813557671,
						-0.7615919698652934,
						0.7553138895575149,
						-0.023973074863335293,
						-1.6876080705085288,
						1.845052617715964,
						1.2972881636263922,
						2.0815858424272613,
						-0.05122459011789154,
						-1.315082161341735,
						-1.026955648550722,
						-0.7759947025998092
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 22,
					"w": [
						-2.817849094291789,
						3.565258433044656,
						0.6695955582216486,
						-0.7727403627675551,
						1.5778560786306504,
						0.6171669924928005,
						-0.5507730884910421,
						0.4804550955062017,
						-1.5007310067231299,
						0.8085976615913303,
						-0.572273792554555,
						0.40717321232611675,
						-0.8230438328310562,
						-0.23267800695261937,
						0.22888520858500733,
						-0.2418506600935671,
						0.4911373734883415,
						-0.8064880992384267,
						1.0588087530097916,
						1.4658568324187276,
						-0.3555064340097691,
						-0.5738945658432312
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 22,
					"w": [
						-4.0048584894420545,
						-0.029385070631308893,
						-1.3553363583784306,
						-1.1016711767573228,
						0.40836964970211925,
						0.41677891141513124,
						0.7178597533199381,
						0.3864247112633597,
						-0.39633798931567954,
						1.3533323227113512,
						-1.0547055663846596,
						1.3541341617006342,
						0.3878477317831302,
						-1.3409728447269953,
						-0.8419095677526353,
						-0.2754667046368292,
						1.4947375502233091,
						0.39523775281555834,
						-1.1298716192222376,
						0.10055050433063166,
						-0.6623266620870145,
						0.07139012906831589
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 22,
					"w": [
						-0.6323213004393446,
						-3.9264023713329346,
						0.4166216358559274,
						1.29108443376266,
						0.16405909443869074,
						-0.4210363018019207,
						-0.6389398039022353,
						-0.6933759893631606,
						-0.9714473679867233,
						-0.9674570152762239,
						0.3366323850378356,
						0.5676888472318319,
						0.36189806387326157,
						-1.8495043400595699,
						-0.5004137063518712,
						0.700344981166273,
						-0.7186420242297304,
						-1.3709235039963379,
						1.2549800764432801,
						0.7275120018637632,
						-0.06649963425934544,
						1.7417880015543408
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 22,
					"w": [
						-0.1190404286815553,
						2.6190538803349876,
						0.1810458653129683,
						-1.656272672242805,
						-0.8633199734695448,
						0.3942255929488251,
						-0.027836441509856716,
						-0.4552707454331719,
						-0.10135283151519289,
						-0.8850502950090435,
						1.0886938688343544,
						1.2891877034588768,
						0.8590206759646771,
						0.1678604907765375,
						0.8878046651742668,
						-1.4655778252625695,
						0.565306513757478,
						1.0563272637878482,
						-1.273215575383687,
						0.6675870975372313,
						0.33028718264447426,
						0.3733455476634715
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 22,
					"w": [
						-2.8462499118375604,
						1.2453633926346972,
						-0.809999585901381,
						-0.5491234629699865,
						-0.790482288602229,
						-0.41721534491109996,
						0.39349978795316426,
						0.33177649856909786,
						1.3104161904069134,
						1.0862164565446393,
						0.9136996634612703,
						0.12419040413161207,
						-1.4517299579802467,
						0.9134031207459916,
						0.08232090675839414,
						1.1728045620116403,
						-0.3478196526467045,
						-0.8299776869984518,
						-0.3725660812006033,
						-1.561181684274724,
						1.1245130981375393,
						0.08933341066254662
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 22,
					"w": [
						-0.6497536161923465,
						4.254314711116331,
						-0.22412584838221486,
						-0.39648440655906214,
						-0.3257700715499004,
						0.10990562456902661,
						0.00483624621843454,
						0.2745434019613433,
						0.7158930506346033,
						-1.6763080900727994,
						0.12233835049910809,
						0.8058552521038156,
						-0.8678980306446017,
						0.7605797269508698,
						-0.3148027955484127,
						1.0194122693971956,
						0.04519944592254464,
						0.910885941633538,
						-1.5852217869673888,
						0.6789122020426938,
						-0.20661202388107283,
						1.1964084600748943
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 22,
					"w": [
						1.4519316463077476,
						-1.4583548315717454,
						0.20004805064847575,
						-0.5383251254160498,
						-0.6336475544724665,
						-0.3520136810594924,
						2.2168403707267945,
						0.3945301442172553,
						-0.5202966342327948,
						0.7063489225628425,
						-0.43289839635081645,
						-0.47111446140933855,
						-0.8109260473489527,
						-0.23298135185768312,
						-0.6418981679050384,
						0.741984656600803,
						0.8152065113963766,
						-0.5158396736691206,
						-0.33301782773336874,
						0.7109643731822275,
						-0.17728109074315299,
						-0.15230680910910674
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 22,
					"w": [
						4.394833809323332,
						-0.7104165358973066,
						-1.2396034154160052,
						-0.9229165603473906,
						0.8069327789816803,
						-0.1801023667539784,
						0.5561333810534652,
						1.2341102762716232,
						1.1638303638207734,
						-0.7359988554904594,
						0.20080487087982118,
						-1.5930312844011103,
						-1.3565716164868675,
						0.3352436201285985,
						0.8322360818037929,
						-0.07443133734796022,
						2.5446044892457604,
						-0.5064591180317012,
						0.07778555303471431,
						0.3048371861346245,
						0.4812491562513924,
						-0.7372871851558848
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 22,
					"w": [
						-1.4090401139019602,
						-3.3542662660182434,
						-0.23141030074872831,
						-0.7481741094329467,
						1.544857987116559,
						2.4635080952187014,
						-0.20735383874027644,
						-0.960451385088988,
						0.7188564674189527,
						0.6802977638377751,
						-0.28007782456314,
						-0.18274380711661178,
						-1.3684079303446026,
						0.6642291274704464,
						-1.2873416861089104,
						0.8696333126168985,
						1.318621471281737,
						-0.9281786148811444,
						-0.6829851021944136,
						-0.666948148791346,
						-0.8212752450074753,
						-0.530619032947657
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 22,
					"w": [
						1.5960667229807217,
						2.177510956194527,
						1.049608632374949,
						-0.8647456666042451,
						1.5357906969291124,
						-0.3752821803914177,
						-0.35879827641196343,
						-0.014822107144480932,
						0.45005970594659456,
						0.1279014154593975,
						-0.02755378310000193,
						-0.27232673548391245,
						-0.7054696527235127,
						-0.5246912468280115,
						1.0891145353012062,
						-0.5377418613255085,
						-0.864907118711485,
						0.22365992683436403,
						0.21346366277583154,
						-0.8642112189203006,
						-0.9644560976945555,
						0.06381479557979498
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 22,
					"w": [
						-2.507800078807363,
						-0.9012966130320416,
						-0.5043509123273275,
						0.27856964079971397,
						-0.18787055419853677,
						-0.8893284876351453,
						0.9248135476967707,
						0.4788669460379745,
						-0.4969858626619329,
						0.44946593914874894,
						-0.001553590697340977,
						-0.8303993042861367,
						-1.0161212652280933,
						1.6409764704429182,
						0.26478963839193076,
						0.08978661399831551,
						0.2948134461212402,
						0.023588853954939475,
						-0.4338649298299832,
						-0.7509345365978656,
						-0.8235211186219807,
						0.4876846835663575
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 22,
					"w": [
						0.10414027315981983,
						-1.9865330064039333,
						-0.058396791390190085,
						-0.7751284737907783,
						-0.6875953606094033,
						-0.5331549539921036,
						0.5985894590291874,
						-0.2571142347901284,
						-0.5271489789076753,
						-0.11860202240033348,
						1.8007874873577099,
						-0.5749373662798628,
						0.9069501301184804,
						0.550599020541004,
						0.760741202587214,
						0.38687625654281615,
						0.36567821436926723,
						-0.31834595146635614,
						-0.8836493132814623,
						-0.4848010318668381,
						-0.4991078676165659,
						0.5915390920066409
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 22,
					"w": [
						-0.16048048266702505,
						-5.058939290434531,
						-0.05260369137953351,
						-1.6825590038982707,
						2.034372388541273,
						0.023298559222675107,
						0.2789733611992413,
						-0.05580381903319848,
						1.7847619642582484,
						1.9025100434609596,
						-1.0121673143518164,
						-0.3874873115315964,
						0.2817193551411673,
						-2.239426242410091,
						-1.467699064025385,
						0.23339441934089653,
						2.3928930822350205,
						-0.5376012722682112,
						-0.16050221670761644,
						0.5155915978341209,
						-1.4151842077195647,
						-0.273525823146659
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 22,
					"w": [
						-1.9336876312528106,
						0.40506590766335626,
						0.8382338437864435,
						0.15358420932629377,
						-0.6700295910220806,
						-0.783820550417338,
						-0.6386119635353611,
						-0.3016215790736564,
						0.2621890210000191,
						0.2739683267758155,
						0.33833167556124244,
						-0.13099435871553464,
						0.8624849540365872,
						-0.2583694123808758,
						-0.36004923554107876,
						-0.02964439868649973,
						-0.7607751418338707,
						-0.3994312237948709,
						0.05800918915385596,
						0.763252999844513,
						-0.2836998328451003,
						0.29577677573243855
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 22,
					"w": [
						-3.757274528008308,
						-0.6704118691105865,
						0.28897850651276397,
						-0.7227709921727599,
						-0.25183738056398597,
						0.031005733814457058,
						0.7164800334631952,
						1.1963931774769916,
						-1.8512068915496867,
						0.2951300359034171,
						-0.47925009624508724,
						-0.3111626504068058,
						0.004504501597025542,
						0.23197069500181078,
						-0.16049718657977996,
						0.4328075496628395,
						-0.25678991982825644,
						-0.7595467911003226,
						-0.06859979295636506,
						1.464059372130122,
						-1.2415176989293466,
						0.3265257280548264
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 22,
					"w": [
						0.22576819865825368,
						-3.835402945148888,
						-0.03136184568158898,
						-0.6173279661165308,
						1.8731249126974694,
						0.30084199477280943,
						1.658482336501061,
						1.0781452914865817,
						0.7855557477414267,
						-0.5994874550954122,
						-1.1616817059490554,
						-0.17653722985723924,
						-0.5136696866603369,
						-0.19606247614845662,
						-0.29660699775468163,
						-0.9991279664731694,
						-0.9664691698735508,
						-0.269188039990178,
						-1.0558168057904744,
						-0.2798097654249005,
						-0.31633486181522447,
						1.9222485518879173
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 22,
					"w": [
						1.7018906512175307,
						-2.0410881324015007,
						-0.682388920553433,
						0.08566906921718234,
						1.1520654530907632,
						0.7115540876938368,
						0.26544141634801727,
						-0.6963579822471891,
						-1.3835634471139233,
						-0.4470257559284814,
						-0.44482144871578116,
						0.29672893993057214,
						1.5063243612892856,
						-1.1838141125818393,
						-0.7701910472418482,
						-1.3920530535233373,
						-0.4735372191201004,
						1.1062797804017888,
						0.6055161541913773,
						-0.08845039784993362,
						0.13667500141189184,
						1.3133140157947514
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 22,
					"w": [
						1.7433856756904065,
						-3.686922974683149,
						-1.0184814072223063,
						1.2507958194651994,
						1.0691517980894485,
						-0.7257690404450517,
						-1.4908944591641156,
						-1.0044735142757486,
						-0.8693857618413267,
						0.6865672140291745,
						-0.6211665009953921,
						-1.044749158866035,
						-0.6901401839883459,
						-0.3165683559927334,
						0.2361451573659747,
						0.6333126229623623,
						0.7117722454834128,
						0.5431254016122343,
						-0.8187635932289279,
						0.9119955221172514,
						-0.16545687366909753,
						0.5632213385075396
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 22,
					"w": [
						4.862701995406907,
						-0.9505027043825247,
						-1.8103863434066634,
						-0.36264824400856593,
						-0.3585983961081296,
						-0.2805853986554233,
						-0.2784481809717445,
						-0.43928325196844775,
						0.0062465855670288456,
						1.5637280459434355,
						-0.3485288104882417,
						0.11429525160250238,
						-0.008168640690601298,
						-0.020100360592256426,
						1.6591691474304318,
						1.2832382608459068,
						-0.6017736757999748,
						1.0380698084514948,
						0.26912944390229226,
						-1.5244455706907079,
						0.7272974747337465,
						-0.6526948856582797
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 22,
					"w": [
						-0.07433693986980631,
						0.8122036858316202,
						0.17426529919422196,
						-0.48721988544026296,
						0.7026823167031775,
						1.1265124088390248,
						0.7561409493512622,
						-0.3901242563702262,
						0.4713611853675526,
						-0.5392459634360526,
						-0.19043672763254058,
						0.7826695767953288,
						-0.5206640079661295,
						-0.5808754546381191,
						0.046419236917944105,
						1.0692395518349582,
						0.2636230012389994,
						-0.5883601403402081,
						0.22454188578361622,
						-0.2684105419813635,
						-0.4283406788009895,
						-0.5834205034599411
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 22,
					"w": [
						1.314651498211614,
						-1.6676721796758864,
						0.03556752601142235,
						0.928402422893952,
						1.3241058393324547,
						0.033197280752081955,
						-0.5775929954524421,
						0.6616363355685217,
						0.11407253815459245,
						-0.8759226598078775,
						-1.500969625093287,
						-0.9890410423049814,
						0.8466311086582188,
						1.0602539147829178,
						0.40423348531821157,
						0.522494548010128,
						-0.16334396862357167,
						0.02747236075925045,
						0.6024845592934407,
						-0.7154701333608625,
						-0.7924403808889291,
						-0.7924818993643669
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 22,
					"w": [
						-1.591462594860833,
						-4.087345937705059,
						-0.20322763225334003,
						0.08526802129993366,
						0.5253681345351779,
						1.0222344921066207,
						-0.5862335374553698,
						-0.604424882005434,
						-0.8334433318699321,
						0.18812344848268944,
						-0.7964286660806704,
						1.1369066298394495,
						-0.8518352549628818,
						-1.6217306617103233,
						2.1192009272899686,
						-0.9541389964007976,
						1.3860863418851885,
						-0.5677673718540163,
						-0.8293064248919376,
						0.31546171279391344,
						-0.10192081194905059,
						-0.9096241793162564
					]
				}
			],
			"biases": {
				"sx": 1,
				"sy": 1,
				"depth": 30,
				"w": [
					-0.22404426546573403,
					0.1374761459346924,
					0.37189029856296263,
					-0.9081828611751402,
					0.17763732107749924,
					0.021378463438295057,
					-0.11947391442385759,
					-0.09679867084372641,
					-0.03043478806981936,
					-0.6602087018824012,
					-0.029690847950885033,
					0.30952797196943044,
					-0.017099277794271416,
					0.5715365686860182,
					-0.3144611966352984,
					0.8210319585253859,
					-0.3411467005321184,
					0.07350273830169564,
					-0.41770908972135795,
					0.04062683453088795,
					-0.31534507146063806,
					0.25747091550975726,
					-0.0892169811675236,
					-0.3250144968903839,
					-0.14125870041698924,
					-0.06870764316208339,
					-0.34216079611995265,
					0.17582589213521863,
					0.1418580652711146,
					-0.5436560309666711
				]
			}
		},
		{
			"out_depth": 30,
			"out_sx": 1,
			"out_sy": 1,
			"layer_type": "relu"
		},
		{
			"out_depth": 30,
			"out_sx": 1,
			"out_sy": 1,
			"layer_type": "fc",
			"num_inputs": 30,
			"l1_decay_mul": 0,
			"l2_decay_mul": 1,
			"filters": [
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-1.1785291832763527,
						0.9547414473372295,
						0.43188094660218057,
						-0.5397153595648025,
						0.3780696924700809,
						-1.3230234200724909,
						-0.06194145000345992,
						-0.13658743922435174,
						0.15372452410243223,
						-0.74287529255892,
						-0.6775067852979502,
						0.53827354075074,
						0.9489684446245485,
						-0.003156694645634552,
						-0.04142271423955202,
						-2.7883618178318406,
						-0.037042669733013865,
						0.3746096351240035,
						-0.5753807406050286,
						0.6685100224601281,
						-0.0360839744981496,
						0.7215220509609603,
						0.3500767068022555,
						1.1956085236647618,
						-1.4281000985111858,
						0.6716857417677902,
						0.0883781506076197,
						-0.28946531388943936,
						0.026634345457705884,
						-1.7622560338978164
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.875901355121408,
						0.5058140118564182,
						-0.7376153808749547,
						-1.054215010532102,
						1.4283341337931434,
						0.2605368047267499,
						0.3067391564322657,
						0.6832508237118788,
						0.5106305497647458,
						-0.8422777695669352,
						-1.1884782822609452,
						-0.9941742725457665,
						-1.4715215025227806,
						0.48281312420091677,
						0.424144095995157,
						-0.3651412149185622,
						-0.9486249095152336,
						0.10509768564803498,
						-0.6978126361901703,
						-0.20330098468924646,
						1.0816907802617415,
						0.5643920451359528,
						-1.0276447329796492,
						-0.05095639842508002,
						-0.491747069416593,
						0.8270235884841556,
						0.6790378132608132,
						-0.21438703939369738,
						0.2554399172354863,
						-1.2487600762646658
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.38719865648165747,
						-0.09646618753857643,
						0.07505343096906185,
						-0.16823551099906986,
						-0.3104069597446313,
						-0.7793499849531995,
						0.8061267692268645,
						0.5131561085564937,
						-1.1363636646955153,
						-0.9967309736195262,
						0.6685507564547841,
						-1.477454225783074,
						-0.6729126658261844,
						-0.32306542913047837,
						0.10480704106362078,
						1.340166388264524,
						-1.3083580348088264,
						-0.33729271026915864,
						0.8226660170402048,
						-0.6661192216051297,
						-0.4308678236431483,
						-0.009487451476599844,
						-0.9813679543432045,
						-0.010810353360254255,
						-0.48139754016458774,
						1.9006660605718857,
						0.9916213885641495,
						-0.43457290862432074,
						1.053246657000077,
						1.0864325035287306
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.2158261700453006,
						0.8361473302236823,
						-1.361139972309821,
						1.0078812483667094,
						-0.4180617274842347,
						0.41571028432799995,
						-0.34662500569505433,
						0.40075615845666146,
						0.7322610184340904,
						-0.47443693283339194,
						1.5170540128300627,
						0.1927323253381116,
						-0.9702676098720602,
						0.821092941010043,
						-0.19727535760890363,
						-1.8198543941285412,
						-0.06459746008390618,
						0.938837458505756,
						-0.3513950735902923,
						-0.43415983001187836,
						0.6940178377307905,
						0.5634937086611504,
						0.023665429916868735,
						1.540314786051683,
						0.43004279302973364,
						1.1077282125989214,
						-0.17974525133682004,
						-0.30568536200772256,
						0.0006860629620458496,
						0.678619750252378
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.6167921784682886,
						0.8696801106895048,
						-0.8915459433100228,
						-0.35907145937672474,
						1.8465086761521465,
						-0.31427590063852706,
						-0.6022795871389315,
						-1.627222437116538,
						-1.2433401139843865,
						-0.5553894778969354,
						-0.5168528196228411,
						0.05643495545261334,
						0.41803111261201403,
						0.5337922754017526,
						1.7764075849168628,
						-0.05745027531641715,
						0.15104290020522154,
						-0.1840156585676954,
						0.6900908767075085,
						-0.8569903490195474,
						0.10984374422486295,
						0.9575615218485399,
						0.38201553625020773,
						-0.21075517580842154,
						-0.22599006349910158,
						-0.7837847556070126,
						-2.789693811194026,
						-0.3145244003907452,
						0.5563850337553895,
						0.08140317732247594
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.48256501466721546,
						-0.5901235645033899,
						-1.360357345367984,
						-0.6042119276759522,
						-0.5423989843733332,
						1.232528125383545,
						-0.8683217431978332,
						-0.9205964361752732,
						-0.9362313427773362,
						0.612688988809229,
						0.48878195307998507,
						-0.3592837037662444,
						1.2359510701119953,
						-2.950992474470186,
						-0.16728704997300212,
						1.1100400861927724,
						0.36686594886526314,
						-0.8477023170037391,
						0.07447455646167137,
						-0.11906140648779001,
						1.009772315096069,
						-0.1154378660097732,
						-0.15783099501815856,
						0.14626139455181988,
						-1.119344478750902,
						-0.7677496388977607,
						0.2688420549601189,
						-0.05971036750963574,
						0.7376327446984927,
						0.6929959385615043
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.07941158216111796,
						-1.0049602919889653,
						-1.2515550690214474,
						-0.7651287765245106,
						-0.16160982282817882,
						0.726535622246275,
						0.3264221301880156,
						1.0479073203711748,
						1.7785988630189893,
						-0.047266143842776935,
						-0.48396148139397455,
						0.5165826479869687,
						-0.17382133949854245,
						0.9263191907132041,
						-1.6683017151066848,
						0.24918384186199097,
						-1.0574235497058326,
						0.5722325669363971,
						0.29419645964193053,
						-1.3353393690376778,
						0.8764651485939146,
						-1.0134234134804472,
						0.8172707179988369,
						0.6759953674077842,
						0.18717186960229834,
						-0.47547287480508504,
						0.005103666421133238,
						-0.19528948431037094,
						0.006184304305920332,
						-0.39153044291667366
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.13776631135168999,
						-0.6439566172662782,
						-0.5261586901859735,
						-0.3713261518674491,
						0.7745876388076333,
						0.9347383122048518,
						-0.40659443166107706,
						-0.3174435024518881,
						0.5551343535391235,
						-0.7860564731633407,
						0.2931302674855626,
						-0.05499735502408255,
						-0.8959276214909798,
						0.7049773228301689,
						-0.8423358431867937,
						0.163025108081433,
						-0.120385493960918,
						0.3801788788875494,
						-0.24388069614871874,
						-0.20286851138122672,
						0.31287116026900047,
						-0.6437103441116884,
						-0.4501474664858991,
						0.128816157345694,
						0.4974014495017029,
						0.49660380006932664,
						-0.7362248854715282,
						-0.2057491622794026,
						1.1575816502441445,
						-0.404987628653158
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.027652777731752266,
						0.4377296247469489,
						-3.0198889790269337,
						1.3864983206416712,
						-0.7573646060252068,
						-1.0265401610473492,
						-0.4799801071431799,
						-0.30584714218874065,
						0.4945375640815224,
						0.480496795586754,
						-1.1069031868436605,
						-0.25095205903127293,
						-0.3618554129304789,
						0.23439942604790592,
						0.22705843579340085,
						0.733284063411499,
						1.1674004799501676,
						-0.135708030428956,
						-0.060355314916199145,
						0.006317997923838924,
						0.17056145934553907,
						0.14277413670854,
						-0.7151081898044005,
						-0.4414092415712519,
						-1.4373416746338343,
						0.25688017313185363,
						1.1972963328787674,
						0.049321964426437444,
						0.8503901116963855,
						-2.3247879875695103
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.3554740356139418,
						-0.016481108528845604,
						0.9855188898027951,
						0.7094456673010198,
						0.2627228594455048,
						-0.6174715436826438,
						-0.2245115770071902,
						-1.1564502569550406,
						-1.145777101668714,
						-1.1575318084378698,
						1.1484887253189269,
						0.3978185719711438,
						0.619736293589571,
						-0.504628417771848,
						-0.6596240170567403,
						1.1472114641488445,
						-0.5485104982463977,
						0.4091230579984424,
						-0.02160831151861741,
						-0.31472757283410624,
						-1.5868519347235808,
						-0.0032559901681872287,
						0.3516639890674188,
						-0.02289947352338581,
						0.016495895668304134,
						0.9977639053451537,
						-1.6120311835922083,
						0.5057161088272538,
						-0.6919853387924707,
						-0.766809924900648
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.18235217172256027,
						1.4983402768995249,
						0.78563329362246,
						0.07896822924710308,
						0.22573688730468228,
						0.6793640015839362,
						-1.073778142475759,
						0.3906838024040324,
						-0.03769309876447544,
						0.39469055243972423,
						-0.039328341843535744,
						-0.916984646075123,
						-1.6500965256926245,
						-1.1152169955426794,
						0.4637053067504646,
						-0.06783752183087749,
						1.3707727150542017,
						-0.29599152136836365,
						0.4278354543291477,
						0.4574527303082422,
						-0.28752412773782254,
						-1.652290238239202,
						0.3723066865783628,
						1.6615922492263029,
						-1.1018015057295165,
						0.08552757118341564,
						0.01911827908546651,
						-0.024088143911981403,
						0.2315290984660148,
						1.1799456564244104
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.38570896321273174,
						0.4965317079685551,
						-1.5373377322975899,
						0.3844783230625451,
						0.18853498681446357,
						-0.4784488808556861,
						-0.19868580165862068,
						1.2246593851645158,
						-1.6335385906371553,
						-0.4216605160840691,
						1.4438806003124642,
						0.58568372833584,
						0.17091338388768584,
						-0.046900073672259034,
						0.05084224530214644,
						-0.5344117866931377,
						-0.5472919092227255,
						-1.483312351251487,
						1.0531519681255008,
						0.23423147705280453,
						-0.3369918407759005,
						0.256765766500425,
						0.1824909372435128,
						0.9217303142664972,
						0.9623214067130679,
						0.039999688764748235,
						0.20230669176830127,
						-0.8027539482866755,
						0.04672753582699039,
						-0.2646795564742197
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.03785964872712692,
						0.34382236527962706,
						0.8398064802697747,
						-0.5428247452703445,
						0.020526197281459765,
						-0.16015695860184284,
						0.5064440338775104,
						-0.5828627633984792,
						0.3572015894429805,
						1.4180117832937729,
						0.8420826448198808,
						1.2499064339971513,
						-0.018200613883106172,
						1.215929000692615,
						-0.6097807952894908,
						1.0754522497694194,
						-2.348820882928073,
						-0.45703311688496195,
						0.33357016749534085,
						-0.9377881436073984,
						-2.394961245020043,
						0.6325750308785393,
						0.2981225981842326,
						-1.0120057958352129,
						-0.2585580304623326,
						0.7595682928618687,
						-0.392816126357495,
						-0.9251511498199153,
						-1.5521482328569671,
						-0.7838802342255679
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.5641770305867277,
						-0.11235102732614613,
						1.5611139059585264,
						-1.050484898319408,
						0.5213042625717248,
						0.6024917226362868,
						0.6789397871579219,
						1.7252086879496997,
						0.056293950743215776,
						-0.06300577060051772,
						-1.109866411194358,
						0.5850717579780462,
						-1.1784375156680615,
						0.5627976838898748,
						0.5114836251788688,
						0.12138841230982109,
						-0.9902111611067493,
						0.6663687047002345,
						-0.5458964397688644,
						0.6333888040228991,
						-0.3247243366779483,
						0.5288169373481508,
						-0.7416610015865326,
						-0.09459165367716,
						-1.2626949768551894,
						-0.15716871597580495,
						-0.19768048975067712,
						-0.04744282178477262,
						0.5071872048450669,
						-0.8363870038321659
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.04594797246152444,
						0.926969989835421,
						1.0339256621485895,
						0.1936875244461056,
						0.2597645821508933,
						1.1260267114708402,
						0.4708678341684094,
						-1.7254144257078998,
						0.036749984704966196,
						-0.5609633389123503,
						-1.7565019632664287,
						0.05880474637847877,
						-0.6945756239888743,
						-0.30615792699146216,
						0.4694892781812132,
						0.9171377851387617,
						0.7773148806318454,
						-0.9484378084312122,
						-0.09903215104202517,
						0.421855733915238,
						0.9833224420008707,
						-0.10555798786923291,
						-1.9692363700891884,
						-0.11790197468247085,
						0.4801714234814415,
						-0.06573131016075995,
						0.9815962100032458,
						-0.23667015465810345,
						-0.17083961694858402,
						-1.4584889659273046
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.30356248599904617,
						-0.14862189221891195,
						1.4444403865126303,
						0.8109928534690646,
						-0.7617016709008317,
						-1.2214496073391323,
						1.169171250508145,
						-1.089687438723913,
						0.4946218746351333,
						0.8795537226455145,
						-0.7124884579103995,
						0.96201946785835,
						-1.234518893616578,
						0.9568124573744168,
						-0.42805299850983536,
						-0.6417325359249214,
						-0.48992172382100885,
						-0.15624919177759622,
						0.770789995463104,
						0.05679570189844029,
						0.10689219397462096,
						0.0718781270502344,
						0.2512672906758637,
						-0.7795340892090424,
						0.22160020619669651,
						0.039763252315404646,
						-1.2327399456789487,
						0.9403434089425181,
						-0.7154202836724829,
						-0.12751147889325967
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.7578608122475146,
						-0.6120268937757358,
						0.6990351645657022,
						-0.4485525727545472,
						1.1435048884078844,
						1.1219052335201933,
						-1.284047411199647,
						0.050332510307858354,
						-1.33731221717219,
						0.8768465451179311,
						-0.14336187344102652,
						0.2933044830734702,
						-0.06631730014383526,
						0.6076606888345245,
						-0.03276668236673671,
						-0.3984783853138716,
						-0.15425727136335954,
						0.11945260212936895,
						-0.7232818423746188,
						1.05675367025039,
						0.5163576887653528,
						-0.05801930366366933,
						-0.43323087390881265,
						-0.8416480207443711,
						0.2321797411777583,
						-0.11584316004017901,
						0.03284205205995529,
						0.24992880327627084,
						1.07016341375409,
						0.7985825773708284
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.2937634156781369,
						-0.49941525257290037,
						0.32029626832275676,
						-0.24827611153661217,
						-1.548313069714501,
						-0.4737088703232755,
						-0.5265175114187476,
						-0.4103956486504966,
						-0.635373575480466,
						-0.7274457857599684,
						-0.8881617581003461,
						0.2707872598332109,
						0.41486750722238086,
						-1.4145746867102365,
						-0.19026614242021905,
						-0.8042318941047195,
						1.7015912150646508,
						-0.31884811520780015,
						0.732937874778941,
						1.5590430966425686,
						-0.22968144499874343,
						-0.49247158093508253,
						-0.2762129782517447,
						-0.6839489094862096,
						-0.8518202075487379,
						-0.09633074432612526,
						0.26528049065701215,
						0.855241063764711,
						-0.9529255078867563,
						-0.6962692348423678
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.6289899602023451,
						-0.2364125978930932,
						0.6217574672909131,
						0.14206163755354131,
						0.21784948041797064,
						0.11060699888314351,
						-0.14073652660435376,
						0.1762846333962456,
						-1.0371678070542774,
						-0.3120091068076912,
						0.3242076545794946,
						-1.4999145764450337,
						-0.5002517789876444,
						-1.1154926097101876,
						0.017250334288947407,
						0.24138298358813615,
						0.5331987999513871,
						-0.22025806275168233,
						-0.4220851220353833,
						0.3262728926026001,
						1.655001265318094,
						-0.39499975331556364,
						-0.1212255647712145,
						0.21698604619056303,
						0.22806136123506107,
						1.2042161019146274,
						0.45230811812254584,
						-0.2955128036016837,
						-0.03980881326696017,
						1.05439829168901
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.06906402300450923,
						1.1820690513082035,
						-0.028841616065373492,
						-1.1120382145979066,
						0.37694166464041245,
						-0.39231866493986794,
						0.5591644294093642,
						0.1536054611183227,
						-0.027285082546847785,
						-0.3380530407591251,
						0.7613578749647323,
						-0.6564230386042749,
						-0.9926795073111416,
						-0.6936472053838052,
						0.18277306763288062,
						-0.3658758410934084,
						-0.960266914661864,
						1.3029606932623534,
						-0.8413992808119983,
						-1.1509345501420594,
						0.9687534735559584,
						0.3735424688777169,
						0.8106920487679384,
						0.3973996597509471,
						1.3230836316872845,
						0.019152105404100006,
						0.2536967670576075,
						-0.6420719841553254,
						0.2968869927442787,
						0.16565890761862329
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.3964106419088605,
						-0.7487248050862292,
						-0.5670925708763263,
						1.5134271801816244,
						0.5465194427917447,
						-0.3149903006657598,
						0.1434189748242402,
						-1.0035086869944407,
						1.0166539521943072,
						1.1744702681102117,
						-0.1177955699582005,
						0.7104468538001846,
						1.4177630126829364,
						-0.1753997868933129,
						1.3779257285761337,
						-1.6176186481083892,
						0.2877192216696633,
						-1.3568154309913276,
						-0.36503390580775213,
						-0.7967288331412882,
						0.36896394727168924,
						0.3009603982784814,
						1.0575867321934727,
						0.04774780949478701,
						0.041345163420357815,
						1.4706661163633248,
						-0.3592209580605673,
						0.8946353836412396,
						-0.37326166222198043,
						0.5401698571004074
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.4542830583110405,
						0.19418968122706648,
						0.41551208370244913,
						-0.4353889288516318,
						-0.10560127398606689,
						-0.26101595685284923,
						-0.1961587055224848,
						0.8760324061623223,
						-1.0723342806033596,
						-0.8338243952639385,
						0.5745821053751863,
						-0.915201091611741,
						-0.13394031045611843,
						1.1027277192213287,
						-0.1471622327560458,
						-1.9324689056723066,
						1.3467080620936087,
						-0.8931613768039106,
						1.0139251598276486,
						-0.4548796113611342,
						-0.24943033048374208,
						0.07820513926622528,
						-0.1295328141265668,
						-0.07573388301426924,
						-0.45969265334127196,
						0.6407690198720899,
						-0.45561180815479757,
						0.10688908234192784,
						0.1726749850372735,
						0.7544446978358722
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.32812130857598976,
						2.0234260887378404,
						0.08712083390920046,
						-1.8095096484806892,
						-0.3575501296405161,
						-1.6091942146234515,
						-0.6006445865646134,
						0.5243946930647588,
						-0.401332368757956,
						-0.7164207081400239,
						-0.7874018052297829,
						0.6377631031619098,
						-0.3839920945505433,
						-1.5136100035187328,
						-0.2891386992441395,
						-0.05972774696738976,
						0.46993048598049886,
						-0.5268304266621379,
						0.2044174578684214,
						0.72078751860911,
						-1.4517882261423953,
						-0.6726059834142878,
						-0.18144155460836345,
						0.12222877015082624,
						-0.254310439890153,
						-0.08343267009821699,
						0.8222002365391798,
						0.6043701831425861,
						0.1760153679030624,
						-0.6584688092784895
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.17790545177663422,
						-1.153491568965199,
						-0.9932378954163795,
						-0.06924256179638075,
						1.0429095982470302,
						0.24724669533872484,
						0.5407646675102651,
						-0.2154343146475504,
						0.845822593497485,
						-0.8593488118766653,
						0.21680275898054982,
						-0.3531509467606616,
						-0.45151016480434436,
						0.15436795906079095,
						-0.9717736452777251,
						-0.2873510832151792,
						-0.021105185567266444,
						-0.8090155377545049,
						-0.14064681001744056,
						0.4962794260471763,
						-0.6374928035843248,
						-0.06018386613748385,
						-0.20067751382812396,
						-0.6808484806115179,
						-0.22399127054630574,
						-0.789149052547107,
						-0.5537253040780691,
						-0.2326490516890189,
						0.9795649464575482,
						-0.17827302173223414
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.8193191102609867,
						1.0180106507158224,
						-0.7558758771643094,
						0.9262935413535196,
						-0.10713318917251129,
						0.21064265911585817,
						0.25467439693204413,
						0.8269709971538022,
						0.23266021945206344,
						-0.5667958599867935,
						0.3469741652871821,
						-0.23254210077807408,
						0.6123836438811028,
						1.153934952262869,
						-0.9417370607490382,
						-1.113110470638813,
						-0.3481910485121275,
						0.963108911561098,
						0.3813002932105637,
						0.6151808861006907,
						-0.880039332692232,
						-0.3106581585476171,
						0.7108864111041032,
						-0.24714111252798396,
						0.6027480728349343,
						-1.405958659030703,
						0.032912278342139945,
						-0.19950186087935406,
						0.8440020911017145,
						0.9239745052173379
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.774614754425988,
						0.19512778317790486,
						-0.14348957902766635,
						-0.6223740512893339,
						-0.0878914181530278,
						-0.9514942399093458,
						-0.17105730289442025,
						-0.07286506598252591,
						-0.6810256465448785,
						0.41563855776769115,
						0.18669079819002743,
						-0.6213868780969369,
						-0.23637722562518382,
						-0.5936388452127993,
						-0.5441545841326243,
						-0.40121864729822887,
						-0.8159893568385715,
						0.04033151185785139,
						0.5950756457674001,
						-0.11535486775636533,
						0.3316253508976494,
						-0.2959852039255468,
						0.4478564133090056,
						0.1519746211401501,
						-0.35720358231341015,
						-0.756790901541639,
						0.13460203736844545,
						-0.3481517457388292,
						0.8381911859034885,
						1.3226735834160597
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.5883050791388884,
						-1.3459865415972556,
						-2.4600540421007113,
						0.9284961435751671,
						-0.3110378569142791,
						1.7832467267042298,
						1.1822083725969186,
						-1.4210975617393147,
						0.22373348092955875,
						0.2282660699898652,
						0.37962422212583974,
						-1.6586271068378404,
						0.3202177696126388,
						-1.1296512057908572,
						1.0886681884915441,
						-0.4877219624571481,
						0.6563947180499825,
						-0.4810512748678658,
						1.223019500895001,
						0.5356565428160588,
						-0.02958405106543526,
						0.967648829886613,
						2.0522940165230397,
						1.2798815638114562,
						0.12329659993081665,
						0.42504403301888427,
						-0.22053654105521298,
						-0.6492950317395847,
						0.23366550150690332,
						-0.1557872394339971
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.4260550688481783,
						1.4231208570173206,
						0.41154660756094913,
						1.1095745539294963,
						-0.5523145206554474,
						0.11471562793526291,
						0.7098780894565162,
						0.5538545099920363,
						0.18967427608099446,
						-0.7932061839244225,
						1.045603297307151,
						0.7723633901009653,
						-0.10940916723218905,
						-0.6386047183619517,
						-0.583115250683753,
						0.47064353224866873,
						-1.4754867965312304,
						-0.5072274683056315,
						0.20022481149790397,
						0.9437322542489023,
						-1.6967456382451864,
						0.5004888986876659,
						1.03933339459085,
						-2.060806132920932,
						-0.14240959081932097,
						0.09797432075117007,
						0.304552093520715,
						-1.1200385462923035,
						-0.34311057607075535,
						0.1733735033968782
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.8286886391722975,
						-1.5643183400999845,
						-1.7197094082442208,
						0.320312526093717,
						-0.3451979068816307,
						0.2442901861584767,
						0.5853539702927988,
						0.11443762118091846,
						0.639010922025522,
						-0.9837281833412955,
						-0.6345109104386422,
						0.7379973842124935,
						0.9615999639706198,
						0.44692751451830337,
						0.09368104509602658,
						-1.5729960315438294,
						0.026841584476317203,
						0.4959255863549402,
						0.7727750691132317,
						0.7116181927125924,
						0.7463113132301004,
						0.284587015286263,
						0.345275897484758,
						0.7578494961885287,
						-0.5183684219300595,
						-0.32547763368876603,
						0.8649850317674141,
						-0.739876211945039,
						-0.038156682206202656,
						0.7370366402785054
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.14689212515525693,
						-0.07332941997814198,
						-0.3094305923777814,
						-0.11899968555183589,
						-0.2013286510607123,
						0.00069895847295247,
						-0.13648245079030988,
						0.2402738925815444,
						-0.1877830567278852,
						-0.10610593425368546,
						0.1263612878417328,
						-0.14668298869635835,
						-0.2636113069323252,
						-0.4037849502806026,
						0.039559748217933156,
						-0.9005620452878922,
						-0.061758490461200154,
						0.19881212568533926,
						-0.38339435871532906,
						-0.08399718226485978,
						-0.235581834942374,
						0.26104130700424716,
						-0.20583551569435107,
						0.13005265352990872,
						0.029152817495253683,
						0.018079039014849148,
						-0.06361080053366604,
						0.18844472610568452,
						-0.11462710728880465,
						-0.07540173799327828
					]
				}
			],
			"biases": {
				"sx": 1,
				"sy": 1,
				"depth": 30,
				"w": [
					0.9188233459974123,
					0.5377726114907723,
					-2.6917453646611937,
					-1.7735693581324454,
					1.9061285951998148,
					-0.24188573938346325,
					-0.7742029075176966,
					-1.0766265572926934,
					0.6066595910207381,
					1.106427894247832,
					-1.4765076513417994,
					0.7801136954821493,
					-2.577063737076782,
					-3.268187982823741,
					-1.4518227032198514,
					-0.34791797959518095,
					-1.0143590384952332,
					2.636170089707624,
					-1.59612389952813,
					0.16923649041301708,
					-2.5698355001710698,
					0.43953348971280165,
					0.38418862684373034,
					0.9621480325748181,
					-1.6910229546118676,
					0.03299656163379739,
					-2.098230003604424,
					-1.0573246357227606,
					0.5342737951354916,
					0.27516785998225785
				]
			}
		},
		{
			"out_depth": 30,
			"out_sx": 1,
			"out_sy": 1,
			"layer_type": "relu"
		},
		{
			"out_depth": 30,
			"out_sx": 1,
			"out_sy": 1,
			"layer_type": "fc",
			"num_inputs": 30,
			"l1_decay_mul": 0,
			"l2_decay_mul": 1,
			"filters": [
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.12855049208084393,
						-0.4598920903252786,
						1.7100722347167938,
						-1.2437320498550493,
						-0.5274026139244995,
						0.4096126388437598,
						-0.2149564035188655,
						-0.6283227263153798,
						0.41122221342218773,
						0.7058611550402515,
						-0.06650950149112977,
						-0.25133114202084605,
						-0.5233796559779863,
						-2.634201167425365,
						0.0021080302113084424,
						-0.6716606154085587,
						0.016254501788591887,
						-0.4415485685376648,
						-0.5711734918992087,
						-0.23874960418417437,
						-0.136772465603318,
						-0.5180302132463586,
						0.1098199661465932,
						-0.6403152317704284,
						-0.6880965217118654,
						0.2623402793181338,
						0.018834952712274755,
						1.000204710744833,
						0.35782875891848714,
						0.04238452198328942
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.4843451535067105,
						0.595201270235712,
						-0.026952756543552076,
						-0.18159200290834396,
						0.12124612697354707,
						0.20267621471409472,
						0.6930931047930775,
						-0.5097775903113962,
						0.30037850759938517,
						-0.2653003915759451,
						0.24588029502946204,
						0.2811633668122837,
						-0.6254418003515838,
						0.0796096643457192,
						0.46031172512159396,
						-1.5560823314730008,
						-0.7531305777146499,
						-0.3989925792057314,
						0.4467062833711984,
						0.47412972150432203,
						-0.5299799294324687,
						-0.2857610127021978,
						-0.40249298257399085,
						0.08400439379713735,
						-0.48593148991081603,
						-1.1355543638665853,
						-0.7100727729725387,
						-0.5716331176344583,
						1.501909874518707,
						-0.3523582441018625
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.8104113899455959,
						0.8674259073836774,
						-0.5003905250490636,
						-0.9493681953257836,
						-0.12339455211408275,
						-2.2536412650443562,
						0.6185151265547841,
						0.10366344692445909,
						0.4289506336277201,
						1.1265180583855692,
						-0.018065272946411373,
						-0.1997072845698708,
						-0.1019677482869363,
						-0.5539028115865684,
						-0.431640827159185,
						-3.6461404299290403,
						-0.4070047562422578,
						0.4478166572159215,
						-0.3960436724197355,
						0.2539505680341919,
						-0.5026525526402649,
						0.1161917153096243,
						1.024379648907362,
						-0.6730413149862463,
						-0.3738106352441694,
						-0.5464849395056791,
						0.4408834757347639,
						-0.9945668117167082,
						0.7596500850854329,
						-0.4625083950983929
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-1.105919806378582,
						0.45853944172732275,
						-0.7995713933294494,
						-0.6461444854157596,
						1.3647162265536348,
						0.40720400073838775,
						-0.869135928159533,
						0.1233512948215627,
						0.26534939649047545,
						-0.37688782118746533,
						0.7663906893585432,
						0.4049053782457027,
						-0.28346259965119025,
						0.8832714039976817,
						0.028532720341991714,
						-0.6846015190715112,
						-0.2748765459003187,
						-0.32879579368158196,
						0.37615860687402003,
						-0.9848619065075078,
						0.2479412992708201,
						0.4746720679230388,
						0.7269149660186267,
						0.6184039621093791,
						0.3551821945140083,
						0.35548213720052413,
						-0.9971282531928856,
						0.7489180723031552,
						0.14834856036790844,
						0.12589520652012443
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.6267452012160449,
						0.51732402377989,
						-0.35258473450022476,
						0.7423486110285519,
						-0.6458271918352062,
						-0.7828652365464955,
						-0.13681803736979126,
						0.6450321188672689,
						0.5416939359524753,
						-0.02987284098307075,
						-0.7553068844134194,
						-0.4661007895359703,
						-0.219183358208793,
						-1.1447560882846506,
						-0.1953493400287965,
						-0.2606719243406879,
						-0.2380044518475015,
						0.44823569483171505,
						1.4171335843266928,
						0.14331467999551273,
						0.8039359591892928,
						0.2921628853983919,
						-0.820911449607666,
						0.19307781291603968,
						0.026137202021969414,
						-0.13983984710124053,
						0.3466637134147772,
						-1.1044159652027998,
						-1.1794585898425491,
						0.1661119520639953
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.08676391446542579,
						-0.1657596306803991,
						-1.0628390375214642,
						0.4298128869329326,
						0.5076279890515415,
						-0.027459069518255042,
						-0.7662607182607987,
						-0.6249192579266196,
						0.06228482451263359,
						-0.1640603360989121,
						0.849404924889669,
						0.6557983029930476,
						-0.14634384680698842,
						-1.433742652044824,
						-0.7701979027738596,
						0.4458661378053269,
						-0.11930261700460591,
						0.5211281798384414,
						0.009226643655918075,
						0.9048113196295056,
						-1.8692441374424489,
						0.5710174763658187,
						0.6431045114828626,
						-0.16057741370117248,
						0.0052401360126616186,
						0.4020239710176755,
						-0.13372460642468004,
						0.060002449620119254,
						-1.1284598610214203,
						-0.09652684934580717
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.013527843813945725,
						-0.7012845358059105,
						1.7676455927003931,
						-1.2864061170926377,
						0.6312075755787291,
						-0.27673816009548796,
						-0.25341122634658453,
						-1.0347706579753895,
						-1.3773342661029575,
						0.8999211656078859,
						-0.6846034861934275,
						0.008034770317043315,
						0.17691806871478313,
						-1.5574145795106578,
						1.0763393822414935,
						0.6847353020822262,
						-0.43280967564968087,
						-1.16840870858622,
						-0.22590072758956975,
						1.1525478329716319,
						-0.8077614508790696,
						0.17151329213163208,
						-0.2789610951979134,
						0.19778497079796545,
						0.3322807277825764,
						0.1659351074911697,
						-0.3744898092492429,
						0.7548558464210747,
						0.8303967003909124,
						-0.1150590235430258
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.07320401041719025,
						0.7133936509772842,
						-0.23240740954758995,
						0.090633712415715,
						0.5849377827100806,
						0.12130133993193275,
						-0.20073541498320752,
						0.006164718768670225,
						0.14438972520590224,
						-0.40911448887736707,
						-0.17177289722700487,
						-0.1191913922824406,
						1.1923671352936855,
						0.009564887729915953,
						-0.8249347509888766,
						0.5157152210580265,
						-0.97873116803743,
						0.9148491448971529,
						-0.26877909548694984,
						-0.33844525898176203,
						-0.6821667533282414,
						0.3159586232119369,
						-0.6009337141241383,
						0.19482949960657958,
						-0.7495879619016514,
						-0.22948824238021678,
						1.034746292008563,
						-0.008848143115560893,
						-1.5893090038950768,
						0.21723136912471097
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.030679058003702908,
						0.4657687936075501,
						-0.15561568757783484,
						-0.7156242848795066,
						0.32880052216733446,
						0.9453464927445323,
						-0.06214443173285309,
						0.22230287554935335,
						1.203352138130337,
						0.8905870888362909,
						-0.031037243638548827,
						-0.30536144945577753,
						0.04949747643553933,
						-0.21812537108969535,
						-0.10396881771204965,
						-1.1116796303137597,
						-0.6087118782160469,
						0.6453125692124325,
						-1.1977585040465268,
						0.6559230703250377,
						-0.14741974638202734,
						-0.1270048984514693,
						-0.5140776371060878,
						-0.6065874319104018,
						-0.6252805912640675,
						-0.060267814898738635,
						-0.21738220650295131,
						0.0009374580727744711,
						-0.8441095160267843,
						-0.16741021241499254
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.10692591414789243,
						0.03924475104005719,
						-0.8357236124661646,
						-1.457631316386477,
						1.1845751244210916,
						-0.33952519833129563,
						0.019984066551930756,
						-0.578181625790944,
						0.14047627896619225,
						0.5072434786425012,
						-0.30381852166373663,
						0.841624951961045,
						0.86591619880107,
						-0.44770519111793655,
						0.5026108791331815,
						-0.8325557611714945,
						0.6350276665197996,
						0.1405249214878725,
						0.49174840938449543,
						-0.41634381778960133,
						0.017615837661493463,
						-0.3743577474933221,
						-0.5841849965265047,
						0.22194983409791214,
						0.13972400430261134,
						0.5453249764973924,
						-0.9275019115265194,
						0.3135724723477979,
						-0.21607904603528663,
						-0.11605475797029603
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.14061242810464333,
						-0.7617206745168605,
						-1.1560312753931914,
						-0.368679021584234,
						-0.45458596206277996,
						0.22193986629204332,
						-0.011343992664165341,
						-0.3089745963144093,
						1.2773969839118549,
						0.5068628465152126,
						0.18243838475883137,
						0.6779032266488573,
						-0.49346945773096945,
						-0.4586443199878859,
						0.23843744123173516,
						0.6549488051251727,
						0.6343598410414599,
						0.018767383560099493,
						-0.669806703523162,
						0.597162219824966,
						-0.6039043077093461,
						0.22826404115621846,
						0.9465460534996087,
						-0.2809527416138305,
						-0.5379397272784415,
						-0.0943046117117979,
						-2.7783798009936107,
						-0.39349066519385745,
						0.31758762332556545,
						-0.02124355802746193
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-1.0810244677236722,
						-0.5913513996670364,
						0.772972545337439,
						0.18589264822646157,
						0.3599980701180239,
						-1.5835703262671734,
						-0.21701167627616794,
						-0.6889993991219444,
						-0.03771704463437615,
						1.2983305930506963,
						0.33530116161283174,
						0.21590302454864224,
						-1.3200384256874151,
						0.5698746363247618,
						-0.24703118832575366,
						-0.37059870064889383,
						0.3383187542850562,
						0.19973242590624884,
						-1.4370561315419983,
						-0.38819806002178076,
						-0.593984387843161,
						1.1283598843884315,
						0.4319369044593901,
						0.4752272496702145,
						0.08863156253137187,
						0.5348824570597663,
						1.2500726933354342,
						0.18163245912268988,
						0.21821463889711948,
						-0.31199093457750476
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.18608600946256082,
						0.04189042568997399,
						-0.5256566269841981,
						0.22644479869220327,
						-1.2164555695732457,
						-0.5919600777030476,
						-0.4981843802828333,
						-0.38442244217546473,
						-1.606032271716581,
						-0.2517241340534458,
						0.9068344064416574,
						-1.177925944259618,
						1.4965205287572838,
						-0.6758933743400979,
						1.1786366327105124,
						0.8671449199268151,
						-0.4900293841311059,
						-1.0081239451809334,
						-0.27978598960648465,
						0.20485673588662107,
						0.3620838715406433,
						0.6091513373653037,
						-2.1614986120752886,
						1.0237473582981573,
						0.17270185380968414,
						-0.606986755475773,
						-0.2098097098552685,
						-0.10310020344074053,
						-1.2003600860055168,
						-0.3270649974413295
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						1.042023587727775,
						-0.1923038389884874,
						-1.4380124412036985,
						0.32079695125473745,
						1.1575884549402597,
						-0.45985994077984,
						-0.5816607576174216,
						-0.40612682760609586,
						0.4115778317661887,
						-0.6900553673405598,
						-1.2547715788278022,
						1.1500119649551055,
						-1.8829778469310183,
						0.26611568805094626,
						0.46673662918744374,
						-0.7636720203642802,
						-0.32113340541432217,
						0.5068226370160983,
						-1.2058413142186972,
						0.6141682260208572,
						0.6084679482575369,
						0.04550440606518176,
						-0.592861339356331,
						-0.8674527365447134,
						0.40419149687922296,
						-0.16360273980557705,
						-0.48495059816570596,
						0.3389233387492764,
						-0.3186286474172501,
						-0.20433065825850982
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-1.210609098364789,
						-0.5403393391059448,
						0.5963806961840961,
						0.9458867337777319,
						0.13568988823711542,
						-0.051883509838690486,
						-0.8732365615598199,
						-0.6804329589146075,
						0.4501846980230516,
						0.14086752862042162,
						0.6423067223070804,
						-1.2687214457906617,
						0.6297765091410252,
						-0.22661910001760918,
						0.5403183895029321,
						0.3375460488915926,
						0.07207618985301703,
						0.5153643616114667,
						-0.02005063872424862,
						1.3563302255666687,
						0.6131089314537511,
						-1.0723535906558561,
						1.1946791243171544,
						0.3719850547854542,
						1.2354274489794945,
						0.31098100465815276,
						-0.8869598119627733,
						0.9278498404282,
						-0.42994043074245075,
						0.2740221087378419
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-1.3392297796008517,
						-0.19211384404023227,
						-0.4382248741547753,
						0.06721924532249159,
						0.06837582726309475,
						0.7783111083905494,
						0.10188138541151343,
						-1.5555699418587494,
						0.21456947459364986,
						0.7123792923981582,
						-0.3782417497206128,
						0.6802123080400666,
						0.6699895431741977,
						0.40519679519128227,
						-1.1235131067435904,
						0.7625776382618096,
						-0.3681934162315919,
						0.7937961043986679,
						1.2782272374158992,
						-0.33430226290994763,
						-1.466039884571583,
						0.3360257762913001,
						-0.0458694557320467,
						-0.40581031050923116,
						0.09599848890631936,
						-0.23486550517659385,
						-0.3645978817473209,
						-0.7471779745584815,
						0.10204796448697229,
						0.2795131374900799
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-1.194348283394362,
						-1.0760623817474517,
						0.4716739226441965,
						0.40712641110461856,
						-0.20279110724142632,
						0.8153277131698905,
						-0.18674209623650165,
						-0.629249480475043,
						-0.043073851920022596,
						0.040569870260418,
						1.423078705749454,
						0.42359507492314136,
						-0.2788208384999063,
						-0.5446435219580481,
						0.6713925178972393,
						-0.43921168347367445,
						0.8887198243012197,
						-0.7451164030790277,
						0.32243379410965184,
						-0.4331005678335202,
						-0.3302476190485567,
						0.4130245756661219,
						0.5153190161395101,
						0.8544322504434516,
						0.1070334498875402,
						-0.16634262593082777,
						-0.29522195523554234,
						-0.01981908995818116,
						-0.7472766086436601,
						0.02138432567951447
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.8158288750660658,
						-0.41007261114812465,
						0.1127724613805661,
						-0.10591773288894366,
						-0.580676549052105,
						0.04158041950167036,
						0.05288715023263894,
						0.4861249194333239,
						0.6071983777997945,
						-1.7496848260900306,
						0.7091177296333624,
						-0.11422371921055054,
						-1.035781013129521,
						-0.3299465023764093,
						0.19123611802379525,
						0.4116046401443741,
						-0.08396628955545271,
						0.5318200583986352,
						0.3705082047034565,
						1.1232767253591014,
						0.6600291648796581,
						-0.31542036656935535,
						-0.010788301938751937,
						0.06502308210859363,
						-0.05689054332928758,
						0.15250706511879747,
						-0.3364473580433493,
						-1.5615806314857774,
						0.9928363636766043,
						0.04744919851577004
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-1.8674635542013722,
						0.3794750336186278,
						-0.19039023166186989,
						0.032085116861234844,
						0.5860757708611304,
						-0.8439418213644325,
						0.000990438318234408,
						-0.10669485010563762,
						-0.9795310561896062,
						0.6050748819613013,
						0.1869985208863135,
						0.4511055599183215,
						0.031142580698145083,
						0.5095158160749556,
						0.5477010603994121,
						0.14931125835317602,
						0.764766498599941,
						-1.0823618729436166,
						0.10468459529312871,
						-1.2231579268598947,
						0.08174034217612061,
						-0.3125918892544043,
						0.2369121417046539,
						-0.4827427844479757,
						-0.5972801265844552,
						0.028755277978557245,
						-0.4516077208448601,
						0.12054847206689212,
						-1.5125536663732289,
						0.10045998811204485
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.9126611702417954,
						0.397157189500005,
						0.4472384028005959,
						-0.22170031820711766,
						0.48029616743918957,
						0.694084348255022,
						0.002893967588733597,
						-0.37071411482730154,
						1.2148074519581349,
						-1.1203352069622121,
						-0.03491734606398255,
						-0.7885339314118763,
						0.11996098844156036,
						-0.5053727433966445,
						0.5944680452496874,
						-0.07098856614371961,
						-0.5213344736859727,
						0.39367446470969003,
						-0.010793439183651101,
						0.8301622835794961,
						1.3214116617030185,
						-0.6135216216966906,
						0.5156064390931915,
						0.5026128715273898,
						-0.9957125268652814,
						-1.0157027479367102,
						1.3127184451367873,
						-0.7563618902005363,
						0.41662527814214934,
						0.2052084710991375
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-1.0133603327225982,
						-1.728089289806384,
						-0.267766399080347,
						-0.1578244889132609,
						1.475663471561164,
						-0.26857852347842676,
						1.4290986128326695,
						-0.15563266908166182,
						-0.10120044467734379,
						0.32262418240421126,
						0.5018283792437643,
						-0.7052435226714155,
						0.7254122739335848,
						0.46939294991617553,
						-0.981938475553817,
						0.6985123276164367,
						0.7242411708224077,
						0.02532093893045929,
						-1.469190750107507,
						0.012598405122732942,
						-0.9375029037529286,
						-1.1116101708831134,
						-0.09289659474709494,
						-0.6736006223013626,
						0.4090783064131798,
						0.3433544515736223,
						0.29178665646315716,
						0.2779124324729759,
						0.09290845647064613,
						0.36181899160065273
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.9870853480936767,
						0.6926922885059604,
						0.31804148208269073,
						-0.6706202387998816,
						-2.2528729095795397,
						0.46286255144970323,
						-0.39007464633091515,
						0.3341188691536972,
						0.11841615772447023,
						-0.0688090716804646,
						0.18907720239797468,
						0.43382593594438856,
						-1.4979946255797711,
						1.1721994756942158,
						-0.09650877955651917,
						-0.2999238839990547,
						0.4816272533906618,
						0.6927304343190648,
						0.3881281920021847,
						0.46542223833563223,
						-0.24256679783269477,
						-0.3619275900206311,
						0.24828020824090472,
						-0.43681335739897,
						-0.45146170427968385,
						0.5197169786146453,
						-0.8007465229474123,
						-0.5964771576861945,
						-0.25350389068365137,
						-0.5885906099172146
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-1.2585807788497023,
						-0.4059501723372229,
						0.11291156174861663,
						-0.5617496378624305,
						0.6919071218729549,
						-0.4584663673962197,
						0.17424088160133158,
						-0.11542159339979641,
						0.01355199376455713,
						1.3242001221152075,
						0.33801035276424424,
						0.1712113049795036,
						-0.356707707798761,
						-0.13100915262432528,
						-1.8612110242746975,
						-1.6867008981512055,
						-0.2382438593408426,
						1.2549751610098112,
						1.0548725137784118,
						0.3756141472905931,
						-0.9567087167854944,
						0.2654098239874881,
						0.14722315754649098,
						-0.40267978288976364,
						-1.3013269435314707,
						-1.0946001671966314,
						-0.27376600995452305,
						-0.29522070875504036,
						-0.2128168432496003,
						0.18059744510139986
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.39667744809684563,
						-1.2991204738497575,
						-1.3176833152317775,
						0.22051068018651454,
						0.5263175916368673,
						-0.13496381814428515,
						-0.24562757768925092,
						0.2634924963917235,
						-0.20614516075679726,
						-0.02812876418650167,
						-1.8016599814507672,
						0.30377248653871725,
						0.3984110471853356,
						-1.3015419137496431,
						0.42317010725863835,
						0.38682929875847344,
						1.25816608204887,
						-0.09239511703113273,
						0.09083953474019013,
						0.383517326554067,
						0.31682479248331746,
						-0.28187484435238314,
						-1.0940526528206127,
						1.2628188954489343,
						0.5294572597071622,
						-0.4051101960452701,
						0.23995308735729567,
						-0.056756661013489626,
						0.20112587022600345,
						0.16259912654944939
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.6466183393659061,
						0.709536711077356,
						0.10891825668602571,
						-0.07082394624878317,
						0.24279250883532963,
						-1.5206797829065068,
						0.7247530916674398,
						-0.7889057022190611,
						0.8797235296099346,
						-0.7198869022494384,
						-0.09037766240985037,
						-0.6172602387538696,
						-0.5378947730110042,
						-0.3602672081101326,
						0.6127791089943231,
						-0.08609264707799819,
						-1.0811367353968024,
						1.0663565774477786,
						-0.47900922836294263,
						-0.016110737711076864,
						0.41266793189223344,
						1.424041730956673,
						-0.10617513418286745,
						-1.2939181365798325,
						-0.6011623294979959,
						0.39087438942158753,
						-0.5851572583745225,
						-0.6596260339209586,
						0.5462815827942171,
						0.1731851167369759
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.19468764688059848,
						0.40687379338851487,
						0.5124790876707487,
						-0.31192403040659783,
						-0.31409706133856635,
						0.35779011270332456,
						-0.9724752547470642,
						0.2829468687127981,
						0.34650095776264206,
						-0.6936919600734806,
						1.1268676114943796,
						-0.6379639895911225,
						0.04290006765205355,
						-0.22340716571229374,
						-0.42126217662516174,
						-0.07087553490537674,
						-0.047429064221069725,
						0.8134831011387584,
						-0.5610374354881221,
						0.5427393302487488,
						-0.8354603673502313,
						0.6910828050255671,
						0.4552973466335616,
						0.13204931329572286,
						-0.28601849785522904,
						-0.4681288808956175,
						-1.1244900287889765,
						0.09295906471126272,
						-0.4696119230073107,
						-0.15422679591202365
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.47927566479882705,
						-0.20897816143542225,
						-0.5659542150163839,
						-0.1487522047780456,
						-0.2831958299763582,
						-0.9672124106255846,
						1.6891025462332214,
						0.3473955889030062,
						0.38757722961918323,
						-1.6296247459467366,
						0.4637805719738427,
						-0.16929778597566572,
						-0.8106407481157429,
						-0.11406155712914846,
						-0.16195949791414757,
						-0.3693744035834252,
						0.7831287441015085,
						-0.4405730119217363,
						-0.6192965790376452,
						0.8475956165326057,
						0.8299513167798006,
						0.19749577991696582,
						0.0159505341599267,
						0.023800328309791362,
						0.11974538117927867,
						-0.14543062578869487,
						-0.8639903641378461,
						-0.04723136545279812,
						0.181635941988541,
						0.3272310398252698
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.5518636518882591,
						-0.6877971752023885,
						-0.5997118815563995,
						-1.2442165999725527,
						0.6571385426486857,
						-0.2262015901618569,
						-0.4141429002506887,
						-0.07237433606588775,
						0.7292097960858686,
						0.10345612696338093,
						0.3862322432746248,
						1.0257734788713082,
						-0.9678056685975394,
						-0.11959398567442443,
						-0.6108525869854039,
						0.6215773650263804,
						-0.46043636910596036,
						-1.139675096785894,
						0.4452748407987314,
						-0.25225495364187067,
						0.8989111821298923,
						-0.8717228827596214,
						-0.5519410568810245,
						0.43463477955943924,
						-0.05567254014703207,
						0.6056841210333648,
						0.4910521737309057,
						-0.9093844372782136,
						0.2980069713837499,
						-0.1377723235461636
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.62206929407405,
						0.012730490241945641,
						0.08549832108353711,
						0.04562425732039573,
						0.12044129317179461,
						-0.9201283661648701,
						-0.33628053404573616,
						0.21537792418125196,
						1.1032499291043247,
						0.33088188472421537,
						-0.32944396222378,
						0.5959065070527698,
						0.7261071460393775,
						0.836579923822734,
						-0.42624595332361703,
						0.38345703828541355,
						0.2068697323173057,
						-0.08386184435644602,
						-0.42145470752741504,
						0.022958835079536055,
						-0.7163274771340513,
						-0.5621355350970663,
						0.07238576074123292,
						-0.027961647366280307,
						0.6417430753304871,
						0.32556871896274825,
						0.12129708555903705,
						0.6335412555113673,
						1.161283921790348,
						0.39038165287432797
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.2277573825182128,
						0.526912769662215,
						0.15790608342727214,
						0.9782841580982525,
						-0.5279081073770808,
						0.1556009918002506,
						0.7197002741479117,
						-0.095231513817296,
						-0.3060766159675369,
						0.6459374206029042,
						-1.0940992563846312,
						-0.12870458933933387,
						-0.0782627128697891,
						1.5745685762329837,
						0.9528841543332541,
						-0.7126969650777132,
						-0.6545556893919121,
						-1.1090091229362231,
						-0.153854000334884,
						0.41128761844805356,
						0.7443560215290023,
						0.1619550001840824,
						-0.8747722715554487,
						0.7326373240980604,
						0.6001339649256634,
						0.3020779324613451,
						1.4311098095981916,
						-0.4889826973286724,
						-0.6456710405902781,
						0.05334676684817479
					]
				}
			],
			"biases": {
				"sx": 1,
				"sy": 1,
				"depth": 30,
				"w": [
					0.6015941441113677,
					0.5402932730136649,
					0.5278613261102107,
					0.41528223395092745,
					-1.2830508770092923,
					3.385281087739231,
					0.8184743071187195,
					0.025026102555996493,
					3.1115904806297228,
					2.3336447498348534,
					4.264145811346213,
					0.10520291876396143,
					-0.7058544845823919,
					-0.18633076934716397,
					-2.3454270220827795,
					1.5269155046576168,
					-0.14476941265520726,
					-0.5316361958649424,
					-0.8248871654796014,
					-1.4632326931215167,
					-0.9840447923198098,
					-0.004946982064841259,
					1.0340114390461648,
					-0.038709526524571915,
					0.19213841138008095,
					-0.7463484497517818,
					2.316605369765384,
					-0.8640996290254784,
					-3.779973432135328,
					-1.8151831944641408
				]
			}
		},
		{
			"out_depth": 30,
			"out_sx": 1,
			"out_sy": 1,
			"layer_type": "relu"
		},
		{
			"out_depth": 30,
			"out_sx": 1,
			"out_sy": 1,
			"layer_type": "fc",
			"num_inputs": 30,
			"l1_decay_mul": 0,
			"l2_decay_mul": 1,
			"filters": [
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.10924130716264199,
						-1.04476878669925,
						0.1587775302981532,
						-0.1803950840861468,
						0.5063235255174492,
						0.4148961035980386,
						0.15958779475607687,
						0.45816525718213796,
						-1.2052438779748058,
						-0.3589045550711125,
						0.4310608964457812,
						-0.9139603845446663,
						0.08507011079208336,
						-1.0361769299110608,
						0.9018422718696819,
						-0.11447844626698615,
						-0.9055926588396304,
						0.6021527619278036,
						0.06689965827501496,
						-0.7530618992677576,
						-0.15160817224474887,
						-0.7971455891109032,
						-0.9345270600764691,
						-0.7446910202761557,
						0.5140634418607064,
						-0.835679303952842,
						-0.5533569520978067,
						0.17274313055744855,
						0.8894922948552507,
						-0.9034793683300681
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-1.2099937386550546,
						0.4148098386595548,
						-0.19117102014196882,
						-0.10081608065557274,
						-0.19580706600586942,
						-0.3898689416417657,
						-1.3485151033846392,
						0.16833240855814235,
						-0.8878144278732825,
						-0.015764241115190463,
						-0.19822002870410382,
						-0.8011215190864719,
						-0.8263896894804138,
						-0.6526137880981875,
						-0.45279063837092937,
						1.0332324041058778,
						-0.1547925380238822,
						0.3163545601563034,
						-0.28416709778887617,
						0.4704016402846945,
						0.24119805572830041,
						-0.20462915326466483,
						-0.10625168189442423,
						-0.6629962572452047,
						-0.30156227321262785,
						-0.44598308202020703,
						-0.8667027643276413,
						1.0874268755095193,
						-0.36300834904600465,
						0.38468549269914
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.2750245797440904,
						0.6754845405673499,
						0.26947208190068,
						0.48097516094502013,
						-0.636588301970263,
						0.4864197949567584,
						-1.571964558607701,
						-0.23073925023852268,
						-0.7380041746830719,
						-0.21613076863258152,
						-0.1728586760366336,
						-0.36309100066612904,
						-0.12262628247770917,
						0.23220582863179687,
						-0.3204302721851373,
						-0.4200486005180217,
						-0.19155072063351503,
						0.9593559420294597,
						-0.3372135621355002,
						0.23490432303326333,
						-0.7090788760400841,
						-0.1138039229866911,
						-0.07919702726596044,
						-0.31546228110697966,
						0.7825656159664102,
						0.3402741484261601,
						-0.10930317977315789,
						-1.0341662762917032,
						-0.43873881172201595,
						0.010137345182370302
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.7470641209597879,
						-0.529132116605555,
						0.3396702058561768,
						0.3429593505397934,
						-0.1162842050406821,
						-1.1872953777512356,
						-0.07700545629245349,
						0.11011354137555673,
						-0.807162484593969,
						0.12751197450693483,
						-0.06784078041916182,
						0.12120483085519049,
						-0.367624747863665,
						0.032643127474829864,
						0.6996018969579305,
						0.2448517927790078,
						-0.45110381664572413,
						-0.21258183324026245,
						-0.4287061955080569,
						-0.9727487992772602,
						0.11382021392957647,
						-0.007152769155164035,
						0.039079446015869115,
						-0.5164555746928927,
						-0.09104653444505045,
						0.40175794906495155,
						0.842659285964609,
						-0.24211610304782163,
						0.7042255865347643,
						0.07051244381486077
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.5826594706594309,
						0.24548506948724583,
						-0.48038468247778093,
						-1.1492545761869406,
						0.3003009927401018,
						0.5623989310182315,
						0.6602490629895428,
						-0.8656253054798271,
						-0.35865907041069156,
						-0.6374005438618915,
						-0.012813694583788246,
						-0.19224928985637738,
						-0.39452718500170064,
						0.11985475702323727,
						-0.6842890087797292,
						-0.14019493330762695,
						0.04943132026256784,
						-0.9768452608489092,
						-1.1322817067228663,
						1.1474613076054392,
						-0.2914746835140328,
						-0.6246511067178034,
						0.4488146909326212,
						-0.6368336437466505,
						-0.10079473779156646,
						-0.7136458269382004,
						-1.0249421537873546,
						0.19107891620587883,
						1.1399525412705662,
						0.7789844595268254
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.4830720335171241,
						-1.1127571243984817,
						0.6496289614806678,
						-0.1132323060807089,
						-0.803415369486813,
						-0.7966991458809994,
						0.35988639455392907,
						-1.2329563490980033,
						-0.6605188858878915,
						0.3794121587259155,
						-0.35686843211476565,
						0.22299368746018414,
						0.2963499746632362,
						1.3464073817312319,
						0.590073457313771,
						-0.6007720074145908,
						0.3030824669562831,
						-0.5524132379226212,
						0.5067638494789288,
						0.08783629122073684,
						-1.2650697012245615,
						-0.2625371385896134,
						0.3905303034772371,
						0.2631456459620173,
						-0.4320174509891077,
						-0.44839455676340373,
						-0.2687391380555399,
						0.020242667167181195,
						0.3478074824618861,
						-0.943273553731767
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.4941271608655275,
						0.5674416447081012,
						0.5656304260018202,
						0.1040224170754705,
						0.12221007825748827,
						0.41448015938561267,
						0.9602039976913591,
						0.3708475308426995,
						0.15211249139421262,
						0.19294798182113018,
						-0.9804752763773578,
						-0.3451973293945674,
						0.37295296864673105,
						0.1618140627479227,
						-0.46862706268807525,
						-1.7153946746596644,
						-0.8121092642279418,
						-0.20133146101566335,
						0.24784471806956054,
						-0.6347890486546515,
						0.6418002598229628,
						-0.31551795259034654,
						0.07592878132425217,
						0.36907365321738317,
						-0.41313621675301415,
						0.11270091232418354,
						-0.46221136676368063,
						-0.32340288072207285,
						0.5851485169824895,
						-0.2488184039133981
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.8689992613620905,
						-0.47126943547080713,
						0.2979640072581206,
						-1.802589525955453,
						0.8635869789925258,
						-0.3264470829686504,
						0.5510383152906183,
						0.21435466974964168,
						0.33495687349619313,
						-0.9122637869287525,
						0.8078969722465291,
						0.2514734944380391,
						0.7481876497102852,
						0.40191667143517923,
						-0.17203521122125032,
						-0.483188972041157,
						-0.010854201531865046,
						0.7718937556792465,
						-0.4610497623707955,
						-0.6717412884893361,
						0.32343895824304364,
						-0.20418947486209074,
						-0.623122661056201,
						0.06598129885294707,
						-0.31220230872574933,
						0.2540829774355598,
						0.01893723984725304,
						0.6286236821501209,
						-0.19776039676786503,
						0.8012996813060249
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.05749314638941825,
						0.10220542925330406,
						-0.17833519886596405,
						-0.8905620015665736,
						0.7911462803236047,
						-1.5114308176749283,
						0.14126426330244887,
						0.6119264522857767,
						-0.6059875568877611,
						0.05161098184526501,
						-0.5303231718818917,
						-1.8560513424772123,
						-0.22477164766165456,
						-0.17732575721109606,
						-0.23113868372829666,
						0.6539433390500381,
						0.29502568209107727,
						0.5397198867285207,
						0.46851666599318953,
						0.9338475316425829,
						0.4979944585931993,
						0.6365421199580341,
						-0.5418501659775781,
						-0.050457917968626496,
						0.3924955658398102,
						0.537265244808382,
						-1.664973764427786,
						0.7338917853661542,
						-0.3908873825218125,
						-0.6749359836391516
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.5186888116971885,
						0.2792151694597655,
						0.58840426222231,
						-1.6551273372519684,
						0.49092794559984476,
						0.10413843708112351,
						-0.2535134143965335,
						-0.12581463995815467,
						0.4392475147890957,
						-1.1685982872341494,
						-0.19658170097653493,
						-0.9471012978633725,
						0.02105894747549105,
						0.13070942562383953,
						-0.26192111112555905,
						-0.5077020716626128,
						-0.6031257476065126,
						0.06324117171870147,
						-0.19565224102348153,
						0.3464932632805166,
						-1.3130151167743278,
						0.5049023984824815,
						0.29273370061808984,
						0.5129514362951673,
						-0.9311253175284036,
						-0.19506263277547076,
						1.3210821219271403,
						0.21173151389855208,
						0.1282089792391082,
						0.0890041269375438
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.08407505219031919,
						-0.35353746827623617,
						1.8465215309203755,
						0.3829852194191459,
						0.5507751069323267,
						0.07221907840573301,
						0.3738315699091491,
						-0.42667684438357417,
						-0.17394055008460207,
						0.17754846652040507,
						-0.22980259154041818,
						0.4090689867399651,
						-0.10687487816673023,
						-0.05030737704304611,
						-0.07684963826583809,
						-0.451407128014,
						-1.6550313146749374,
						0.23354659203282022,
						-0.8418371501992198,
						0.5189745979211431,
						-1.5265331428258064,
						0.19831677036321868,
						-0.3082915027037747,
						0.7535380412402739,
						0.6507692175004846,
						0.1088328732153245,
						0.24188397300920442,
						-0.40649064611440455,
						0.5767883616281516,
						-0.6552506368647749
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.31111589919960886,
						0.2069732113907537,
						-0.7642830284942955,
						0.2946528808385822,
						0.5930811792074314,
						0.10351703294652602,
						-1.4775089379271396,
						-0.14034332306351038,
						-0.5744832854485088,
						-1.1964093333909636,
						-1.5860640187266084,
						-0.9437075537493519,
						0.44590352194496313,
						-0.6184841024753674,
						0.6671023525387076,
						0.351481399892434,
						0.14861242270153563,
						0.25606414824467444,
						-0.07933774628332108,
						0.9553409133360888,
						-0.5147404903154359,
						0.09766890081476959,
						0.030121132907328138,
						-1.0483664898050895,
						0.8837879028702519,
						0.37787983969288746,
						-1.0829842699855965,
						0.25361016996058816,
						-1.4309541676989246,
						-0.15242045668074994
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.46864461824933684,
						0.24643170787306942,
						0.7779390934192335,
						0.008478630623538446,
						-0.401191947899384,
						0.363979522838547,
						0.26361589482175235,
						-0.6924566593541295,
						-0.31847335522946213,
						-0.26404299752053917,
						-0.22932980076050008,
						0.779854260772272,
						0.7735613244865576,
						0.5015146639612976,
						0.2028078878540421,
						-0.252998996916497,
						-1.3805475426789524,
						0.7173100153913368,
						0.09764972609001757,
						0.6263101813462175,
						-1.5013144180894564,
						-0.14124909624917065,
						-0.4509551175861157,
						-0.954558988224991,
						-0.5928365285314953,
						-0.515076093804096,
						-1.0191380693924414,
						-0.56078520338369,
						1.1048973653637888,
						-1.0313883085395792
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.8571944823433815,
						-0.07917921891261148,
						-0.22855186715265965,
						-0.06746959635902726,
						-0.131715542999836,
						0.0002677745751712092,
						0.3370064182574556,
						-0.27329463187143693,
						0.6291686093305119,
						0.7994898131660099,
						0.9236204432378579,
						0.03221016385253933,
						-1.2932470357944135,
						-0.06040233755416318,
						0.5175612003510603,
						-0.40680225905388817,
						-1.4521069670254811,
						0.5396427919260885,
						-0.3055132928167361,
						-0.16775154321908586,
						0.15390551579981404,
						-0.11670284252340901,
						-0.7501385982069066,
						-0.044256330820806655,
						0.5487894980232689,
						-1.1742136002909076,
						-0.37284571285162305,
						-0.9329214116106311,
						-0.46904063197258367,
						-0.10681031106926696
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-1.0775206114514408,
						0.45860440307619665,
						-1.1401105944351237,
						0.043126391977262916,
						-0.9311133850419593,
						-0.6315638143531498,
						0.6946748604244489,
						-0.9746837789173556,
						0.005481221896637744,
						0.529424324071335,
						0.3425496873566119,
						-0.9314730535011836,
						-0.10345713264760541,
						-0.84718823164094,
						0.9429207535615903,
						-0.3363739207160085,
						0.3948558303468473,
						-0.7581946188618529,
						-0.9902059251363869,
						0.22846737720097665,
						0.33654878499449636,
						-2.5470512262124716,
						0.9989864627256555,
						0.273076004317757,
						-0.6136926365983649,
						0.45555752830294005,
						0.5388314554218123,
						-0.330897506775964,
						-0.12462782888559794,
						0.10882300212467283
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.5884779083801673,
						0.09245748264186146,
						-0.07297625620563493,
						0.5374489449971446,
						-0.0928670087087411,
						-0.08420793032704958,
						-0.6780952076028868,
						0.03949402469974413,
						-0.15563810612329973,
						0.3386596307500685,
						0.4619574284229896,
						-0.19424565511987352,
						-0.39102342728161354,
						-0.9215911397045539,
						-1.2988638667455112,
						-0.15812934767839273,
						0.5634054583936915,
						-0.021435349946545734,
						0.960208761072178,
						-0.9452125025919319,
						0.18435743221650072,
						0.7326797925389489,
						-0.17192643134189814,
						0.1849549829771452,
						0.16927211371556497,
						-0.17911759765436666,
						0.3662087316989888,
						-0.6918220845512162,
						-1.1517883727603313,
						0.03465463985505413
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.6219408245560251,
						-0.8203096243791613,
						-0.866976119851633,
						-0.11206485214785393,
						-0.6287340832178802,
						0.2662322593211876,
						-0.659728829117994,
						0.02639257345690427,
						-0.597205599094897,
						0.17954326400834109,
						-0.6862264090773442,
						-0.5904392989296147,
						-0.9794844132365684,
						-0.5330554417502847,
						-0.2742833439364935,
						-0.19405928435592645,
						0.451450010242304,
						0.669134992411176,
						0.19823470014741304,
						-0.9114199086145346,
						0.4448895515582963,
						-0.09558631160772726,
						1.562025471128505,
						-1.9534576705463218,
						0.21010240942792766,
						-0.37878013329904436,
						0.4079297892287495,
						0.1082473328690087,
						-1.1898519447092049,
						1.2756889231418207
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.42458609455111046,
						0.1705864751005935,
						0.8952839105779773,
						0.38270495378792846,
						-0.3441988729300147,
						-0.3112618713363791,
						-1.1828531238952373,
						0.08093300012645381,
						-0.3293423425921186,
						-1.2870660961110283,
						-0.2648202885132958,
						0.6545099150740049,
						-1.9137228226151342,
						-0.16968117376106243,
						0.40602019639514747,
						-0.5361336773973226,
						0.23314022541104196,
						-0.177990185450466,
						0.40915893474652054,
						0.8412428750465099,
						0.20961157797116697,
						0.2800482359015421,
						0.10833569325937673,
						0.11461838749773814,
						0.5264529785002885,
						-0.3665446852810011,
						0.607652006816002,
						-0.0673392763061102,
						0.35734072701893543,
						-0.17978192706999044
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.7337914706157875,
						-0.6522840501822116,
						0.32973098385051075,
						-0.433162935680976,
						0.27500874666110436,
						0.2216939019959351,
						-0.12905831297655135,
						-0.43549917446136865,
						0.11906579652386402,
						-0.2880351897407974,
						0.20076010012169065,
						-0.4353907357739683,
						-0.15300858065047374,
						-0.2980909138631993,
						-1.3735122485062774,
						0.655625564544251,
						0.6509232578656665,
						0.9047124176997129,
						-0.04555727643454338,
						-0.4940280308407367,
						-0.154476966249879,
						0.537391092137752,
						-0.16598933548863248,
						-1.4875660601308773,
						-0.44250167512451266,
						-0.0853939946520432,
						0.2993836615501968,
						0.4472071615279667,
						-1.126960741819732,
						0.20438022894225968
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.6884768536720189,
						-1.056335065390629,
						0.8315935435437956,
						0.29507214259648606,
						0.33592588261884226,
						0.3341098708086442,
						-1.0658017293805238,
						0.6789798080289723,
						0.5626356435148585,
						-0.5737553520002163,
						-0.2502662522088689,
						0.5651201181244558,
						-0.12813977562470266,
						0.20125597113500832,
						-0.4406703872351822,
						0.3626105536141739,
						-0.01183304806274288,
						-0.6383459130798602,
						-1.2055704323877237,
						0.14241268861234277,
						0.8837969214458631,
						0.40042111986499174,
						0.45585586764871566,
						0.13124864825170174,
						1.147370965531622,
						-0.3571728789265296,
						-1.275712491957529,
						-0.14185566735868765,
						-0.21714280574036324,
						-1.2942597846404227
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.2176998875965436,
						-0.4488851693657699,
						0.3154268162534832,
						-0.11180826645003382,
						-0.6293086586507435,
						-0.7930276043190777,
						0.17264638307739416,
						0.15910321451413414,
						-0.8026606919926914,
						-0.03713800635584414,
						-0.3928719701871846,
						0.10523211669084537,
						-0.15552589117767765,
						-0.2882804366439805,
						0.13917969247655376,
						0.6762163402018654,
						-0.8217045868376258,
						-0.5977316893288375,
						0.8157813395525114,
						-0.348597604099327,
						0.2961276064183291,
						0.06674561368248212,
						0.099368980323621,
						0.20778955627460802,
						0.47609990500961585,
						-0.12126719473996099,
						-0.4907221706475741,
						1.2522471351708573,
						0.1480312859974746,
						0.22724823961172136
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.036353904745196806,
						0.2545642425009371,
						0.37031619047153386,
						-0.31146699957062207,
						-0.031555874217513005,
						0.4840020516112941,
						-0.17365620759167297,
						0.3964221656169,
						-0.3127008969257253,
						-0.060239008444139076,
						0.35235308787850256,
						-0.43092770319484064,
						0.294224372009512,
						1.0290620717571888,
						0.3912070372886078,
						0.8537462374223483,
						-0.4856649757029622,
						0.6626297545587689,
						0.4952863946374367,
						-0.4599815240027079,
						-1.9698691213533808,
						0.863008675697129,
						0.46507141096009125,
						-0.04396295798688245,
						-0.7035780783308406,
						-0.6447725037847225,
						-0.20529298793583228,
						0.23400672393526525,
						-0.8424920710014936,
						0.6884010679931037
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.9995491034330665,
						-0.6582328010965607,
						0.17695930008573807,
						-0.038504376861699226,
						-0.7778004962938971,
						0.9157003851432104,
						-0.053574581798929446,
						-0.0838366053359995,
						-0.6882808232099421,
						-0.14763314411742573,
						0.42438095161279993,
						-0.3383408999681651,
						-1.517337093258822,
						-0.33342173966161126,
						0.3276467198066897,
						0.38044998789452333,
						-0.5599494599993639,
						-0.8181298294009196,
						-1.1716059066543323,
						-1.6133368720849743,
						0.4862235151739558,
						-0.6211340716545227,
						0.4987128150400271,
						-0.22869690529746395,
						0.18136923378695036,
						-0.5286418317056065,
						0.15983291731900942,
						-1.097396284166269,
						1.3610093747613643,
						-0.14306935287394001
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.33898315031767196,
						-0.20524040231988044,
						-0.6485437840954549,
						-0.16020372823789258,
						-0.1541878064253702,
						-1.0303962482614522,
						-0.3794297505170086,
						-0.13091554326093285,
						-1.097803006436005,
						-0.9144120723743494,
						-1.8032048785015253,
						0.15462210469978419,
						0.5839968237172501,
						-0.9204619549532046,
						1.1291620148068666,
						-1.068093410469073,
						-0.7264440753094434,
						0.8118990613846738,
						-0.5308959118534865,
						0.5257558088560301,
						0.20449080764313468,
						0.8217674247216769,
						-0.4067601198163109,
						0.3817946301336802,
						-0.2682373724831307,
						0.3412760209909923,
						-0.33472775448694425,
						-0.6629445067345241,
						1.0066697844133317,
						0.4787949752975485
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-1.6393416204414941,
						0.5031009115319774,
						-0.61713955347923,
						-1.0432756515507216,
						-0.5832412034007515,
						0.7589114113737697,
						0.47385660345827835,
						-0.01563936643631055,
						-0.041013856976725986,
						-0.9378643096409346,
						0.8219548174726251,
						-0.42582066355412995,
						0.7528179792018272,
						-1.1288050541284143,
						-0.11636922184806307,
						0.6519684052186859,
						0.5159603484988584,
						-0.26907379260835274,
						-0.4996263110443308,
						-1.3692889003356297,
						0.4176451282543779,
						-0.8298195136847433,
						0.9718683237766773,
						-0.7236350714882159,
						-0.6507756727631473,
						1.0811063499314604,
						-0.17736031342860648,
						0.1963374663864927,
						-0.7867309387458312,
						-1.272352042979431
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.6003911518934101,
						0.16523291839458257,
						-0.17217100036023986,
						0.41503353709413354,
						-1.3412114819715661,
						-2.396522641593298,
						0.5009329802475094,
						-0.5395751021753076,
						0.9827896248360447,
						0.12397827617523385,
						0.08064969703453818,
						-0.8546807522520002,
						0.934325991397672,
						-0.144416175588089,
						-1.4332703919285132,
						-0.38788124641054306,
						-0.5969790890418668,
						-0.2062456991524958,
						0.12403356711187284,
						0.22657471317841069,
						-1.001072827548874,
						-0.14076166757612923,
						-0.02082949328976392,
						0.8606800991892619,
						0.2584544794958729,
						0.8702739758520994,
						-0.6125929118906944,
						0.010883007968631076,
						-0.6529211193920874,
						0.5886041972588235
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.13882765126314586,
						-0.7701313613566778,
						-0.4471305859060476,
						0.5798972626225555,
						0.8195549313899277,
						0.3865497690926446,
						0.9522969929359603,
						0.22981887561341768,
						0.6911771363011879,
						-0.8044124829310572,
						0.2704122393980536,
						0.8944327655332456,
						0.5656431090697289,
						0.7690434191425581,
						-0.05198791090818675,
						-0.4422074687677079,
						0.8802267742176817,
						0.029686239991150835,
						-0.27936131942321135,
						-1.210400697200485,
						-0.27566965758686596,
						-0.0873459312932448,
						-0.3532010665856299,
						0.1472901027429432,
						-0.4350269520397075,
						0.15478814359517423,
						0.5810301985149426,
						-0.44568284905688305,
						-0.8188914115346292,
						-0.8405569027689502
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.2751301287769143,
						-0.8743510262600057,
						0.3431739407928023,
						0.807895597495686,
						0.15837348377130653,
						-0.45739977618131095,
						-1.1603952920292087,
						0.802137431842188,
						-0.9761790531038381,
						0.09428138525402843,
						-0.28025623543723166,
						-0.21636976007768738,
						0.2776333228618345,
						-0.3851808437172707,
						0.2305948137936448,
						-1.344331392250974,
						-0.0245111496577391,
						0.17319071859108023,
						0.8258073885516463,
						0.3005771020492694,
						0.8862190187087884,
						-0.20052146860022005,
						-1.4058182708740738,
						0.04062688611107745,
						-0.36242491263590776,
						-0.26301074655259815,
						0.2525014684166608,
						0.1899474077292378,
						0.3306837708304986,
						-1.1667385336095817
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.15134897062375646,
						0.31864701240850946,
						0.741505794559875,
						-0.057465653674391985,
						0.08170252477178865,
						-0.5472340844087543,
						-0.14708211877229646,
						-0.6212473687375015,
						0.08239336364092902,
						0.7612139457219755,
						0.6825505094642177,
						0.37243046840280564,
						0.28459144673734027,
						0.4096664326651359,
						-2.193513043592633,
						0.21885301154293318,
						-0.2958999638814744,
						-0.31308648237859693,
						0.6384894066623722,
						-0.6332927015240238,
						0.4792348364364682,
						0.47328214170251204,
						-1.2048083227811262,
						-0.054265333888211136,
						0.23287994142895993,
						-0.3810612275051495,
						-0.37095059090825766,
						-1.2657512980229335,
						-0.0619287587172996,
						-1.184562357390442
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.14729204101734766,
						0.3892739178622894,
						0.14216517689307165,
						-0.2540713251072135,
						0.1432192399708588,
						-0.2034462401008223,
						-0.5478393363078157,
						-0.24080862543389717,
						-0.09417024927564868,
						0.11207445744159783,
						0.11524781140795998,
						0.06006586221387692,
						0.04346895993250024,
						-0.30201090373108724,
						-0.23951209906750665,
						0.07663690985882082,
						0.04636277302116122,
						-0.282529161976655,
						-0.004781808751956306,
						-0.24849582903063333,
						-0.21900051309639743,
						-0.12401462857705069,
						-0.046582607902774784,
						-0.300154974572426,
						0.054110137301108065,
						-0.018809428796214125,
						-0.08802418527719884,
						-0.03673131409335791,
						-0.3474178102017265,
						-0.34893878733247674
					]
				}
			],
			"biases": {
				"sx": 1,
				"sy": 1,
				"depth": 30,
				"w": [
					-0.6529551836333737,
					-0.20200540429482722,
					0.14029580895974866,
					-1.0676617828841135,
					-0.4051637346413544,
					0.46962946069626477,
					-0.4318767260913768,
					0.06990876951565882,
					-0.5124445423277203,
					0.7801453684798811,
					-0.5475588671444904,
					-1.7417021086845192,
					0.050794410750287816,
					1.3569646850807364,
					0.8102587886263183,
					-0.6866072799042511,
					-0.8751690212407257,
					-0.5399482833574752,
					0.2820776903731306,
					0.25879074277057273,
					-1.4137887535984868,
					0.016266531449641124,
					0.7690705361021569,
					-2.4953335332804603,
					-0.506648706960474,
					0.26223886077464514,
					-0.17455935289982122,
					-0.025865057069863816,
					0.4540368822787118,
					0.07906379681008772
				]
			}
		},
		{
			"out_depth": 30,
			"out_sx": 1,
			"out_sy": 1,
			"layer_type": "relu"
		},
		{
			"out_depth": 30,
			"out_sx": 1,
			"out_sy": 1,
			"layer_type": "fc",
			"num_inputs": 30,
			"l1_decay_mul": 0,
			"l2_decay_mul": 1,
			"filters": [
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.0830828242603518,
						0.43100526193590555,
						-0.032815346797020396,
						-0.35666953824668785,
						0.41929910315913627,
						0.11988329972702208,
						-0.36231751480853747,
						-0.2606990619767892,
						0.2637033682617169,
						0.14195459040086844,
						0.06050275030756101,
						-0.11743508803814504,
						0.13659066771169243,
						-0.8424957901608432,
						-0.34426345770145506,
						0.18278203259422932,
						-0.3295105711003408,
						0.4941830203597306,
						0.2686644103352061,
						-0.8255085225550212,
						-0.24578340835342288,
						-0.2901452542679215,
						0.5922548521516238,
						0.5243587761657036,
						-0.471627767788867,
						0.19855559685454982,
						-0.5207173955018133,
						0.015880370957395064,
						-0.5316830979078557,
						0.0927003206968754
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.05150268640859321,
						0.24222909733143605,
						0.174194696483478,
						-0.6583758222303271,
						0.6570641487881856,
						-0.4513849954755986,
						0.4856721787935477,
						0.05906588177537167,
						-0.4404824539592281,
						0.4587589419227127,
						-0.4659607496092564,
						0.7085414149658769,
						0.07454697131207304,
						-0.49637757747279615,
						0.06942898878995264,
						-0.7876277667143216,
						-0.3862233112172502,
						0.016213906951747074,
						-0.39612021642863887,
						0.0768200709271459,
						-0.9703032111014137,
						0.23307464934638897,
						-0.48424702107929246,
						0.4181138901924681,
						-0.22110524889599217,
						-0.6385265583196088,
						0.5895612831858844,
						-0.546518002332912,
						-0.15582823232079474,
						0.06429741146055422
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.8736405774838208,
						-0.29399919661444107,
						0.06855937053523027,
						-0.3013282097787549,
						0.4048595690047767,
						0.83994364947667,
						0.40078430787106273,
						0.14933492825223776,
						-0.688192086533297,
						0.008869359776328321,
						0.27221339307195763,
						-0.2506854389563222,
						-0.3553686042419055,
						-0.48805012985827195,
						0.39612638944487727,
						0.5617378316840933,
						-0.6054402272981737,
						-0.14736038048450284,
						-0.3991073785538639,
						0.3245285560807092,
						-0.6363096364520814,
						0.7834557682437501,
						-0.3972906616759799,
						-0.04386932244191544,
						-0.9057424719193622,
						0.06292719073618956,
						-0.8419661813538446,
						-0.6158493914183434,
						0.1491795270912826,
						0.45556822035539407
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.9783945262443516,
						0.18067493864840614,
						0.11533861568094694,
						-0.12471835974771836,
						-0.4127680675036513,
						0.03594482215389843,
						-0.7917698536786623,
						-0.2576045110470315,
						0.17307776927458784,
						-0.4805283729032114,
						-1.5419034933322187,
						0.7297805611580666,
						-0.49708791607899505,
						-0.1689505642208325,
						0.9800532231284573,
						-0.09249439108565383,
						-0.5038307586821175,
						-0.10071992290354789,
						-0.06020796899989744,
						0.2712995731295134,
						-0.5940247719625171,
						-0.5372810546202923,
						0.22169001998532517,
						0.5169917685235094,
						0.44141674759231414,
						0.995203888269836,
						-0.48405134297835295,
						-0.4111971403862622,
						0.2250611382796177,
						-0.22998276324268005
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						1.2648596848839033,
						0.6191216094904924,
						-0.4080470287967491,
						-0.7373092338883325,
						-0.13735340487824946,
						0.0964673287346798,
						0.5038877437518209,
						-0.33231018983008986,
						0.25786135985037273,
						0.28840275441997354,
						-0.14507242910298307,
						-0.5299333737286303,
						-0.3987930471780831,
						-0.07319259665785348,
						-0.8657115542947694,
						0.035631810036627805,
						0.46346328780303436,
						0.6263648572512764,
						-0.7599504638555744,
						-0.5122821862347416,
						0.03039468156192969,
						-0.058264062367091224,
						-0.6523137973023885,
						0.17260450823640786,
						0.09165061215032094,
						-0.853447294976734,
						-0.7190710154939265,
						0.3698920855185946,
						-0.6155691912822551,
						0.05700154623521582
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.48282063909311923,
						0.5733343389950736,
						-0.8398492293062022,
						0.6242496499536516,
						-0.4308609695871237,
						0.6311656963357101,
						0.7136631417563364,
						-0.015477446515220896,
						-0.34041480851704936,
						-0.34712533679759827,
						-0.8239778900527673,
						-0.32398734911066507,
						-0.18067065767011517,
						-0.2917130590416461,
						-0.38989146765121,
						-0.43793415961368215,
						-0.4158877397722358,
						-0.20295111496464044,
						0.6321974849712039,
						-0.1691443236826625,
						0.04425695313899962,
						-0.4731499114347252,
						-0.662671677316283,
						0.052540827403265065,
						-0.8762312173583096,
						0.35503761308543175,
						0.19906004201917768,
						0.2819383383926927,
						0.7309974337243128,
						-0.15501295856652594
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						1.0227297919822627,
						-0.7195415325081171,
						0.00536898653670367,
						-0.8905376015016044,
						-0.40298093459184403,
						0.7895522451724956,
						-0.5889950550349554,
						0.20200899381241003,
						0.2566131251494137,
						0.13198889395026928,
						0.3901221390522502,
						0.1199871896440006,
						0.8362869069392036,
						0.4184895548669894,
						-1.4870725262189672,
						-0.18800897891478074,
						0.2873965503465912,
						-0.564962508529217,
						0.4387801494575648,
						-0.07251738971378875,
						-0.31522553853839497,
						0.433592824712256,
						0.10423310651668413,
						-0.8658723826343558,
						0.2075132384738221,
						0.35807449113157036,
						0.004985435848504252,
						0.31546197900403833,
						-0.4412939524342317,
						-0.02503344408362894
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.25949316538945355,
						-0.8225717633854531,
						0.34086966067220226,
						0.01925472318024597,
						-0.5444867357140639,
						-0.7162377324027532,
						0.1333524544690767,
						0.5038423091375834,
						-0.7194350205410577,
						0.09401371391959318,
						-0.5550798593919054,
						-0.14660716734158272,
						0.2548091176392103,
						-0.012376255165906402,
						-0.040707349085063016,
						0.4558861796730743,
						-0.7248429248030868,
						-1.1640995700065382,
						-0.24499905856172222,
						-0.10885745086532789,
						0.09055247952558768,
						-0.15239597515936532,
						-0.8700933838764473,
						0.5525720330496463,
						0.7737126397341237,
						0.7153773571843699,
						-0.6979429635662986,
						0.07395415891969855,
						0.1377955132024922,
						0.12559179813078666
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.10890787432312586,
						-0.21549627275781025,
						-0.37308590598010566,
						-0.11906417921846991,
						-0.0017867699212374029,
						-0.2387274797952392,
						0.22735341906274367,
						0.2541633105049218,
						0.11256145099860308,
						0.7540858193420189,
						-0.5154825893911853,
						0.8095059661850011,
						0.18042317993760018,
						-0.7150735725363934,
						-0.49156383526162434,
						0.40075398927925143,
						0.30056897740426325,
						-0.19615309994672112,
						-0.18897397712771194,
						-0.45214625668404895,
						0.6036731110586618,
						-0.35425420891663983,
						0.21155793808657633,
						0.002286307024304571,
						0.7399793519085105,
						-0.18255758461140248,
						-0.5620012673315882,
						0.5977329020889645,
						-0.4057118733137284,
						0.12102547171832823
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.00539629819367328,
						-0.26287761631163076,
						-0.4891756869149963,
						-0.09941137795902559,
						-0.015283240457481752,
						0.215677959152187,
						0.7546218534688135,
						-0.262628157834767,
						-0.36835199085097814,
						0.75559838955209,
						0.3098760996627654,
						0.4576352568209326,
						0.07789997307867336,
						-0.1806523046813974,
						-0.7380060206925476,
						-0.9194848388924614,
						0.0009369149648701261,
						-0.8906846516440206,
						1.2643621507109104,
						-0.7330376033860435,
						-0.0174591247913065,
						0.055593897260272154,
						-0.0818601062374538,
						0.6060768995422992,
						0.11495083586784612,
						-0.2816941183877928,
						0.030602404637575704,
						-0.4171878911538928,
						-0.7417285146324356,
						0.26982295221560176
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.20879345042203787,
						-0.20905351988868973,
						-0.059801328911537305,
						-0.6236501529987452,
						-0.11119176983394956,
						0.4056301263977209,
						0.18009905153002906,
						1.118048246126144,
						-0.011210038237473607,
						0.050398118194358466,
						-0.3706955943527953,
						-0.15532682523374727,
						1.0266327921434346,
						0.15105747130608624,
						-0.04897946673887944,
						-0.22243606990058576,
						0.6323620519812282,
						-0.48755933010830904,
						0.22563653948837734,
						-0.39944180987927747,
						-1.2034734433162242,
						-0.12724173669312305,
						-0.35478387435878667,
						-1.046872999881334,
						-0.4598381401248003,
						-0.33935991564126533,
						0.16638915029792067,
						0.2125712541577929,
						0.7086393421192948,
						-0.0730654517944616
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.630833255593585,
						0.7198083499819344,
						-0.32088155330018286,
						-0.293469656861597,
						-1.1623845249634046,
						-0.5008675338382955,
						-0.005404785776945109,
						0.47887562664507183,
						0.09963777670034522,
						-0.10150859916822089,
						0.44664664970144957,
						-0.9390023191066666,
						-0.5899365944753046,
						-0.01509038625236792,
						0.3531644783723064,
						0.1661205665865875,
						-0.006466995098793132,
						-0.4222945742754708,
						0.2149694117158458,
						-0.9422308243425721,
						0.30770598567065915,
						0.09524672137608736,
						0.13574703478751662,
						-0.26560483994486533,
						-0.9814498311713054,
						0.2495626215263562,
						-0.8639042268379994,
						-0.05145051989105668,
						0.8539285674887237,
						-0.021104589848972146
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.19153559138390755,
						-0.2814743974507961,
						0.2076920531687112,
						-0.8511439693611662,
						0.2446284693211534,
						-0.5705286978049078,
						-0.9461101590262908,
						-1.2220902016621105,
						-0.5743769754450107,
						0.19403214357018594,
						-0.2515748734349479,
						-0.5198779358962551,
						0.5426941935563167,
						0.24564209128208297,
						0.19588453987647997,
						0.36183475146198796,
						0.3814533785724079,
						0.6069021901898934,
						0.12926175101410195,
						0.090167410808956,
						-0.9415444598643377,
						0.26779224297179105,
						-0.35072696420778243,
						0.4967265626491332,
						-0.36027828257328254,
						-0.8482360533143561,
						-0.33640853371888174,
						-0.35841133757149607,
						0.6119009849180334,
						-0.4169636274578654
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.03338105076100989,
						-0.5184986788647815,
						-0.06902471857578965,
						0.14778160225567963,
						-0.5676280208307757,
						0.4709099215162115,
						0.7396981584118366,
						0.254998759264565,
						-0.5510336178743104,
						-0.2679833950124225,
						-0.07928113259053098,
						-0.3364645143623047,
						-0.17192897604837665,
						0.8285205777006075,
						-0.17431904760341074,
						-0.5758120559242579,
						0.4034191477771222,
						-0.5300835438740331,
						-0.004722306095405495,
						0.18669530937452664,
						-0.41607289290885063,
						-1.052198413045592,
						0.3345161696699936,
						0.36231709031714104,
						0.5588642907636442,
						0.07716120598264077,
						-0.16123437510497715,
						-0.4204129089332407,
						-0.6092578815902893,
						0.0676089954172747
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.17060063211666748,
						0.3522354641346049,
						0.049359679894277614,
						0.38739291333048553,
						0.0809512983876922,
						0.05563810929312434,
						-1.553467642344616,
						0.2633633516612613,
						0.34926130548005224,
						-0.6668078713136042,
						-0.11526772599931785,
						0.01718004480801157,
						0.18996584207710634,
						0.6487500880064159,
						-0.8042784131929919,
						-0.11113737636339004,
						-0.5796876679894737,
						0.42927278661312257,
						0.4265579704082112,
						-0.4659921922188792,
						-0.23126886403094113,
						0.14820598716903718,
						0.6237525274832962,
						-0.4919573013393022,
						0.2391121199562899,
						0.02708650744347501,
						-1.6068612621961906,
						0.48137678485581886,
						-0.34592169730629324,
						-0.102000450501805
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.5306581639210413,
						-0.09455894275086689,
						0.4841128143790983,
						-1.1445495482861505,
						-1.0255273142075532,
						0.1443984110254023,
						-0.3785139453250783,
						-0.5269494483633396,
						-0.05136503046188989,
						0.6287174371948738,
						0.2751676355102461,
						-0.6185438931598914,
						0.3826217226370447,
						-0.2935110715296296,
						-0.9997916801954669,
						0.5638781747222469,
						0.062110576702288506,
						-0.257643307516678,
						-0.1664808468724925,
						-0.15597973313808197,
						0.8248338432770553,
						-0.4854979924591079,
						0.040905463755243454,
						-0.6669399941005663,
						-0.03925336877291229,
						1.2970395266212555,
						0.4328547956148792,
						0.09373063614990265,
						-0.4439205560154587,
						-0.06737101058230419
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.005312378458830822,
						0.546098016777585,
						0.5961213606017127,
						0.2930860288883905,
						-0.5499401880853284,
						0.11017491308022302,
						-0.851916161248609,
						0.19448823404775814,
						-1.0050078929466408,
						-0.2941176191800704,
						-0.29626804353352987,
						-0.5295583172259075,
						-0.014180022780553461,
						0.1280548363543517,
						-0.7052934601437069,
						0.1869407078584193,
						0.9172343513399125,
						0.4483341753177762,
						0.1182790269191704,
						0.7414312180831976,
						-1.4124267664265793,
						-0.02707181022575694,
						-0.33580635420434946,
						0.6595745412444713,
						-0.8047579842209333,
						0.33791389608364636,
						-0.45416726856768863,
						-0.11168917846778013,
						0.06538032686986127,
						-0.022432866919746445
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.14679795674998244,
						-0.15769414346720684,
						0.5500535426311057,
						0.496123881106046,
						0.6593682636225624,
						-0.6878440941799507,
						0.4231225597776292,
						-0.3572494698279648,
						-0.43861758311272336,
						-0.2919585387676987,
						-1.2959869351358144,
						0.6441573917377752,
						0.17900871402461688,
						0.13720770633059584,
						0.6375834555180627,
						-0.09187744519668709,
						-0.7673207828572118,
						0.00511436050260358,
						-0.3632331661275108,
						0.5648964881887334,
						0.34168609674903233,
						-1.1706581118200037,
						-0.2335102500233817,
						0.5300025280625336,
						-0.4628542725411596,
						-0.3345317807070315,
						-0.3055284414063308,
						-0.7236072507248005,
						0.4835574772487759,
						0.25252171490027453
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.20851682251282488,
						0.06277543138079114,
						-0.03567214349529701,
						0.11576555384964103,
						-0.30330634729205924,
						-0.058207397222159056,
						-0.069171617684724,
						-0.016087812514412467,
						0.19142968485817674,
						0.08232838858201598,
						-0.6756988385389034,
						0.4625873764348271,
						0.17994835779375365,
						-1.578510895489612,
						-0.6109252537976583,
						0.5931108873317785,
						-0.2928727946109541,
						-0.6216827051536964,
						0.39726558909590165,
						0.29593402982309364,
						0.5387232748735938,
						-0.047693686942976384,
						-0.11379487813375687,
						0.8020934198834581,
						0.3632605987592813,
						-0.2552903086562349,
						-0.7846255821690316,
						-0.12916959306331416,
						-0.6793503595174999,
						0.0751960806994055
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.42543487694964127,
						-0.9463205323649688,
						-0.1900501932671525,
						-0.5402127463795608,
						0.12699257506104492,
						-0.31519686565894117,
						0.05813330255136718,
						0.43514626025558933,
						0.020598869610243164,
						-0.19034390411612,
						0.5965859009408686,
						-0.29956138470025984,
						0.5879835166590799,
						0.7081473399579438,
						-0.26654764415545823,
						0.30592905151375566,
						0.015760918353426065,
						0.24216313807390027,
						0.28978567005738065,
						-0.21159518783014067,
						0.3296700525327894,
						0.008213407099882771,
						-1.173361006480237,
						-0.7809328336091778,
						-0.4759872583467796,
						-0.9486202727031116,
						0.057147043832150746,
						0.31209947121108494,
						0.103391739028698,
						0.10987845481227372
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.6464312283624332,
						0.5337440454007873,
						0.3039751023129011,
						0.22811185787375815,
						-0.20762995089414618,
						0.034755328221211176,
						0.22599506777734657,
						-0.26186788722201565,
						-0.2627132562929472,
						-1.2998899007811167,
						-0.5259968068922395,
						0.6596107571427883,
						-0.4386490347160183,
						-0.5638521249441864,
						-0.19399286665641732,
						-0.15685281315718955,
						0.8111495557362371,
						-0.48276866851169137,
						0.678669391269818,
						-0.6510689177096477,
						-0.22123301697041245,
						-0.23894694697536303,
						-0.559995995523518,
						0.8426789462867538,
						-0.4881975786939663,
						0.41718623916993075,
						-0.7828166973893022,
						-0.46695474000224396,
						-0.0946108235054509,
						0.11538359723541966
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.6893300829420235,
						-0.038759437989653645,
						-0.27388733459804865,
						-0.7221269774429103,
						1.1140373151330032,
						0.02512422321763593,
						0.15853681580232198,
						0.2597439300023874,
						-0.054174637781097976,
						-0.2966439509338545,
						-0.35425643230056136,
						-0.4816520114042555,
						-0.16256643461843398,
						-0.3310049595301138,
						-0.09480549674354893,
						0.3955801326348784,
						-0.6373750247474559,
						-0.2574890122115164,
						0.11208427740263696,
						-0.6336263387396234,
						-0.1488447105817403,
						-0.7020105726172203,
						0.13158699140986496,
						0.04148035330358823,
						0.7098967720576302,
						-0.44021524279215024,
						-1.2807918188655707,
						-0.5498361735117915,
						0.36325624229117165,
						0.02399556296935133
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.6187372574682068,
						0.746347164432474,
						-0.056617165527054536,
						-0.8820298682622542,
						-0.8254037225221815,
						0.08376296505572452,
						0.43786021084931687,
						-0.16711830241309955,
						0.23430518683656293,
						-1.097894282583048,
						-0.16734694392722818,
						-0.07177828265436328,
						-0.24347402313953465,
						-0.013380944530619849,
						0.18377352771486682,
						-0.7094435567703092,
						-0.5228104360571333,
						0.11440616376689106,
						0.5454553061688103,
						-1.0666971802340706,
						-0.04095961740454378,
						0.6084922029225741,
						-1.0087588603947348,
						-0.4160459654751483,
						0.31852314120688596,
						0.02091944742643658,
						0.14797173277161868,
						-0.16654062735659397,
						-0.2040400372337872,
						-0.33774231389118886
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.49707500630233914,
						0.08446637036799365,
						-1.2622172960875366,
						-0.043565257324053475,
						0.6045388060381499,
						0.2578116274011924,
						0.010572777075323973,
						-0.6109928704827081,
						-0.6862733671408899,
						0.9573219818739668,
						0.5654670544398955,
						0.34389411462142927,
						-0.19773474296374963,
						-0.44810951641188485,
						-0.21918825657045607,
						-0.1009573393476861,
						0.7620709664317771,
						-1.4297271889371497,
						-0.30283743350218256,
						0.5958060839359465,
						-0.07342823990737368,
						0.09828248311130741,
						0.28663184296620914,
						-1.5219376365144899,
						-0.5685961711552486,
						-0.06297036784147084,
						-0.1442226754783671,
						-0.22788132117815055,
						-0.07646694642045242,
						0.42301735848329075
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.1968712151163107,
						0.2559503133227341,
						-0.3647439194662418,
						-0.8574548974744592,
						0.5745740865090294,
						0.5373991118814463,
						-0.24647141699234235,
						-0.17857085678009416,
						-0.8267625839336296,
						0.3195699880737307,
						0.12663532674462305,
						-0.25129689349680356,
						-0.3392036639268631,
						0.4427288891733201,
						-0.44217249873627973,
						-0.3359832494465652,
						0.44883568549717406,
						-0.5709521303940054,
						-0.03169595805226652,
						-0.569146393258319,
						-0.03339625640532485,
						-0.5999557836021442,
						0.8865358446233328,
						-0.46993211073538854,
						0.441131960308678,
						0.0392915016079607,
						-0.2231319944562963,
						0.5691843106256206,
						0.17154449505418126,
						-0.4143312369601381
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.29291276710428504,
						-0.4958155658089182,
						0.5070375085802878,
						-0.8645113215087509,
						0.5103764023861527,
						-0.728673916561183,
						-0.14207560614061815,
						0.37464095848003776,
						-0.25363110728057053,
						0.3724662768971345,
						-0.4368054209744719,
						-0.004760615389705892,
						-0.0020192530226122983,
						-0.6733806400787101,
						0.07973654006901888,
						-1.7558607385846412,
						-0.8841438901685178,
						-0.4894775399960411,
						0.5942898412718113,
						0.24215036488078268,
						0.11616174553155004,
						0.004934403569353422,
						-0.7949993772986359,
						-0.007924911216651849,
						0.34610191537744667,
						0.5827768893721611,
						-0.0695804730105231,
						0.51345936981264,
						0.07669509911192846,
						-0.11092797979643529
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.25575979258180637,
						0.5781608283992574,
						0.07050626835340909,
						-1.5019536046654849,
						0.4090549494770237,
						-0.6641225041618274,
						-0.12510394419569854,
						0.08125580954861397,
						-0.1281304205788116,
						0.5694298856641816,
						0.7554756648139958,
						-0.9309077120237543,
						0.2061824931232693,
						-0.558269328753852,
						-1.11465553896493,
						-0.7013397692536928,
						0.09950857301723134,
						-0.4300311825828815,
						0.02184152943486971,
						-0.04454570852693317,
						-0.04538445483561763,
						0.4891520691490099,
						-0.5986031159259738,
						0.26195346054319135,
						0.03424028782554104,
						-0.04623233000809079,
						0.18129781998168254,
						-0.6854799661660043,
						-1.1552679624042241,
						0.04169193593339719
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.3748641845930405,
						0.45512356267588555,
						0.3475126526652697,
						-0.015179882051581812,
						-0.4792675783844459,
						0.8363754397747419,
						-0.0596128749856284,
						-0.6551146780399609,
						-2.0001055954402287,
						0.23616170048003376,
						-0.9543258685307092,
						0.5625587185305693,
						1.0401117892226626,
						0.002048423441612644,
						-0.2120736099193696,
						-0.2612258610105263,
						-0.5835313153616408,
						-1.0078508364525693,
						-0.9146799126497834,
						0.3697155031979965,
						0.5218588035267808,
						0.44884348376722477,
						0.3490950460858,
						-0.34726146783338907,
						1.014266238327541,
						0.908841433548983,
						-0.5537530223769651,
						0.5217290635625383,
						-0.5529530995259899,
						0.07445157232315139
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.2986603117237149,
						-0.2604047737703778,
						0.4004866528037066,
						-0.8974303644250704,
						-0.13434881855706043,
						0.7407191263986963,
						-0.48118920388226283,
						0.010232451597189255,
						-0.4159390349688421,
						0.8841135588558484,
						-0.21151902511769935,
						-0.07967016927847238,
						0.9261065274657284,
						-0.6791261907752175,
						-0.6589795411247119,
						-0.013485669607590707,
						-0.7662943843577857,
						0.2845812635761434,
						0.5445035446582135,
						0.34282063642824157,
						-0.433461291339612,
						0.4332998616326642,
						0.35138110995380273,
						-0.2504802775158313,
						0.15696901335215957,
						0.21834959534753492,
						-0.35612531307487155,
						-0.28885912299384525,
						0.055116883445734295,
						0.149380306315878
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.6897940814645663,
						-0.9671763680116389,
						-0.06577734921310775,
						-0.05853354476463091,
						-0.12063062888326212,
						0.25741027329761357,
						-0.4156154313068736,
						0.5360262188131281,
						-0.5646425199634293,
						0.8220568524400779,
						-0.24624725105402825,
						-1.2074491644807896,
						0.2477207558468159,
						0.3179221297698902,
						-0.4597810484095718,
						-0.2857354342041499,
						0.11438685777837512,
						0.11154780784415017,
						-0.3047447283030531,
						-0.8957199353032342,
						-0.043292330581097424,
						0.4314412008456489,
						-0.5247227443906739,
						-0.1220633641605212,
						0.6415733780822901,
						0.1195356426641122,
						0.12874965872879607,
						-0.3245161578931361,
						-0.7070340391706051,
						0.1416289195800887
					]
				}
			],
			"biases": {
				"sx": 1,
				"sy": 1,
				"depth": 30,
				"w": [
					-1.7314887066288105,
					-2.02202957956065,
					0.1272776437390287,
					-0.8055671571331193,
					-0.9214114534230144,
					0.6028053785439405,
					-1.2804912060689528,
					-0.44616889959141065,
					-3.2403166496404414,
					-0.8955400486160312,
					-0.5471178440519178,
					1.0052155739051227,
					0.4856816877724981,
					-1.2604488301516774,
					-1.046171733913904,
					-0.5324356665496724,
					-0.21767070317788698,
					-1.369887540004395,
					-2.0505575348239637,
					-0.5133265497013397,
					-2.037510366601336,
					-0.6234398407711395,
					1.791873795125318,
					-0.7332671547291713,
					0.04620790892486551,
					-1.8288775839145759,
					-0.4720165023500347,
					1.1076232321386192,
					0.34784517766218964,
					0.837195475923478
				]
			}
		},
		{
			"out_depth": 30,
			"out_sx": 1,
			"out_sy": 1,
			"layer_type": "relu"
		},
		{
			"out_depth": 30,
			"out_sx": 1,
			"out_sy": 1,
			"layer_type": "fc",
			"num_inputs": 30,
			"l1_decay_mul": 0,
			"l2_decay_mul": 1,
			"filters": [
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.12585437124829868,
						0.46987280011538973,
						0.2320743632746691,
						-0.7770540450718509,
						0.06412312480396382,
						-0.405425918179068,
						0.4741222648616607,
						-0.48583517089430894,
						-0.025168521003964377,
						0.2138606459191321,
						0.3511603684050245,
						0.674407689863641,
						-0.5289069793336209,
						-0.018459429065330026,
						-0.35625735951118304,
						-0.2152108580233432,
						0.1505505768729226,
						-0.25341488738372453,
						-0.10043371310894865,
						-0.10519959253127438,
						-0.12251796060155079,
						-0.34155172840287074,
						0.17150312070475826,
						-0.5357879217565624,
						-0.1601555255346898,
						-0.4034112706002614,
						0.5895685387729228,
						-0.3676874373685213,
						0.08252798957487772,
						-0.2706029515018847
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.2334848808862445,
						-0.4850104521867436,
						-0.028111463017048567,
						0.015161070531086347,
						-0.050934235534077416,
						0.2694708333993907,
						-0.3538805378631507,
						-0.03329301628393381,
						-0.20132562838352228,
						0.4757907778854698,
						-0.6585655815552706,
						0.1435575028858696,
						0.3262144078244835,
						0.4130253743827877,
						-0.5532354842758157,
						0.44701353020582707,
						-0.617362249848134,
						-0.0032494925757010937,
						-0.4405533407420454,
						-0.13618611819789442,
						-0.8634800654707039,
						-0.051596146307928345,
						-0.2825472814492245,
						-0.5041922319577192,
						0.2315516702253356,
						0.013532069967157915,
						-0.0879501001503768,
						0.5718785638874159,
						-0.3962077554928797,
						0.11322248231066633
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.19896948414435378,
						0.12297493400904255,
						0.171629866723963,
						-0.039535863749862225,
						0.14749048090301087,
						0.7097561936958136,
						-0.9744378759976527,
						-0.20773105056435628,
						0.17889324727091882,
						0.09364641927142417,
						-0.6318753334321868,
						0.07853684984359464,
						-0.09293172016332975,
						-0.11305073322810634,
						0.3020457722688407,
						-0.02552679502021233,
						-0.48220588507598233,
						0.3610171771848343,
						-0.7047905117987746,
						-0.38869885470371274,
						0.022751342399149964,
						-0.11309401022956465,
						0.4965375107530142,
						-0.15963256767920594,
						-0.5197148563112671,
						0.26355157352783326,
						0.30945687085402845,
						-0.06582893923254265,
						0.35323080883631724,
						-0.504737960414115
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.2754352487589097,
						-0.2283547214110051,
						-0.5710923570547981,
						0.2096578691236818,
						-0.11967060159062229,
						0.08828571098799906,
						0.5662745452220586,
						-0.5658718045470521,
						-0.3066386575635334,
						-0.007337056129630966,
						0.6751148019812881,
						-0.3801880495624482,
						0.30853261481058114,
						0.2585206879402308,
						0.08280905976530382,
						-1.1956997894827233,
						-0.6778644196699416,
						-0.8841468350362953,
						-0.21557182376220374,
						-0.24777689461400618,
						0.2851455467018482,
						0.21640411352151537,
						-0.7937606332763171,
						0.46154975369648044,
						-0.22973214749246296,
						0.7239561943559679,
						-0.7892526918192545,
						-1.0590202481046005,
						0.14917364276520295,
						-0.29388297592426543
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.10664740424135104,
						-0.306390364707119,
						0.3021553355388826,
						-0.6925712155025578,
						0.24960268062606805,
						0.3529613995161724,
						-0.11667156331999733,
						-0.41564006619248245,
						-0.2516077279890158,
						-0.17024944968856628,
						-0.14951747796242199,
						0.2513149601726544,
						-0.3050920194650534,
						-0.6292165921936015,
						-0.02925111043376755,
						0.01635236927942805,
						-0.7901418098877516,
						-0.444928814582798,
						-0.44464974835069737,
						-0.6954054359928082,
						-0.4833070083558057,
						0.29137118461328876,
						0.5992809394500354,
						-0.3456587633912502,
						-0.22928050610676662,
						-0.722754874480345,
						-0.2693247691002807,
						-0.6439603177575364,
						0.609101055316782,
						0.16805087352206755
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.08115897473552593,
						-0.10140827524834495,
						-0.3429497648242886,
						-0.5744818744387566,
						-0.6756849353650033,
						-0.05181061453713705,
						-0.12099071642265725,
						0.003733666319650252,
						0.27018353586153837,
						0.3602478770964125,
						-0.1379011617441714,
						0.0936930946501025,
						0.8354464933004079,
						-0.31625926668858845,
						0.5212142246937987,
						-0.22020178694357315,
						-0.2802181076708364,
						0.13264232630781345,
						-0.8062739277750628,
						-0.2184153612838906,
						0.081812107386097,
						0.3590677092491513,
						-0.20506897879940159,
						-0.32897487002691306,
						-0.21750087108334906,
						-0.1206945669256916,
						0.24631053997805033,
						0.1437043947007224,
						-0.6568850714455584,
						0.2728587729014593
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.4023819996404253,
						0.29178893940987516,
						0.46509834414711426,
						-0.2061261035662792,
						-0.290280367014873,
						-0.20285157394492886,
						0.19747851841398276,
						-0.1619265852763179,
						0.026268424320662075,
						0.12449805663002754,
						0.03535030981855087,
						0.526151563805062,
						-0.12340839955265114,
						-0.3838241502553432,
						-0.27797517052814014,
						-0.23571975331925862,
						-0.968115599395748,
						-0.7897725927765323,
						0.021412648596652255,
						-0.44287286162028844,
						0.043206097815732016,
						-0.42870124059230336,
						0.18199445925102875,
						0.1143618919594558,
						-0.4768832434056493,
						-0.09342969059824532,
						0.06575692777471272,
						-0.07532723321460591,
						0.10443598124513669,
						-0.6325318047752141
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.3327995900490915,
						0.7176579055532917,
						-0.5357287833131225,
						0.06395162137665593,
						-0.5855676403284795,
						0.15953524217826173,
						0.3405879890236067,
						0.46990364433006193,
						-0.27651141305872046,
						-0.3892463683707594,
						-0.47119553548385357,
						-0.040052313419125234,
						-0.03133938570754511,
						0.4626113282636205,
						0.0859139708345067,
						-0.5148065941783343,
						-0.09808609448797372,
						0.06670135179385592,
						-0.1733459462905642,
						-0.7546558255436691,
						0.16507861429325468,
						0.19962263190561103,
						-0.15430309271489337,
						0.396088469786807,
						-0.14670165530443538,
						-0.4396588558794065,
						0.005967261533802365,
						-0.24953079717179835,
						0.27246860764847713,
						-0.5885368098795806
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.2638059844607983,
						-0.2924128095099849,
						-0.6826637743442118,
						-0.9506866992885058,
						-0.3469991091144108,
						-0.17227303330249158,
						-0.8344936127672538,
						-0.6544290007541471,
						-0.6742652992413714,
						-0.1656958449780448,
						-0.12916650756353484,
						-0.16083107188255086,
						0.25025307243866796,
						0.5266776155014831,
						-0.1835866174133139,
						0.05669980580631098,
						-0.30934100854494756,
						-0.39885645598624014,
						0.05084155663215026,
						0.37922872286216547,
						0.1330632610190144,
						-0.2368520218624647,
						0.09487936046161408,
						-0.20061956064079822,
						0.28275174537436293,
						0.047783934631416405,
						0.2348251214374541,
						-0.9488715377341682,
						-0.5094928893422078,
						-0.8783380348235509
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.5637788636614733,
						0.16665092405394683,
						-0.3610305586694786,
						0.40942663325173273,
						0.521806149776554,
						-0.5470537412004236,
						0.2151039563273478,
						-0.13706445692070365,
						0.36785227316260116,
						-0.43109769473724124,
						-0.2985910560050482,
						-0.6055317806331565,
						-0.31280865648956807,
						-0.17637798659581846,
						-0.19203759396678688,
						-0.17177085605728507,
						0.3877288412558676,
						-0.2829889765908786,
						-0.5977314192858675,
						0.09043457987758215,
						0.3615216965390854,
						0.21822418742719937,
						0.23013899813646066,
						-0.1457640139160182,
						-0.3901180186416037,
						0.022149218152255692,
						-0.41291936929005313,
						-0.62692176192777,
						-0.4126392494088286,
						-0.4672047125061638
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.13647828789466027,
						-0.1683611270742702,
						0.2914038660759999,
						-0.7741552866534425,
						-0.6983350928116273,
						-0.05522184114505198,
						-0.5848751586301256,
						-0.4592314486292282,
						0.3409738743727015,
						-0.13565174181184808,
						0.11157261163803739,
						-0.534819074725889,
						0.14198524592587441,
						-0.022623600306352586,
						-0.400441272422423,
						-0.11767797099240701,
						-0.8231794797941625,
						0.3387746263231204,
						-0.4852049441596682,
						0.12032197228700611,
						0.10228894387734569,
						-0.42039222180814795,
						-0.3951413852367805,
						-0.14212773392000247,
						-0.4452204609154967,
						0.7315135211607178,
						0.4306452236484581,
						0.10612329172726148,
						-0.34318260042212684,
						0.5220946496398585
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.49574972642488657,
						0.22532481956108422,
						0.29333570779897283,
						0.03200101674601861,
						0.03722293454227116,
						-0.05481521359912298,
						0.12836864316172347,
						0.1286134404611037,
						0.3594845267259489,
						0.3733040321335592,
						-0.24048273247989752,
						-0.32764138845390245,
						-0.6242579656511686,
						0.13537203810398776,
						-0.10988544098202334,
						-0.0990776390010698,
						-0.37823291935263026,
						0.052581762110899585,
						-0.11593976548717617,
						-0.02083310554609359,
						0.31968640469702386,
						0.3734223484589806,
						-0.8664572303010907,
						-0.06447356905933824,
						-0.3727061913956189,
						0.08589398400112493,
						0.09839164975990013,
						0.09178398829704679,
						0.027019352198314882,
						-0.1570082804554387
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.7550015723887785,
						-0.6615655266692402,
						1.0486540926203674,
						-0.013736829300493419,
						0.2459325251420785,
						0.061670419903731684,
						-0.3867939714865457,
						-0.6158688443841437,
						-0.1083124222031132,
						-0.10635521759743496,
						-0.21062180012681955,
						-0.37592538049125596,
						-0.3890763306270988,
						-0.7649344729843991,
						0.047115439044714325,
						-0.4544346773315646,
						-0.510853083524381,
						-0.2606415489976294,
						0.41834593623228605,
						-0.36343520850330574,
						0.2779378247552445,
						-0.07850522031260397,
						0.4454837969554672,
						-0.17415751614231728,
						-0.5610999068643662,
						-0.1835939140836509,
						-0.14515219505121152,
						0.20977146727429746,
						-0.9496074544004975,
						-0.2564031908322182
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.7107739466358377,
						-0.6555064284993305,
						0.46890757597010996,
						0.1099645584005842,
						0.14754689540998475,
						-0.1687758110721574,
						0.15636675409576914,
						0.06746393065431616,
						0.0834895785381384,
						-0.37269788489339145,
						0.37550957125731255,
						-0.30693510269384133,
						0.2330639809878127,
						0.12018311558472528,
						-0.19345598788011723,
						0.17954321680995092,
						-0.3597746546949906,
						0.27809095261892314,
						0.1199222549671083,
						-0.7678015665561798,
						0.04345467685347136,
						0.10493494073316086,
						0.27687476144723255,
						-0.6744245611053392,
						-0.3564615219593534,
						-0.7562009863927682,
						-0.3434832304474758,
						-0.305264991778375,
						-0.01665405081487467,
						0.020779397190566373
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.17866448889114994,
						-0.0430669813810255,
						0.5245821490661442,
						-0.07324226380096777,
						-0.13470151819081388,
						-0.1459992892835178,
						-0.3446912652088835,
						-0.49260693552924545,
						0.48978250371492654,
						-0.045699659471548984,
						0.5313545955248741,
						-0.3082088596057519,
						-0.06004608615228056,
						-0.3354207863712588,
						0.06146590739155079,
						-0.39786724287715214,
						-0.3371217839181265,
						0.06705130149778889,
						-0.08546697825765504,
						-0.7324618716722971,
						0.5327953739831831,
						-0.19401036647770553,
						-0.31902675371108563,
						0.03213776701750212,
						0.1307293862964792,
						0.272885899960927,
						0.04129810433880723,
						-0.5579780752296801,
						-0.0030080791564128604,
						-0.5678755928143207
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.030962947472453175,
						-0.23154866415524708,
						0.10624997452253154,
						0.2701318676231437,
						0.06771642976684983,
						0.4064559773230066,
						0.414525770995817,
						-0.5798326923013075,
						-0.11962462055392127,
						0.0391475847036554,
						0.1239831640611414,
						-0.9667139675288441,
						-0.06498892833498279,
						-0.18486919830119633,
						0.3384706247142554,
						-0.1608395528705124,
						-0.07557715152156964,
						-0.06353868671589614,
						-0.11186425657254907,
						-0.13492529539661238,
						-0.28707368380294257,
						-0.47135758653635995,
						0.21205629028063952,
						0.2923097530384656,
						0.6282023926550948,
						-0.5237905072715924,
						-0.224821738558026,
						0.03920425039434434,
						0.10467241234329804,
						-0.366228090880499
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.6528619411556869,
						-0.12504253010192967,
						0.7015490334172088,
						-0.5362616833291272,
						0.5098428084138592,
						-0.5331208444021964,
						-0.33380252195231586,
						-0.46086574337279707,
						-0.4507010733435813,
						0.1357208825740338,
						0.22030866525192516,
						-0.2760276352270782,
						-0.46404546644980454,
						0.36323482811003244,
						-0.016912045337145878,
						-0.7374570548198403,
						0.03285876661304033,
						0.2456521604641504,
						0.20990170379559003,
						0.15935360767384213,
						0.14896307201040013,
						0.1542895229480356,
						-0.17595876006775743,
						-0.6926588535308194,
						-0.055274767267059655,
						-0.2445654748281344,
						0.0483017159360949,
						0.27591475988717495,
						-0.2586197958880681,
						-0.07698426147579604
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.09692700736761557,
						-0.36812402071482975,
						-0.04225854606267807,
						-0.07996043054085523,
						-0.17565853437950912,
						0.281353170588412,
						0.07120495626132797,
						-0.33425980560922725,
						-1.4496581022448416,
						-0.2713085613756051,
						0.00968532797928191,
						0.05010838930649201,
						-0.2090254239587074,
						-0.7679636338601162,
						0.48379450304715316,
						0.3080630274308493,
						0.19778509365068128,
						-0.04596795091848364,
						-0.11775820363650684,
						-0.016843488849420447,
						-0.004275563203251589,
						-0.10818772476813462,
						-0.16191305658118707,
						0.6106161663685641,
						-0.6781017748907722,
						-0.540965813620492,
						0.09808322081863156,
						0.14193557494624773,
						-0.020316531376150027,
						0.060556180243204874
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.27089272057336544,
						-0.0763758970495951,
						0.03298846038735427,
						-0.63991805413795,
						-0.7847601180215976,
						-0.18734736284615439,
						-0.0617585210008565,
						-0.24852344449131503,
						-0.32235056037721527,
						-0.012055958518862289,
						0.3068666054736681,
						-0.2564446548710891,
						0.6321225322486221,
						-1.3954418358567855,
						-0.37382609944904255,
						-0.008107670523330541,
						0.03725314227642616,
						-0.5725388008146196,
						0.21542072594201017,
						0.06856726558602146,
						-0.6020603979771703,
						0.04523901348019199,
						0.43832424163247347,
						-0.03031675162566466,
						0.43027169523892533,
						-0.22798787620253028,
						-0.03972434181588449,
						-0.9693826852392264,
						0.3701892749870836,
						0.1482844204829318
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.4420928350031394,
						0.2980174644929716,
						0.4669880015873874,
						-0.08310052222436548,
						-0.7928194905492618,
						-0.501460255423453,
						-0.20017127810848256,
						0.26577809331140034,
						-0.3002334616528552,
						-0.4073805272676605,
						0.07754049527559799,
						0.045182499667694324,
						-0.3424217499400878,
						-0.12285002698512656,
						-0.7405455367549615,
						-0.2250195103090458,
						-0.08681292363416099,
						-0.3078519764039893,
						0.32167734492500905,
						-0.5222716445482495,
						-0.21383698939311177,
						0.42732776046271254,
						-0.19215348994764622,
						-0.5495557263033989,
						0.0667254618839859,
						0.05282984876101182,
						-0.23471071457149828,
						0.49595326324436595,
						0.1195968807967612,
						-0.021625239420514912
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.2991513682363484,
						0.41923059516652944,
						0.16866232483438556,
						-0.4011057108021865,
						0.33658246105695444,
						0.017305193614506307,
						-0.1038224339102166,
						-0.48040782749751637,
						-0.9276746422324526,
						-0.9117516021063024,
						0.5326843960746492,
						0.1539567941428461,
						-0.30857998418438964,
						-0.28244256289834346,
						-0.4974319350993062,
						-0.45620991181381254,
						0.4196487876842358,
						-0.6302967799642183,
						-0.3270484437258232,
						-0.42711441646645715,
						-0.8006601163888216,
						-0.12795586555382119,
						-0.1487482443373644,
						0.16415232224716395,
						0.5471869546509756,
						-0.30648164376627035,
						-0.1595959494421322,
						-0.4596529255445627,
						-1.1456341145237379,
						-0.0076623619854137145
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.08445521900810553,
						-0.7504220975362045,
						-0.17142445150213442,
						-0.22623628854353006,
						0.5845056869562525,
						-0.11877026375532386,
						-0.05572383729643546,
						0.5742747725118754,
						-0.37328630721196115,
						-0.3179096110677262,
						-0.11043311533378351,
						0.477591489726251,
						-0.18482399190669452,
						0.2709599460327831,
						-0.8543154261664777,
						0.018656416717314855,
						0.366118582678865,
						-0.10253443894445025,
						0.3233120266841461,
						0.18300533162619295,
						-0.0011470764704842444,
						-0.44982945875306835,
						0.013030772266135499,
						-0.06136275677808018,
						-0.21089314374411583,
						0.33810642361757365,
						0.014713888986321585,
						-0.41514319002007877,
						0.28119964049827917,
						-0.011484803118354288
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.2618727584564203,
						-0.5683355942412013,
						0.10083787875104186,
						-0.020075892863876173,
						0.3850524693138089,
						0.18903395264063552,
						-0.33531028750015246,
						-0.9212779352472614,
						0.1251417068527624,
						-0.4734848198043681,
						0.3266867906381754,
						-0.39937956056232904,
						0.2695775473743138,
						-0.3154880536803952,
						-0.03301858039479666,
						-0.7922979684007367,
						0.27941667901816425,
						-0.06418157285208038,
						-0.24825211401005093,
						-0.30202251619501075,
						-0.12013599588857155,
						0.14304529207419855,
						0.3342213102987135,
						-0.3219771288161166,
						-0.24656831762881812,
						-0.7914664754791436,
						0.2728769440872438,
						-0.37817165217948584,
						0.11754159581772822,
						0.1751928046062855
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.27276685148391105,
						-0.5835110921079492,
						-0.27756016124800964,
						0.08680089062453915,
						-0.5129006244755462,
						0.14799398983154172,
						0.2912206110731202,
						0.06329107073375863,
						-0.5753126975351346,
						0.08441239170474044,
						-0.14745863939636925,
						-0.03935529575378808,
						0.26976767746112656,
						0.19904535717033395,
						-0.193859572747273,
						-0.28022531213241986,
						0.17395894342555288,
						-0.5063684927545224,
						0.03542839185114977,
						0.12290469648750903,
						-0.9057697972154702,
						1.110371874524612,
						0.4882540272532689,
						-0.2695245260521884,
						0.13040493338195092,
						-1.087494953866469,
						-0.9835748325054928,
						0.18677401135300356,
						-0.12075079455718103,
						-0.642150089907223
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.2616055758824185,
						-0.24712238955083862,
						-0.1315182087245436,
						0.08000886801384033,
						-0.47844148769245726,
						0.5771534897668927,
						-0.3025954128658909,
						-0.23525965437521226,
						-0.7896899868933841,
						0.1759542860959514,
						-0.35100984336989344,
						-0.18596459746487298,
						-0.7529237114691149,
						-0.644892677231555,
						-0.21130555003497745,
						0.2350020838294728,
						0.22700467691205395,
						-0.3086658702635483,
						-0.8236381388010251,
						-0.3455070866807909,
						-0.04539361847932787,
						0.3153026830032338,
						-0.40087597089893856,
						0.17915030493025416,
						0.5270915137620977,
						0.10346052582033183,
						0.35158368906274035,
						0.191818057978105,
						-0.1245386810953081,
						0.17280888349519172
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.3641757774790868,
						-0.5586960627867439,
						-0.2907118065776106,
						-0.8021085564350726,
						0.16521577126245152,
						0.36202882812035075,
						-0.523779112740309,
						0.2175260613078814,
						-0.0009621476609017671,
						0.2956724951275695,
						0.37190314566735766,
						-0.05399788109599054,
						-0.10783090857692204,
						0.07095111885804647,
						-0.27429429039970177,
						0.22662584257856788,
						0.17527910932604987,
						-0.17519145619327997,
						0.39736075560238804,
						0.38397583631444776,
						-0.45634133601333626,
						-0.5959830982426333,
						0.6759974698396402,
						-0.19775773018779577,
						-0.6833908505228615,
						-0.9870941078102103,
						-0.32308999800267274,
						-0.05348578514195044,
						0.13668795376454537,
						0.041287486521950925
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.18263060623111166,
						0.05041228271747646,
						-0.21036389962830843,
						0.21162613064542277,
						-0.045779086841266886,
						-0.806663910346423,
						-0.438203182820042,
						-0.21708887696010115,
						0.2120717389745064,
						0.13248212307936744,
						0.13443821315725746,
						-0.0321918392614192,
						0.02629314468632857,
						-0.2341319984861169,
						-0.6932116851425189,
						-0.0587460950484952,
						-0.044177378357080646,
						-0.08449069075630374,
						-0.09675603264456939,
						0.39956583283001496,
						-0.11612722926137173,
						0.18453543708062825,
						-0.6687346047678031,
						0.5453234068961715,
						-0.5725247364431955,
						0.2423088293077091,
						0.02895936699730288,
						-0.45439462701265626,
						0.08284705849205626,
						0.37692186826156326
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.20232286783063785,
						0.3437867436227026,
						0.22861018747007886,
						-0.431057928740927,
						-0.23692100403375926,
						-0.31921125782047155,
						-0.1998901273308483,
						-0.7080640521917028,
						-0.17069192918610385,
						-0.10522298691025049,
						-0.10574328742481943,
						-0.6438001427141561,
						-0.14210775986330107,
						0.45984280155338353,
						-0.768397218822549,
						-0.036702889914341265,
						0.18689921181845795,
						0.4939370981102321,
						0.014079049755334206,
						-0.012737486053247017,
						0.11898616576331797,
						-0.1599637727029839,
						-0.7068623640383341,
						0.23849135367114802,
						-0.5178561510561187,
						0.0921483812515817,
						-0.6694844544840525,
						0.06088189839005531,
						-0.3499683032659656,
						-0.30157439879601855
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.7010702341265768,
						0.17960999505088154,
						0.3010660864794619,
						-0.5029926963523973,
						-0.1573448691584772,
						-0.9956254903810713,
						-0.08855133125050067,
						0.5814711679194917,
						0.08388686672312948,
						-0.44703260844757764,
						0.39157079414686446,
						-0.4906127106892097,
						-0.07523267883282471,
						-0.10306961344652427,
						0.7542302727292525,
						-0.30251113256011036,
						-0.1500910074367409,
						-0.800851387670629,
						0.037824462765253815,
						0.13610604987142275,
						-0.3517723797443399,
						-0.1724467740479621,
						-1.0986024291641814,
						0.3825805143562892,
						-0.07374055645618657,
						-0.03711955444091771,
						0.014339601977214978,
						0.34259540488173607,
						0.3037864351682181,
						-1.087591764162946
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.707032497557057,
						0.02468513545962385,
						-0.9061194707181254,
						-0.5984407086855495,
						0.29382710044854116,
						-0.18476533565742384,
						-0.45983931903778696,
						-0.06535830435101031,
						0.15852841911396542,
						-0.14218507178846582,
						-0.47514762128907573,
						0.3377992598241112,
						0.694301960885513,
						-0.8568299843210506,
						-0.19323316873405466,
						0.34357093072286754,
						-0.3383060019424643,
						0.4903859022621174,
						-0.2175883572359367,
						0.34716707698460775,
						-0.7575169731070219,
						0.4357121948590255,
						-0.17669384807138633,
						-0.20109672765150893,
						0.015603013345191215,
						-0.6224021567784815,
						0.06894610446611184,
						-0.2565139944945234,
						-0.1854469697147707,
						-0.9300268571945297
					]
				}
			],
			"biases": {
				"sx": 1,
				"sy": 1,
				"depth": 30,
				"w": [
					-0.3806524889553515,
					2.562038293797605,
					-0.2157926404744919,
					-1.043100507848154,
					0.27581926783005695,
					-0.962341456892279,
					-0.8070610342453545,
					-0.19549086973765606,
					0.004445008382907733,
					-0.4994605927060353,
					-0.8654081819118652,
					-3.000073238117132,
					0.16528853758662673,
					-0.9734924143525053,
					-1.8046790487943216,
					0.10040666948699689,
					-1.4607303827703315,
					2.1099822831388777,
					-0.30619969715894063,
					3.5223269031439766,
					0.340955420275931,
					0.1998099585687686,
					0.7813853199299126,
					-0.8584172077509715,
					-0.9305466465044159,
					-1.017893021883635,
					0.6921007997516666,
					-1.0963831311804435,
					-1.8924170837754417,
					-0.7119090946919763
				]
			}
		},
		{
			"out_depth": 30,
			"out_sx": 1,
			"out_sy": 1,
			"layer_type": "relu"
		},
		{
			"out_depth": 30,
			"out_sx": 1,
			"out_sy": 1,
			"layer_type": "fc",
			"num_inputs": 30,
			"l1_decay_mul": 0,
			"l2_decay_mul": 1,
			"filters": [
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.908512794806793,
						-0.1073090040313742,
						-0.3136514660325281,
						-0.3640899335818411,
						-0.16465128173172344,
						-0.5015177112081455,
						0.04757666035750653,
						-0.5159404678030491,
						-0.00704258027288652,
						-0.04207357563526208,
						-0.4878167617324585,
						-0.8028704410045637,
						-0.10912714556904186,
						-0.06285321702532973,
						0.02015473277049529,
						0.19170182185047696,
						0.44627137067886785,
						-0.31914558665004145,
						-0.27185400634702667,
						0.0033508598648686484,
						-0.5525660673281528,
						-0.3194629835478544,
						0.02760325248590646,
						0.1477200752970502,
						0.29494436421977066,
						0.08094833238858268,
						0.35132713698185886,
						-0.07957105894126194,
						-0.35013351381884694,
						-0.22548236964668456
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.16586700886344682,
						0.19488141217151056,
						-0.15719678241535634,
						0.033716967655899426,
						0.3986678991295036,
						-0.2401620386337104,
						-0.13627934928608654,
						-0.18439589907925827,
						-0.17176560379407788,
						-0.018951612615834036,
						-0.27051513331330945,
						-0.11492132141556807,
						-0.2826876395306607,
						-0.053753145306811155,
						0.06973607353814619,
						0.052968953571350785,
						0.018918529374510967,
						0.025417739628686584,
						-0.24332153634128817,
						-0.6502356013796566,
						0.0820827943840447,
						-0.010453205061870896,
						-0.3518548674618547,
						-0.0946595567779687,
						0.08910246192924327,
						0.03670426438774955,
						-0.15076839701858682,
						-0.2365889088504715,
						-0.5319318872724251,
						0.034325629088499426
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.1133753287658214,
						-0.49672408275255947,
						0.008538982138877818,
						-0.15256865476305742,
						0.014827281770604337,
						0.18499376126803768,
						0.04196709422166385,
						0.07977737029452038,
						-0.5779704601431223,
						-0.13151696676133878,
						0.33557586183196725,
						0.1824603703087355,
						-0.4449832371550164,
						0.026424464456996914,
						-0.11057610981071293,
						-0.10453356108451496,
						0.16609995267267355,
						-0.42204140600058965,
						-0.40930977227072063,
						-0.45889996071069805,
						0.3999098306376068,
						0.11819177749153212,
						-0.5614748518575335,
						-0.12072057478139861,
						-0.21947794680494478,
						-0.4817040895891214,
						0.08927603106445978,
						-0.01909751007945477,
						0.22636797988861843,
						-0.03275596012576697
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.0562246306268883,
						-0.28732099693409036,
						0.17649997452004243,
						0.13587309024508182,
						-0.16779382630400488,
						-0.16838025476519122,
						0.30221720484751413,
						-0.39799339058034333,
						-0.4264324526204501,
						-0.9828055282171974,
						-0.4707943001458611,
						-0.4686319139521762,
						0.05420596807409855,
						0.4195585463160324,
						0.19547684337723,
						0.0272287591982517,
						0.1136910949845326,
						-0.3120393902041992,
						-0.15109009423280953,
						-0.5002348864081575,
						-0.10144778939167876,
						-0.23416612463807474,
						0.36459191959738896,
						0.22401459582834465,
						-0.46264795286476923,
						-0.11347779832678044,
						0.19086888488590753,
						-0.7981247693068135,
						0.06711996477958822,
						0.16969596914084614
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.18757356064704236,
						0.08358872015045384,
						-0.057896734366566435,
						-0.16027276651257408,
						0.34334435723184636,
						-0.09621308768203556,
						0.17992685053214966,
						-0.4222074907925234,
						0.0806518338652051,
						0.45113334812910266,
						-0.1699638111538178,
						-0.590765876099589,
						0.024167870773467163,
						-0.4922038987063659,
						-0.47396204191392266,
						0.22967428058260458,
						-0.3154827624436618,
						-0.14463853853002592,
						-0.7649996202786462,
						-0.015006842656514285,
						0.2532058253241594,
						-0.26370278993613494,
						-0.22845265451924016,
						-0.3571945136794928,
						-0.4385085367327119,
						0.07065006136322541,
						-0.29393407393211224,
						0.0656084795135502,
						-0.1297222310998486,
						-0.8467803256016254
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.1818945438939402,
						0.25739020544433283,
						-0.07357440233180532,
						-0.08711438565816278,
						0.13185972455868544,
						0.15907022079238936,
						-0.18997242049698185,
						-0.13117551408611458,
						0.09539100288670546,
						0.16540403357700742,
						-0.2996237316354587,
						-0.738539448068021,
						-0.1404383767996336,
						0.1272440863050895,
						0.28042579334355694,
						-0.42654722549598506,
						-0.012046939535185425,
						-0.1544905486155792,
						-0.3513801566932563,
						0.2673531136466724,
						-0.023538055089996037,
						-0.11671801792846291,
						-0.01517823058597948,
						0.09916850182028734,
						-0.3216918591437513,
						-0.32409471469905016,
						0.11815857244622123,
						0.041527168016273694,
						-0.19716585750524337,
						-0.2232509236038253
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.13704397151504932,
						-0.5791609954126148,
						-0.031306410562355766,
						0.004442233436391866,
						0.12836991184798408,
						-0.13495621434963456,
						0.023830384655549094,
						0.025690029178098456,
						0.11887724117678894,
						-0.17480192950135265,
						-0.37954405601851476,
						-0.02218655258589215,
						0.04961631100116777,
						0.09018689937387345,
						-0.6037289196010814,
						-0.6194453366596038,
						-0.6833158593760178,
						0.09590985314685774,
						0.06036093768606632,
						-0.02071108349207934,
						0.4241976422264786,
						0.25199746225900593,
						-0.2230404886776327,
						-0.6765386061374649,
						-0.3622016767013325,
						0.26865294272479817,
						-0.20989576729998627,
						-0.11892406563674233,
						0.19668166737448584,
						-0.2732584926413163
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.004763784961548806,
						0.04912171900080283,
						0.17846333461928254,
						0.1439823806085845,
						0.20990765736558048,
						-0.5856199750327677,
						-0.03806417755822109,
						0.1887670505760359,
						-0.424043898218626,
						-0.5802746534676316,
						0.16454250865566092,
						-0.016341101258876695,
						0.1833703509413383,
						-0.7437743741174097,
						-0.07034418266938039,
						-0.9835283672290581,
						-0.6566651480643259,
						-0.11528712739576527,
						0.012023606075016203,
						0.12225210746209705,
						-0.7731792152079446,
						0.2712201280341579,
						-0.9174052195239027,
						-0.21977785323150884,
						0.16843107771279825,
						-0.24483927308824635,
						0.15491289333051766,
						0.052112044620923594,
						0.06892935643603676,
						-0.035500603648134815
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.17210489419472008,
						-0.4949072122694131,
						-0.1955227517618985,
						-0.28780923788800067,
						0.20986126097104513,
						0.3231706871704651,
						-0.06927366810325895,
						-0.9261766452909577,
						0.005136228313843906,
						-0.28582253587543904,
						-0.18442198166013996,
						0.001618994751145127,
						0.22707697122803183,
						0.11149377645840634,
						-0.43840867058928407,
						-0.1901760775152239,
						0.2308245037634324,
						0.20593818815300385,
						0.24235024581866044,
						-0.3278234659502901,
						0.37490631546398206,
						-0.07221011079009357,
						-0.09737537619917234,
						-0.12498632395993697,
						-0.16210204377276205,
						0.20311966596384642,
						-0.11620911517466512,
						-0.9340215536825137,
						0.14683285654607459,
						-0.4625970062595569
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.22069273710942783,
						0.1529621359022946,
						0.46463654459935483,
						-0.9106666365599052,
						0.3273200499652484,
						-0.21384207663525007,
						-0.01712250465439641,
						-0.16650339868359953,
						0.32031980686474887,
						-0.16992472661323252,
						0.2258037819903923,
						-0.585897813572225,
						-0.06111992161356017,
						-0.45105705603444063,
						0.0944551031008449,
						-0.2569657754243527,
						0.0004524479044798081,
						-0.2566844318096972,
						-0.13489985781945604,
						-0.3284666446531338,
						0.5389787833431241,
						-0.33988433560685244,
						-0.19462666654081054,
						0.25839943232120466,
						0.026274227793494476,
						-0.38213375793109544,
						-0.348084117670499,
						-0.26424590842173085,
						-0.5424362408714334,
						-0.4114157801131414
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.13124018279610988,
						-0.47141105642305103,
						0.06320501848351637,
						-0.5923070158815502,
						0.5295479636204157,
						-0.6834865742277104,
						-0.19995496993425152,
						0.04420671278083294,
						0.4699903996096128,
						-0.12540580980016228,
						0.046885522876667064,
						-0.3626552855519345,
						-0.7296524471625376,
						-0.3181097274151823,
						-0.11823337208130819,
						-0.18659404602726082,
						-0.6178620357362501,
						-0.484211437850742,
						0.06212077858295177,
						0.3213384861871083,
						0.1027295938196647,
						-0.44581974998237234,
						0.4360553209587438,
						0.32371900644644197,
						-0.27748282587611534,
						-0.40554200837737386,
						-0.3900581442568542,
						0.22739449981593782,
						-0.3720360947156202,
						0.2328140059601192
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.09386050336984435,
						0.019083134739471402,
						-0.2598971182099714,
						0.16181650708123665,
						-0.0489189295903427,
						-0.1431337977576263,
						-0.18242384215004134,
						0.022879059656384277,
						0.7843979821953221,
						-0.2741728523918215,
						-0.22628806252833306,
						-0.5140533889947633,
						-0.008792779062517785,
						0.042602012324163094,
						-0.19531781615524424,
						-0.15170150496863127,
						-0.1398917873269192,
						-0.09311194073371715,
						-0.14719216591246798,
						-0.19604594357697516,
						-0.2805136248048223,
						0.11209679112609776,
						-0.13077885407777018,
						-0.5875829439577919,
						-0.03487060551720318,
						0.0019498902234809893,
						-0.3423112307561866,
						-0.03880692771503829,
						0.10956703547879665,
						-0.5034785089561576
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.42896238854587354,
						0.24290676910890108,
						0.20497153649525943,
						0.4157029330689556,
						-0.5673767699906347,
						-0.15490318089238317,
						-0.7458709794368626,
						-0.38332676546176236,
						-0.19817121388276682,
						-0.05337046290061557,
						-0.13845801311665598,
						-0.45678897440168786,
						-0.3601670658387903,
						0.16030040631548015,
						-0.2256680276457703,
						-0.08136897188314794,
						0.2304888253500246,
						-0.4263000779135817,
						-0.30843820544806305,
						0.3717189101698044,
						0.012358375909013036,
						-0.5063867907985685,
						-0.06012887651514466,
						-0.11553063056757079,
						-0.15196656879748136,
						-0.2128750757141409,
						0.37265616254897177,
						-0.18134859414259635,
						-0.5028250103919963,
						0.25629640449236585
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.0406670807810219,
						-0.07230811725764613,
						-0.03618599318458106,
						0.15237739024984773,
						-0.14558097216445887,
						-0.4518833664117618,
						-0.0608512108316731,
						-0.17842830855308045,
						-0.40121100550565036,
						-0.07299688279259382,
						-0.3475598511148399,
						0.057506411743388525,
						-0.280128898583588,
						-0.3332377929583101,
						-0.0886109559857586,
						0.06500975700290929,
						-0.014243669165139047,
						-0.06273645690103545,
						-0.09953121499031642,
						0.08248851644269585,
						0.2393739865493962,
						0.14473807859555252,
						0.1856188709351715,
						-0.816909230122174,
						0.02371884127613805,
						0.02618081794697977,
						-0.24196599989067563,
						0.08024474113034734,
						-0.5536801206620537,
						-0.1375408241067172
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.8438794556372987,
						-0.47034345468100575,
						0.10292181555325956,
						0.024881114459610384,
						0.0026561404398240556,
						-0.14729495458982794,
						-0.10332307591302065,
						-0.04773566152415379,
						-0.12007594397628385,
						-0.04517886308811579,
						0.06729179230273268,
						-0.02131813327994295,
						0.008900566577673788,
						-0.34140651184791193,
						-0.4315448137085259,
						0.016267247252741715,
						-0.27503343425441573,
						-0.42698074871224057,
						-0.44168230093793054,
						0.023579147959602184,
						-0.050591265425985944,
						-0.5316217047548397,
						0.11617464741556952,
						-0.25139585870252673,
						0.36336251143921355,
						0.07633918195903908,
						-0.3987052924819775,
						0.010290606383399495,
						-0.3219297394669307,
						0.5751910588160991
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.36530842666795316,
						-0.06507538490681632,
						-0.06173917116612903,
						0.0664203803163784,
						0.3362755090189257,
						-0.4799630317552569,
						-0.4370163583622755,
						-0.018184089665294903,
						0.9057184756771399,
						-0.5786303752129339,
						-0.13150066548279765,
						-0.2701593403130392,
						0.2997338055706675,
						-0.29109913873930543,
						-0.022315645591728234,
						-0.3239170377150653,
						0.12549019988622662,
						-0.3371757800883415,
						-0.32019231699249157,
						0.1655311974052117,
						0.5975023570903429,
						0.23887626393560288,
						-0.2772835501770869,
						-0.699322097756085,
						-0.00990365910889134,
						-0.44961207112584567,
						-0.0364108206042954,
						-0.3131615220853582,
						0.037707259797013365,
						-0.04667813844586962
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.32285191881049513,
						0.06909460389557513,
						-0.7638232657711977,
						0.08744150617082004,
						-0.20888655094608144,
						0.039812895313880214,
						0.02785188782089688,
						-0.00839235823434919,
						-0.09397620683959468,
						0.0913716443993175,
						-0.3381954049977693,
						0.081722199224984,
						0.2284493018352058,
						0.02573817980153946,
						-0.09308370664063159,
						-0.04273189435904332,
						0.4982793734858998,
						-0.7228831460339237,
						-0.4283841125150574,
						-0.5790713543318563,
						-0.23892655598227147,
						-0.43006552221656197,
						-0.10148808774989716,
						-0.02215900008313612,
						-0.37950523717299844,
						-0.7964786542340849,
						0.08559995236293524,
						-0.41122309487202763,
						0.6211313139306424,
						0.1405454703542408
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.6962979641406236,
						-0.25630188985730645,
						-0.7135959817585784,
						0.35979853264102074,
						0.5682341002739345,
						-0.40526548359553394,
						-0.03719713125661957,
						-0.19789757692606608,
						0.30236061563725763,
						-0.20884277410988036,
						-0.1896481245695196,
						-0.366203597245391,
						-0.24133755085211236,
						-0.01242309455268124,
						-0.16317745079417073,
						0.31291440228608064,
						0.35106448909252697,
						0.10924976825804031,
						0.11269699034586576,
						-0.01248123484763951,
						-0.0780936540641206,
						-0.585850458786868,
						0.21045839115613643,
						0.16331747387433415,
						-0.5675002506414893,
						-0.3032264971978298,
						0.010188794525323607,
						-0.023254566058598814,
						-0.16565291923592249,
						-0.1671079939924423
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.17607618361888314,
						-0.010118371457840917,
						-0.22542256741550595,
						0.20873531501392725,
						-0.38682709362946854,
						-0.09553132081511169,
						0.01716812429202415,
						-0.5142831902801864,
						-0.4918533595712533,
						0.4932140256963079,
						0.15076004295639303,
						-0.4032048130212204,
						0.4295413980984663,
						-0.1140541763807216,
						0.04123011391900589,
						-0.2060023736016306,
						-0.36448780328382097,
						-0.5077491811845264,
						-0.48592661055737646,
						-0.34118819753857516,
						0.4880543917302496,
						-0.30324703955766086,
						-0.15081392190054008,
						-0.8983709817294359,
						-0.41803822682212144,
						0.29587924249125724,
						-0.61050044154889,
						0.010650869922950813,
						0.2759857346805859,
						0.30229961310148723
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.5433369269480978,
						0.20383887155763586,
						0.084800352750415,
						0.17882144999888513,
						0.17303029927144706,
						0.1506429828827187,
						-0.19057595392026638,
						0.15145891577339832,
						0.09481612022165958,
						-0.11545305173231588,
						-0.05247625855620372,
						-0.1810097265484992,
						0.4713778938921658,
						0.17524165755905835,
						0.08460399801510742,
						0.22369999349145592,
						-0.8209816476749963,
						-0.3548284752676244,
						0.007898156521902039,
						-0.26374728788457624,
						-0.1247953217541541,
						0.14622867825217503,
						0.006878271335420869,
						-0.49332946213859324,
						-0.44412338419557273,
						-0.15204892932224995,
						-0.6132278049417461,
						0.06638281356189454,
						0.0763018481413233,
						0.04514051563743881
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.2964305837524822,
						0.31057687947659984,
						0.08066236240146299,
						-0.44261758683079216,
						-0.5039081555674533,
						-0.23946578736142973,
						-0.024738351630910243,
						-0.457009766790168,
						0.22824135114739566,
						-0.44447889330390294,
						-0.6847210832591933,
						0.05185094789513893,
						0.05481152137810509,
						0.11743721920424756,
						-0.14890794830819326,
						-0.45077277160663065,
						0.0752774482574555,
						-0.7806811776040261,
						-0.8619356016093033,
						0.435525083167597,
						0.01995023386266339,
						-0.44876381407625043,
						0.3235064042659754,
						-0.6300267985598612,
						0.18479627521749656,
						-0.05461369783156813,
						-0.05589415758710021,
						0.03357853428034009,
						-0.31083481537679297,
						0.07737649337502026
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.0821009332255434,
						0.19878263353648315,
						-0.4207167625790667,
						0.1442572332766741,
						-0.2532560685893222,
						-0.47042496579567145,
						0.12506184099082585,
						-0.2143313184739131,
						0.054100577697532355,
						0.06271119511319757,
						-0.06203063202955669,
						0.18185921404203043,
						0.1492502617804268,
						0.0986765482042566,
						0.09869448096030886,
						0.16742784077715114,
						-0.29341987235559497,
						-0.38996072342204047,
						-0.2428182830388501,
						-0.461263931530783,
						-0.25337864006943783,
						-0.14809835930826704,
						-0.7474095397127273,
						-0.3526014193172037,
						-0.29942240196936687,
						0.22831502030517353,
						-0.14671859414657354,
						-0.3903295856119585,
						-0.5879173286929564,
						-0.029925528039211995
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.0539470372308586,
						-0.4531276106364037,
						0.02291599821685315,
						-0.32781230545632434,
						-0.17168525201963708,
						0.11171519101367758,
						-0.02207653478278422,
						0.05907183569239818,
						-0.10261067453458683,
						-0.7574720855770782,
						0.015033045751738618,
						-0.10864670936423258,
						0.006661664826619841,
						0.20830272990760323,
						-0.01650822983750872,
						0.22549475725631968,
						-0.34285502173142923,
						-0.16618195685718476,
						-0.3148108423800954,
						-0.5163851504480443,
						-0.2823662214229951,
						0.10912796996705564,
						0.15667350514354858,
						-0.11775166812268116,
						0.18557505076509873,
						-0.17067309004621053,
						-0.03131608298487753,
						0.02540933975614701,
						-0.8774912875017328,
						-0.05644483992689109
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.10489814343199887,
						-0.49743615012494474,
						-0.07111443227064591,
						-0.09501881951387495,
						-0.004201776917118711,
						0.03500038585191326,
						-0.5910530200106697,
						-0.42884824058942017,
						0.5506943938330624,
						-0.10329579592878894,
						-0.617607885585583,
						0.15208536922269209,
						0.014352579508242458,
						-0.985378927494717,
						-0.7544865464416958,
						-0.13731535431125538,
						0.03928497953850745,
						-0.07664003140951968,
						0.12039992363374356,
						-0.520121919365141,
						0.46913773266151787,
						0.3587493237359517,
						-0.21824590717179868,
						0.3021176252346056,
						-0.4098503809185012,
						-0.585788299811883,
						-0.09789663514664973,
						-0.049204868802048295,
						-0.5286568221379107,
						-0.4372523584092949
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.3966810162880676,
						-0.40662478415109465,
						0.09094991768472926,
						0.11853251817059346,
						-0.12951101837027781,
						0.20014618664956918,
						-0.00015637203477312774,
						-0.5269650376595597,
						0.17670146693298508,
						-0.1277292352589615,
						-0.044454356823861646,
						0.03699113223056586,
						0.5816541870737816,
						0.11608711527778486,
						-0.016798035250076476,
						-0.980674176389721,
						-0.7084979943005518,
						-0.5193889886402826,
						-0.08837929918705625,
						-0.37255082443264553,
						0.1949123821093102,
						-0.45049454134231565,
						0.24389377141560592,
						-0.4603340379404239,
						-0.08639555241119157,
						0.21713174984203476,
						-0.040738474734888244,
						-0.5326572695901032,
						0.3669227965077369,
						-0.8942439472322253
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.31417426075112487,
						0.1589508195112998,
						0.22291032837430594,
						-0.2959262143078212,
						-0.425927852657997,
						0.18209614469259372,
						-0.17537845055807075,
						0.10578482810011226,
						-0.035296906504973975,
						-0.016010273651805348,
						-0.5212949710438538,
						-0.09493604907760839,
						-0.46975322363196853,
						-0.09010058525080522,
						-0.16502609516936287,
						0.12126817630286271,
						0.26485983280336656,
						-0.49077076944456255,
						-0.18357500332814772,
						-0.15201200355910344,
						-0.0744895820127215,
						-0.23941002190174,
						0.09058745705050754,
						-0.8695633820363875,
						0.36584546408543894,
						-0.43061327601681787,
						0.049351427334777966,
						0.0007546122430129054,
						-0.40113629070919415,
						0.22349673572986475
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.09038408425298013,
						-0.15312394778792165,
						-0.46815826194582133,
						-0.1759296216795485,
						0.23706277859251138,
						-0.2175410663845128,
						0.17957104313174352,
						-0.09721100612935081,
						0.07718881055061004,
						0.2552229159576645,
						-0.11333260797515238,
						0.024826587557433024,
						-0.13475863420148124,
						-0.3922505819153987,
						-0.42766777336106515,
						-0.1935982741652503,
						0.005832569742858402,
						-0.14035693488769194,
						0.016030037404739156,
						0.021669809290002097,
						-0.0330209673439915,
						-0.2980684785837236,
						0.2264521091902868,
						-0.1424193978795613,
						0.03319292182751311,
						-0.09582309536224251,
						0.13122698314474307,
						-0.765126893591639,
						-0.44996040250423364,
						0.06712259220341091
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.04457544731656201,
						0.18888813021341547,
						-0.20249768475025925,
						-0.311967330739198,
						-0.07285321733857504,
						-0.18039926672531736,
						-0.2198553641603244,
						-0.053802377679665475,
						-0.3021632992265121,
						0.06207998836661643,
						0.22035937191709093,
						-0.06657750459504169,
						0.326328079505216,
						0.13802862589952028,
						-0.4551129202746971,
						0.25258543782378784,
						-0.08862590087831593,
						0.09974855891133357,
						0.08565971908324142,
						-0.08158887431486894,
						0.09730840037847831,
						-0.3232742961336851,
						0.10937436633296664,
						-0.150978094468751,
						-0.12371919531707865,
						0.14161988309321166,
						-0.30367171457272,
						-0.1855051110394468,
						-0.013916826597824448,
						0.46936022069846356
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.038384124549834316,
						-0.4048128310662084,
						0.15307366071106743,
						-0.32608048859346833,
						-0.8047274449167846,
						-0.006043913110821502,
						-0.14724536772263733,
						-0.11448431171009969,
						0.18242102067569232,
						0.27730073050156584,
						-0.1600268254523506,
						0.19907006301649252,
						0.2590756272688098,
						-0.7609504065890422,
						0.023485998957792673,
						0.07554555148477213,
						0.14211056996150528,
						-0.06906848748345712,
						-0.9267368440224951,
						-0.41427564876984674,
						-0.7203359107735443,
						-0.8842246651987484,
						0.1238029586370094,
						-0.18600124419858546,
						0.14355361419183132,
						0.31051690374539975,
						0.059648753165069755,
						-0.013795248009223715,
						0.14944542899219715,
						0.6468404439472434
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.10555314410383568,
						-0.5791613363969926,
						-0.15948370083785637,
						-0.8173777116731904,
						-0.11353007234253518,
						0.4159084110586966,
						-0.2675348470846171,
						0.14030861349644863,
						-0.6195402087854844,
						-0.2750779376290547,
						-0.08680391972963283,
						0.03133863696880846,
						-0.472080248136358,
						-0.09619513621637307,
						-0.023130710757047483,
						0.3013994457064128,
						0.15527514097791228,
						0.038896020987336216,
						0.029580113326783772,
						0.1796417912714323,
						0.09800552258742523,
						-0.1267604404299159,
						-0.25934401968062415,
						-0.007597886881638904,
						0.13001040928381852,
						-0.027162874683982707,
						0.08071492686990596,
						0.2282697837013988,
						-0.44825488719562245,
						-0.418078174243667
					]
				}
			],
			"biases": {
				"sx": 1,
				"sy": 1,
				"depth": 30,
				"w": [
					-0.1062621071089094,
					1.0942647155363048,
					-0.23284398635326292,
					-1.2886575082774154,
					-0.06781384480643403,
					1.8077984029592462,
					1.2987242532656942,
					-0.9000902102154276,
					0.8707474076818679,
					-1.1380986975332195,
					0.951680921178231,
					-0.3009368353665953,
					0.6034873707395477,
					-0.24072869694333196,
					-0.1009720031614802,
					1.257803953556539,
					-1.0778388439506228,
					-1.0388676373810843,
					-1.0548745387675589,
					-0.09338162506691867,
					-0.4561805467026318,
					-1.932995583562057,
					-0.07090370299635183,
					1.4813070223244464,
					-0.25934247960616824,
					1.8560043934470225,
					1.1872164884861596,
					0.5224648558339676,
					-0.7469823947696318,
					0.5695280550954083
				]
			}
		},
		{
			"out_depth": 30,
			"out_sx": 1,
			"out_sy": 1,
			"layer_type": "relu"
		},
		{
			"out_depth": 30,
			"out_sx": 1,
			"out_sy": 1,
			"layer_type": "fc",
			"num_inputs": 30,
			"l1_decay_mul": 0,
			"l2_decay_mul": 1,
			"filters": [
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.2670822128286472,
						0.3278803022375828,
						-0.24961682307786365,
						0.0935903857077283,
						0.21727859312299141,
						0.12665137597549847,
						0.03773785211686382,
						-0.12471838725590172,
						0.19167649114706858,
						0.46875560540773215,
						-0.2987524639784782,
						0.47580518370807057,
						-0.07164445797891325,
						0.12099380918034734,
						0.23371528995630178,
						-0.34197569506023073,
						0.040247739621096,
						-0.6012212796066981,
						-0.5937983655083013,
						-0.4657846945654834,
						-0.14694818840532917,
						-0.24686379092511437,
						-0.029288557406303643,
						0.18155212707612234,
						0.3537952516251657,
						-0.2967854590238919,
						0.04507361793059562,
						0.17201713660693096,
						-0.08670555175990446,
						0.15450391805013539
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.36919227130310317,
						-0.004073931945875746,
						0.05065850932662258,
						0.12474667805221058,
						-0.19764097630922275,
						-0.026724595931334572,
						-0.012233999064882364,
						0.11887061417932528,
						0.03291329146561542,
						-0.3294679980499203,
						-0.14814422621072332,
						-0.08327405801727604,
						-0.1151179770678711,
						-0.03980672715703357,
						-0.1036734659520427,
						0.015470620201317665,
						-0.2699278800423312,
						-0.17327870462941455,
						0.13069082081264333,
						-0.42979965406009885,
						0.05810070414394132,
						-0.15786546129563278,
						0.08759546133888801,
						-0.1274146178496257,
						-0.25896228687582884,
						-0.03896965310955176,
						0.10098773340274807,
						-0.15462231518735545,
						0.04823918007606643,
						0.048358974744632
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.3044941341983361,
						-0.14866319815078613,
						-0.07744714348033419,
						0.05925237682178553,
						-0.017442970772271523,
						-0.00723275148721812,
						-0.19476775429065463,
						-0.30535550054745964,
						0.1732562379381314,
						-0.25421565632613924,
						-0.20104859040131118,
						0.0022970374079492443,
						-0.1634889837093182,
						-0.21034003710213273,
						0.03818532215522693,
						-0.27294773729215177,
						0.16103569915961424,
						-0.27110476693780583,
						0.0338702452550757,
						0.04628940451381061,
						-0.21189660193928275,
						-0.1459832880791418,
						-0.11206906810951643,
						-0.5072274865629213,
						-0.12425312701672046,
						-0.07177205230805178,
						0.30969438533740956,
						-0.1469364184499862,
						-0.04811859971400268,
						0.04832507409380063
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.2932450397678069,
						-0.04243503844455274,
						-0.010164565448934477,
						-0.0521860574199955,
						-0.6013418205440517,
						-0.583589517343313,
						-0.29649679168356285,
						-0.3115756112929573,
						-0.019546156539216222,
						0.1251578391533637,
						-0.25415904993896715,
						0.13909528569041027,
						0.04842047305957922,
						-0.27148325532003426,
						0.0026169789158369656,
						-0.20302746678062067,
						0.11078451918825896,
						-0.25582098859200386,
						-0.43718830615973703,
						-0.035376538810985146,
						0.09915203081363015,
						0.1538051662096693,
						0.17029743890244534,
						0.08001067229965324,
						0.004399663480125895,
						-0.1120065371330381,
						-0.18440083724865122,
						0.07042613243659158,
						0.08353289843459724,
						0.0174557878505992
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.2865088932886533,
						-0.04928986415044089,
						-0.15824258454423398,
						-0.02952011499719277,
						-0.02960604785822626,
						-0.3900406939964481,
						-0.03731705086419864,
						0.43074614299775493,
						0.1451402848255654,
						-0.0287400508777923,
						-0.26718152339532486,
						-0.08794642093340782,
						-0.12097626398313764,
						0.20872342823308151,
						-0.10072047343641798,
						-0.9048896119802112,
						0.04647578304159847,
						0.1357448474580387,
						0.31846082340969956,
						0.14007643683794777,
						-0.3697465583641218,
						0.12864992589765045,
						0.01141831112207678,
						-0.09501374668449242,
						-0.4972725608093168,
						0.16595506662190856,
						-0.26218528682201675,
						0.045206774719042005,
						0.05454077943210897,
						-0.12515095462897832
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.055161706270644616,
						-0.17696569391887665,
						-0.01245487141115209,
						0.1407258835864294,
						0.10991477037855878,
						-0.5323393448180913,
						0.03039775022146611,
						0.13726417241739672,
						0.10702629689176295,
						-0.009438274506031904,
						-0.16487702020287534,
						-0.5409771115030443,
						0.10985149919568397,
						-0.03707471945486066,
						-0.12537031735820953,
						0.06124365257511957,
						0.05476250218107496,
						-0.020249366859733085,
						-0.38816391551405216,
						-0.0007608815871081541,
						-0.4139484813155425,
						-0.5235049991226528,
						-0.6618426000994071,
						-0.011841409451320313,
						0.24341216602844146,
						0.02230890027482352,
						0.05120754046799062,
						-0.38109321311490085,
						-0.7167618485311413,
						0.10661191467563365
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.14718796650352695,
						-0.1777810785136621,
						0.11813482933594234,
						0.0806522846698861,
						-0.1479515182808271,
						0.1000405977660739,
						0.24554761047135737,
						0.14530595942030017,
						0.33193664314093474,
						-0.16556796255999642,
						-0.35515065454856243,
						0.053999335092560136,
						-0.2736632784528112,
						0.3931247293758323,
						-0.021016095227530476,
						-0.07302284662282778,
						-0.31659980389997566,
						-0.0945198405837436,
						-0.09941036428994356,
						0.1412293924416371,
						0.01827781332375089,
						0.28872882819323725,
						-0.458241748614019,
						-0.057026191264625284,
						0.24131624239963026,
						-0.29438444241798667,
						0.33641135817398626,
						-0.3118900284336773,
						-0.5019824767397894,
						0.2697989773623273
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.2583022739118628,
						-0.2052925087741846,
						-0.14174319836415114,
						-0.5159677997275125,
						0.017699199218358913,
						-0.4733435372036379,
						0.1460363215203756,
						0.24291647832977056,
						-0.33452825899285515,
						-0.0958220786054637,
						0.10534210374156915,
						-0.2666168079950198,
						-0.2764270672301049,
						-0.1152703731707847,
						-0.1874876754637895,
						-0.12315036674281153,
						0.1603563221646876,
						-0.00652709912970207,
						0.02223135327705147,
						0.3056948131410853,
						-0.17981300746919893,
						-0.21661153034210237,
						-0.3058634520109691,
						-0.1987034133120067,
						-0.10336948815985414,
						0.08156284726290147,
						-0.4350536294575579,
						-0.12051639528476815,
						-0.4510802892509332,
						0.172728313147826
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.018051435926112937,
						-0.1890531960825358,
						0.15485601146888522,
						-0.10188514246912062,
						0.030842761869654022,
						0.0173787893674337,
						-0.48081761804652046,
						-0.1156294852339762,
						0.019076556263885193,
						-0.4503248796913862,
						-0.006561871744046271,
						-0.14308077036541553,
						0.12268677343418588,
						0.03375780616113329,
						-0.3535401593105731,
						0.3624649660324013,
						-0.044934405349513,
						-0.15419909634537846,
						0.19125079843771647,
						0.16756293373955194,
						-0.08113490807171009,
						0.1525598779632163,
						-0.044249362736166004,
						-0.42971954608246776,
						-0.37251346250270667,
						-0.07495783239856331,
						0.11712812469228236,
						0.09274243026189044,
						0.002533794426319725,
						0.032457907557189865
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.32827364257197117,
						0.16000710514016425,
						-0.1390864984361501,
						-0.08106079955039946,
						0.2492213344895709,
						-0.13254715874688747,
						-0.035719218630671096,
						-0.2888222522316688,
						-0.008881967076039946,
						-0.12180636353513978,
						0.21760055235514275,
						0.32102969324009406,
						-0.08557553480151794,
						-0.26626186096354504,
						-0.4991896424261249,
						-0.2192650224975658,
						-0.11874837600865092,
						0.044832964025117904,
						-0.19488729898503068,
						-0.09722241854201479,
						-0.35590258593665136,
						-0.041931835857878824,
						-0.13829575063940164,
						-0.04014752702528217,
						-0.10410495350771941,
						-0.017452660712032563,
						-0.03500041278640141,
						0.01758009522675501,
						-0.08354285190039647,
						0.11522307788669693
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.07654698475972685,
						0.1624387445887838,
						-0.04913849288878646,
						0.06046823885719677,
						-0.09846788834471913,
						-0.3038861139564854,
						-0.10722185044128708,
						0.11564923471668274,
						0.24205190500765997,
						-0.26140721340572903,
						-0.3635709133554572,
						-0.41832676022476467,
						0.06603271484863667,
						-0.25440501560779505,
						0.1609336278466761,
						0.10459982357890067,
						-0.3801093692043924,
						0.1918890402353672,
						-0.023148465156958405,
						-0.21118345869633418,
						-0.5110231415729012,
						-0.26548132293043636,
						0.09268049669144734,
						-0.043271128227693016,
						-0.194559259989037,
						0.2323171946164751,
						0.10111730216681049,
						-0.06022296425561705,
						0.07256994239919105,
						-0.4821344506534126
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.12764762004903346,
						-0.28727884674861526,
						-0.16665408416197935,
						-0.0023964989857314595,
						0.11814902465862719,
						0.07394049300342603,
						-0.3266573772578181,
						-0.2099565351686624,
						-0.47089004090260833,
						0.002922925243387756,
						0.013109824816117123,
						0.21785350856817046,
						0.07523070248207331,
						0.09760659689401104,
						-0.23064027973449444,
						-0.2674488635103934,
						-0.23227849069617562,
						-0.0951286576060039,
						-0.008281839313680647,
						0.06547709184702949,
						-0.19807116803343766,
						0.22910118807076113,
						-0.15145724402757046,
						-0.27460313926954244,
						0.24750703860776307,
						-0.2432278019898457,
						-0.014753865937483599,
						-0.29136598018536614,
						-0.015152563773713507,
						-0.0478952506895245
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.006950998823312015,
						-0.43004838144238056,
						-0.039063153740906555,
						0.18774512898169288,
						0.1304557354185544,
						-0.49282372059552143,
						-0.25605169971245784,
						-0.15715988051062305,
						0.07772645586082007,
						-0.05495737680447338,
						-0.4343888521756155,
						0.036421662584591834,
						-0.042669337711717485,
						0.2054277415515317,
						0.11766151276676427,
						0.01722933783735688,
						-0.1765879545502007,
						-0.4476833965970708,
						-0.012662650518016847,
						-0.19917419781198006,
						0.16645613264035097,
						-0.47394861030283225,
						0.07551614376919677,
						0.003171940350344829,
						0.21751119459382112,
						-0.3125915763515542,
						-0.34855869658481586,
						0.1254033682720601,
						0.05963715389930927,
						-0.2807962526958585
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.46570081854840467,
						-0.12717287719371365,
						-0.03315720169756164,
						0.0004021435416216802,
						0.39707897783841223,
						-0.12334212056456074,
						-0.7012283213132505,
						-0.40983766081770684,
						-0.09166278041949899,
						0.27648919141040873,
						0.2761218358184498,
						0.2790771628023565,
						-0.1406071303864922,
						-0.1706708348704877,
						-0.08863411870621671,
						-0.12994952728232673,
						-0.5983783256404911,
						0.15154425960627496,
						-0.2046138548909929,
						-0.23178997187203243,
						0.12417398829178937,
						0.19816954746476087,
						0.14599997739636392,
						-0.17393060497574428,
						0.10882421678717151,
						0.004651251364405551,
						-0.10552988350433029,
						-0.19915099193392347,
						-0.3917859034047768,
						0.07975656355938496
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.3517931099233607,
						-0.29587836786952293,
						-0.29102800107527427,
						-0.2533644358484593,
						-0.02376091330831709,
						0.05279957377812519,
						-0.21697420605513767,
						-0.3359516763658703,
						-0.2389987282599477,
						-0.1457617071769932,
						-0.2057406186921556,
						-0.09356923199151575,
						0.08974510314851743,
						0.004854366204942947,
						-0.2900200296724296,
						-0.14189053735959611,
						-0.1409323632556661,
						-0.014207935472174511,
						-0.15732102855505112,
						0.13273902515282518,
						-0.010338333120899598,
						-0.4259097411529159,
						0.025559528031714587,
						-0.18632296255050984,
						-0.42843024601629043,
						0.060184605267988404,
						-0.22924164811488643,
						0.03802921967743207,
						0.06361851477930958,
						-0.16667190809392493
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.3486964035481639,
						-0.28120777556596743,
						-1.084834780450959,
						0.11482189114243221,
						0.023031218103138767,
						-0.8940003931172418,
						0.011802015686306032,
						0.05890395838251587,
						0.07555274301278096,
						-0.03821774642152599,
						0.17166201234087125,
						-0.5801305074132733,
						0.045170931625457135,
						-0.017576213115655895,
						-0.02781153002543819,
						0.3566249248047052,
						-0.09444000873836426,
						-0.22399127741628283,
						-0.14939294510570925,
						-0.036827954688705256,
						-0.16075012353843057,
						0.16792478968081076,
						-0.10488111006754454,
						-0.14801601441452142,
						-0.16256728609105778,
						-0.22585691158291857,
						-0.1298690630393961,
						-0.2708118985176434,
						-0.1859423558413257,
						-0.01902157274441316
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.10645041096506297,
						0.13061061855411005,
						-0.11849804041093377,
						0.11561631815701655,
						-0.16086207044295728,
						-0.05691783997363503,
						-0.0734262867021477,
						-0.4292742878625127,
						0.08143921096977211,
						-0.23694328776506968,
						-0.7771753257274593,
						-0.34361683923811037,
						-0.49758920888507485,
						0.10258207891200749,
						-0.03147241547920415,
						0.3029577395158727,
						-0.07192735867241212,
						-0.2614482823175883,
						0.023552145362612815,
						-0.0026127279431417518,
						-0.20079175497638174,
						-0.04390590524075687,
						-0.2375540011965908,
						0.05649926553258226,
						0.035946790822455305,
						0.05828756334928973,
						-0.029025922344738858,
						0.012232226042744276,
						-0.1838028735923702,
						-0.23544924332096193
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.033777391358726996,
						-0.19783358536075168,
						-0.07218038996023055,
						-0.6531467685073545,
						-0.22075850120101667,
						0.06144994681371254,
						-0.12063769591646534,
						-0.6986316995259483,
						-0.07034424402728362,
						-0.29652630493379284,
						-0.3439032892960995,
						-0.3940896740781664,
						0.43478754393590235,
						0.03275338195757036,
						-0.28803780840228194,
						-0.10829757553723993,
						0.14410892302070463,
						0.3907580008956399,
						-0.027628540498249938,
						0.10893257073946941,
						-0.41393552968188446,
						-0.3512598728416474,
						0.15229941734660074,
						-0.736081706458837,
						-0.2709686680061643,
						0.14487161370740406,
						-0.31668579696757454,
						-0.4124095743998454,
						0.34620173565095386,
						-0.13665453667558874
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.06923374039993854,
						-0.06862242561307841,
						-0.07981653302324469,
						0.021484128028393227,
						0.03872603197356151,
						-0.0736799767281731,
						-0.013592289436580023,
						-0.02819057850460646,
						0.012179357113976394,
						-0.027007924877089324,
						-0.022373212484430315,
						-0.19758724843536615,
						0.005460826151481732,
						-0.1712229188036901,
						-0.05132559170765974,
						0.08484674429962057,
						0.05153099023478276,
						0.023817041006257044,
						0.01639810031413785,
						-0.016243266309905906,
						-0.02167752861274862,
						-0.06075827557931486,
						0.1976991348352998,
						-0.046131170975034205,
						0.008040214599453959,
						-0.10317473463274081,
						-0.08336944725502965,
						0.1150995505731524,
						0.02535504178540795,
						0.027316007810884536
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.187489131497409,
						0.11973982317506218,
						0.06077446679122648,
						-0.17757629025703162,
						-0.15715163641332724,
						-0.27004073054494543,
						0.049571320535614256,
						-0.1945761046509978,
						-0.1086908297626575,
						0.020997015792511658,
						-0.17625653262125482,
						0.36299520592319506,
						-0.12663068202477454,
						0.08020404648583157,
						0.13987227100565253,
						-0.16036077910512694,
						-0.24784385555266072,
						-0.26593208008133284,
						-0.193708959680597,
						-0.6047907803686494,
						0.0041053654867226055,
						-0.327704165113273,
						0.020655103989808642,
						0.07781274127782307,
						-0.4527147482738975,
						0.0019532679419018498,
						0.019092587089121676,
						0.1681156676556295,
						-0.5110225809400669,
						0.09118425894374492
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.0036016656568767474,
						-0.09309702645898368,
						0.04875784860522912,
						-0.3801449716447238,
						-0.2533031441057512,
						-0.1777077531396031,
						0.02701330946212254,
						-0.37301203931663146,
						-0.25502013426473347,
						-0.012015449173983169,
						0.056711363805237405,
						0.049184925485430915,
						-0.041272384003099245,
						-0.32277917116342497,
						0.08571525754456845,
						0.03167328685932121,
						0.2916159492978622,
						0.06801400743092048,
						0.126719023436773,
						0.1498264536776488,
						-0.4175339002892607,
						-0.4629907609615676,
						-0.3562426792950442,
						-0.06518477929449328,
						-0.23262149920351113,
						-0.3350811305080877,
						-0.015209582444134579,
						-0.34426294217462033,
						-0.2744934838913151,
						-0.18277547999143848
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.042535362746046294,
						0.316252006201022,
						0.13446541294596923,
						-0.6449143283917,
						-0.1226940132809122,
						0.00827388214629193,
						-0.15227951943013338,
						-0.1452639816958171,
						-0.16479604611470444,
						-0.35928103540005496,
						-0.11048192992943073,
						-0.2927288839507066,
						0.2812793412000079,
						-0.029813246549997497,
						-0.06759577816348616,
						0.33008533950428076,
						-0.13587541267027173,
						-0.11853570461152776,
						0.15793860234409246,
						-0.004710855937183974,
						-0.28156659695356595,
						-0.0667761345272004,
						-0.1212517571796937,
						-0.525933325337435,
						-0.2185716474146247,
						0.08366555091622799,
						-0.18246054122682315,
						-0.2750230597000198,
						0.18903504977182073,
						0.024652162958603504
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.2406584479615059,
						-0.18769254521224163,
						0.14981610416097535,
						-0.31166352325708735,
						-0.3259164245296327,
						-0.280571205627774,
						-0.33015317764039315,
						-0.342291591556154,
						0.10454264391373784,
						0.10389926573876807,
						0.010847569251843629,
						0.09043721524917117,
						0.1342398062865078,
						-0.07674373629856678,
						0.13151126827928386,
						0.03454808654710477,
						-0.13116638601494052,
						0.0002622704508054454,
						0.013421623884427924,
						-0.21865101556894648,
						-0.19702488576264465,
						-0.25057859730795956,
						0.1963101436998399,
						-0.17884579486945787,
						0.07734000026633775,
						-0.0250049985786672,
						-0.5180801676461281,
						-0.3948051165853234,
						-0.3524169385342302,
						0.01561884443824879
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.19831403378415152,
						0.2820841781041465,
						-0.26485834949449794,
						0.06923332159729083,
						0.05034993920002521,
						-0.12814860254200391,
						-0.10839773097218687,
						-0.3801439493448187,
						-0.3903411505044753,
						-0.031078667638380183,
						-0.2376938039965757,
						-0.14339460155832626,
						0.11247538369647855,
						0.3405908207538986,
						0.023276716969407214,
						-0.18864501035700804,
						-0.15947058026235303,
						0.05605178961713852,
						0.19783656768527066,
						-0.2343650092389065,
						0.041644850316830725,
						-0.26618106354992094,
						-0.007842739976612669,
						-0.5200900926848083,
						0.2076417538508993,
						-0.0959102262900001,
						-0.04755302469907668,
						-0.10436999027779963,
						0.08651920994279785,
						0.061692636087426825
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.047036230493241994,
						-0.1936182311005447,
						-0.08524504677969588,
						-0.11490239979637595,
						-0.07046862546762281,
						-0.0534785068414518,
						0.015068758104416475,
						0.18119890759041116,
						-0.034442301551118104,
						0.019304337542720772,
						-0.041620520229522374,
						-0.07591681708066339,
						0.015012836809953627,
						-0.16239276309302406,
						0.061060998945409006,
						0.04953087363040418,
						0.0015772441384632597,
						-0.2733543069434165,
						-0.15247461870708506,
						0.07969277898036124,
						-0.1369299380128374,
						0.010274365046346745,
						0.11803919088737189,
						0.0533948272799223,
						0.12928985353979028,
						-0.2673525812769111,
						-0.19940652169425196,
						0.01591271790824302,
						-0.1303941233027635,
						-0.17655580270193966
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.10699380939731905,
						0.10593630613081051,
						-0.6577540902466655,
						-0.3603993084299785,
						0.017037287747660137,
						-0.17928066971916962,
						0.04780081198643053,
						-0.09344862721901123,
						0.24305408071089488,
						0.20611300699144425,
						-0.2653376893474209,
						-0.2988682888762228,
						-0.12129209548503342,
						0.09973766674266799,
						0.20002118808811195,
						-0.18520469156022798,
						0.09837079419143131,
						-0.4728837165656124,
						-0.216743346294068,
						-0.028221331665199443,
						0.04114472907427058,
						0.13167703586577453,
						0.03646536340660751,
						0.06843554122480554,
						-0.043360719585549136,
						-0.2556127501035599,
						-0.2213546849384807,
						-0.18157974589978945,
						-0.0941190877605485,
						0.06985736767789194
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.020177415236149954,
						-0.07780001196752254,
						0.06644722298064099,
						-0.11933723368580772,
						-0.11634838287533517,
						-0.04828986102143525,
						-0.2755557104354199,
						-0.3437910713471118,
						-0.2253521203405746,
						-0.03509929101265148,
						-0.06219318414060292,
						-0.06438114492038656,
						-0.06573951879588473,
						-0.19811031172713217,
						0.18755941749382468,
						-0.026184996731077555,
						0.060886754613049085,
						-0.08098417146544012,
						-0.11925844477080702,
						0.16403957522631765,
						-0.20219508194541835,
						0.09832723142909845,
						0.1754970548549047,
						-0.05880950925585451,
						-0.13033125344874882,
						0.056759881416029015,
						0.0151857672708838,
						0.014608838402576917,
						-0.18188717360873466,
						-0.14504452040260524
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.1793989177639928,
						0.030166681792605468,
						0.09560892961017137,
						-0.07900248570333417,
						0.131658298809439,
						-0.17472285188434855,
						-0.06271442925288502,
						-0.06227781510595112,
						0.07107580608432988,
						0.034162175376743154,
						0.14483288284874632,
						0.0028119901166022364,
						-0.007309153193362568,
						-0.02134211333478994,
						-0.07041622503258516,
						-0.0334317039950233,
						-0.02474936280382402,
						-0.0016736765848784,
						-0.04856612861204443,
						-0.0677425332019503,
						-0.13085083093444216,
						0.08030660792111262,
						0.06679297993102537,
						-0.010496391581336782,
						-0.18478201422191842,
						-0.031501242307821094,
						-0.07823538740883357,
						-0.13669532674650658,
						0.08634516417004569,
						-0.017055434225869897
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.08033868925771001,
						0.055130314797966685,
						-0.15481410575766907,
						-0.014553476025303042,
						0.29028954801389373,
						0.019878221468007506,
						0.02391689550894297,
						-0.2219155397279585,
						0.011677969775302768,
						0.5498275317730269,
						-0.15908683952646333,
						-0.07067623180702809,
						0.006031609621700347,
						-0.03749415233066566,
						0.5395837713701002,
						-0.09105545737376863,
						0.16449876821521603,
						0.0036984571651279066,
						-0.648735628995174,
						0.05142814094470147,
						-0.4398354137612124,
						-0.24875189714281334,
						-0.06036854256617729,
						0.14135294034761958,
						0.5457586208445803,
						-0.43354759572425206,
						0.33431694821585767,
						0.1811597045681345,
						-0.14050917863113271,
						-0.1677671275184728
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						0.32448829272796625,
						0.20668163377913026,
						-0.45553261837474984,
						0.07587304136654195,
						0.12639900333171,
						-0.117199124398591,
						-0.34438297246619204,
						-0.11437672715003241,
						0.31477150767177753,
						0.10204003727403275,
						0.13010331064129144,
						-0.2146846559429157,
						0.16743966259529727,
						-0.4676444834669966,
						-0.14770971602200952,
						-0.061698137950346434,
						-0.1090801476928076,
						0.0820623577450285,
						-0.34204224494945673,
						-0.23620263667909597,
						-0.04192196926288864,
						-0.25860878554855976,
						-0.04606168283493919,
						0.12086219920030053,
						0.5166134911533633,
						-0.2985250491199369,
						-0.3998805026137238,
						-0.3774052757854131,
						-0.24847354701176172,
						-0.11352056529805551
					]
				}
			],
			"biases": {
				"sx": 1,
				"sy": 1,
				"depth": 30,
				"w": [
					-1.209794881550087,
					0.32459978363317793,
					-0.6932376910367425,
					-0.1916475357744203,
					-1.1326452268717615,
					-0.37158729083230924,
					-1.5715448464738841,
					-1.047688165052805,
					-1.048097561307344,
					-0.0034012932382925225,
					-0.923254600176287,
					-0.9622652715200254,
					-0.5762592545739025,
					0.40827947128069353,
					0.8545115126402705,
					-0.5970476527342767,
					-0.43568122073454807,
					-1.2825771974551992,
					0.32968164002625744,
					0.43509515302268514,
					0.28480986335544706,
					0.43174715930877994,
					0.19754330211284382,
					-0.6371660181435743,
					-0.1318542217032975,
					0.5696914747776477,
					-0.9869716241827964,
					0.3514085511321318,
					-0.07438618053389699,
					-0.47910808592894305
				]
			}
		},
		{
			"out_depth": 30,
			"out_sx": 1,
			"out_sy": 1,
			"layer_type": "relu"
		},
		{
			"out_depth": 3,
			"out_sx": 1,
			"out_sy": 1,
			"layer_type": "fc",
			"num_inputs": 30,
			"l1_decay_mul": 0,
			"l2_decay_mul": 1,
			"filters": [
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.22070214162204774,
						-0.02621888036700144,
						-0.24629306944932045,
						0.1905552166982732,
						-0.19428544026228878,
						0.11126615405478484,
						-0.09004118572698433,
						0.21416215631235025,
						0.2364422523028184,
						0.17702788326215083,
						0.2623886305151014,
						-0.4118218962279513,
						0.23082645408693075,
						-0.1836055977283871,
						-0.13756830374477394,
						0.2503592367258356,
						-0.22419692309221728,
						0.13803611841446742,
						0.1333554306235259,
						0.16449928384047868,
						-0.14814167826642907,
						-0.20454590982805604,
						-0.09649131689782862,
						0.19686551087485077,
						-0.04224006934480019,
						0.24302752280575451,
						-0.3318549738567664,
						-0.044955922522950546,
						0.16290571068964457,
						-0.11498449425567783
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.21381231188496533,
						0.12544560320398096,
						-0.17501494201552809,
						0.3304282855415344,
						-0.17817583641627305,
						0.22642695686865935,
						-0.11745010294080771,
						0.14328258430914026,
						0.12745046886767555,
						0.22965563166357778,
						0.21737250520213197,
						-0.39695750882517855,
						0.27863353002452873,
						-0.16490741160299877,
						-0.16614614659748045,
						0.29623643063439714,
						-0.2707806350932217,
						0.1193324089247772,
						-0.1280080874558087,
						0.1438965150022357,
						-0.18813860332850302,
						-0.1703965830526466,
						0.2092998239702075,
						0.3309559359262786,
						-0.029594757298717064,
						0.2514210406703664,
						-0.1927689463014056,
						-0.10869190713027631,
						0.1749569767058473,
						-0.2030006292731626
					]
				},
				{
					"sx": 1,
					"sy": 1,
					"depth": 30,
					"w": [
						-0.1441348079055652,
						0.23402676988485818,
						-0.10222663803635455,
						0.2818199787654295,
						-0.15695896440515625,
						0.22817447335654836,
						-0.11332960272071779,
						0.11704370628660164,
						0.10534965414890496,
						-0.03608126333341204,
						0.14187627331586833,
						-0.392284895900411,
						0.3179887796198501,
						-0.09622757100094881,
						-0.1711229857092612,
						0.2444400766201351,
						-0.13460910672778928,
						0.11216303407269404,
						-0.15431713431838234,
						0.1725955891012702,
						-0.22065954775091404,
						-0.14288404179516428,
						0.046453312755008504,
						0.13697618697171085,
						0.11041202786936449,
						0.18372714329034756,
						-0.1320767046832519,
						0.16329067683546739,
						0.14329013947706754,
						-0.2213045883824327
					]
				}
			],
			"biases": {
				"sx": 1,
				"sy": 1,
				"depth": 3,
				"w": [
					0.47014717849007315,
					0.5013269509476093,
					0.5033858161020248
				]
			}
		},
		{
			"out_depth": 3,
			"out_sx": 1,
			"out_sy": 1,
			"layer_type": "regression",
			"num_inputs": 3
		}
	]
};

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en.original_studios.yaml": [
		77,
		2
	],
	"./en.yaml": [
		78,
		1
	],
	"./language-names.yaml": [
		14
	],
	"./pt.yaml": [
		79,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 76;

/***/ })
],[19]);


// WEBPACK FOOTER //
// static/js/app.d5a36a9bfa089b510a00.js